import { i as isPure, a as inheritIfRequired } from './es.number.constructor-f2ac18e9.js';
import { i as isArray, a as arraySpeciesCreate, f as functionUncurryThisClause, b as functionBindContext } from './es.object.to-string-2822ee1b.js';
import { a as stringMultibyte, c as createProperty, d as deletePropertyOrThrow, b as arrayMethodIsStrict, e as _inherits, f as _createSuper, g as _classCallCheck, h as _defineProperty, i as _assertThisInitialized, j as _createClass, k as _asyncToGenerator, l as correctIsRegexpLogic, n as notARegexp, m as _objectSpread2, o as _slicedToArray, p as _createForOfIteratorHelper, q as objectGetPrototypeOf, r as _typeof, t as iteratorCreateConstructor, u as createIterResultObject, v as arraySort, w as getIteratorMethod, x as getIterator, _ as _toConsumableArray, s as script$g, y as checkCorrectnessOfIteration, z as iteratorDefine, A as _objectWithoutProperties } from './Select-191fbc9e.js';
import { r as regexpGetFlags } from './es.regexp.to-string-763daa55.js';
import { r as regexpExec, a as regexpStickyHelpers, s as script$h } from './Input-355815cc.js';
import { f as functionApply } from './function-apply-7ad2ef07.js';
import { w as wellKnownSymbol, f as fails, a as functionCall, c as createNonEnumerableProperty, b as functionUncurryThis, t as toObject, i as isCallable, d as anObject, e as requireObjectCoercible, g as isObject, h as getMethod, j as getBuiltIn, k as descriptors, l as createCommonjsModule, m as globalThis_1, n as defineBuiltInAccessor, o as internalState, p as createPropertyDescriptor, q as hasOwnProperty_1, s as objectDefineProperty, u as uid, v as hiddenKeys, x as isNullOrUndefined, r as registerComponent } from './index-f674799c.js';
import { d as defineBuiltIn, c as classofRaw, t as toString_1, a as toLength, b as toIntegerOrInfinity, _ as _export, l as lengthOfArrayLike, e as toAbsoluteIndex, i as indexedObject, f as toIndexedObject, o as objectGetOwnPropertySymbols, g as objectPropertyIsEnumerable, h as objectGetOwnPropertyDescriptor, j as classof, k as objectGetOwnPropertyNames, m as isForced_1 } from './to-string-6d234645.js';
import { p as promiseNativeConstructor, s as speciesConstructor, a as promiseResolve, d as doesNotExceedSafeInteger, u as useConverter, b as safeGetBuiltIn, v as validateArgumentsLength, c as anInstance, i as iterate, e as setSpecies } from './runtime-core.esm-bundler-f5bc4aa7.js';
import { ref, readonly, reactive, watch, computed, resolveComponent, openBlock, createElementBlock, createElementVNode, Fragment, renderList, normalizeClass, createVNode, toDisplayString, nextTick, createCommentVNode, pushScopeId, popScopeId, toRef, getCurrentInstance, onMounted, resolveDirective, normalizeStyle, withDirectives, vModelText, withKeys, createTextVNode, onUnmounted, createBlock, renderSlot, withCtx, vShow, toRefs, withModifiers, onBeforeMount, onBeforeUnmount, resolveDynamicComponent } from 'vue';
import { a as arrayMethodHasSpeciesSupport } from './es.array.filter-3afc328b.js';
import './es.string.trim-1d1c26df.js';
import { o as objectGetOwnPropertyNamesExternal, s as script$m } from './SwitchButton-7a923f83.js';
import { o as objectKeys, a as objectCreate } from './object-create-ee21b296.js';
import { set, get } from 'idb-keyval';
import axios from 'axios';
import { setupCache } from 'axios-cache-interceptor';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faQuestionCircle, faLocationDot, faFolderOpen, faFileLines, faList, faCheck, faSearch, faTrashAlt, faVolumeHigh, faArrowsRotate, faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { s as script$f } from './Loading-aa57dc92.js';
import { a as addToUnscopables, s as setToStringTag } from './es.array.find-55b4ab5e.js';
import { Vector, TileImage, Cluster, TileWMS, XYZ } from 'ol/source';
import { Style, Icon, Fill, Stroke, Circle, Text } from 'ol/style';
import LayerSwitcher from 'ol-layerswitcher';
import * as ol_control from 'ol/control';
import { GeoJSON } from 'ol/format';
import * as ol_proj from 'ol/proj';
import { Point } from 'ol/geom';
import { Group, Vector as Vector$1, Tile } from 'ol/layer';
import { Feature, View, Map, Overlay } from 'ol';
import './web.dom-collections.iterator-71bdf1d5.js';
import TabPanel from 'primevue/tabpanel';
import TabView from 'primevue/tabview';
import Dialog from 'primevue/dialog';
import { s as script$i } from './TextArea-f705f377.js';
import { s as script$j } from './Attributes-69e95dc7.js';
import { Form, configure } from 'vee-validate';
import debounce from 'lodash.debounce';
import { s as script$k } from './Checkbox-5cb779a3.js';
import { s as script$l } from './Datetime-1e8eb7b1.js';
import './path-6fd8cb75.js';
import './object-set-prototype-of-1688b6af.js';
import './string-trim-244b288d.js';
import 'vue3-select2-component';
import './useToggler-e9ff86c0.js';
import 'primevue/password';
import 'moment';
import './reactivity.esm-bundler-12dbef55.js';
import 'primevue/inputswitch';
import 'primevue/calendar';

// TODO: Remove from `core-js@4` since it's moved to entry points








var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegExp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) !== 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: functionCall(nativeRegExpMethod, regexp, str, arg2) };
        }
        return { done: true, value: functionCall(nativeMethod, str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};

var charAt$2 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex = function (S, index, unicode) {
  return index + (unicode ? charAt$2(S, index).length : 1);
};

var floor = Math.floor;
var charAt$1 = functionUncurryThis(''.charAt);
var replace$2 = functionUncurryThis(''.replace);
var stringSlice$4 = functionUncurryThis(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$2(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt$1(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$4(str, 0, position);
      case "'": return stringSlice$4(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$4(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt$1(ch, 1) : captures[f - 1] + charAt$1(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var $TypeError$1 = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = functionCall(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classofRaw(R) === 'RegExp') return functionCall(regexpExec, R, S);
  throw new $TypeError$1('RegExp#exec called on incompatible receiver');
};

var REPLACE = wellKnownSymbol('replace');
var max$1 = Math.max;
var min$4 = Math.min;
var concat$1 = functionUncurryThis([].concat);
var push$3 = functionUncurryThis([].push);
var stringIndexOf$1 = functionUncurryThis(''.indexOf);
var stringSlice$3 = functionUncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegexpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = isObject(searchValue) ? getMethod(searchValue, REPLACE) : undefined;
      return replacer
        ? functionCall(replacer, searchValue, O, replaceValue)
        : functionCall(nativeReplace, toString_1(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString_1(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf$1(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf$1(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString_1(replaceValue);

      var flags = toString_1(regexpGetFlags(rx));
      var global = stringIndexOf$1(flags, 'g') !== -1;
      var fullUnicode;
      if (global) {
        fullUnicode = stringIndexOf$1(flags, 'u') !== -1;
        rx.lastIndex = 0;
      }

      var results = [];
      var result;
      while (true) {
        result = regexpExecAbstract(rx, S);
        if (result === null) break;

        push$3(results, result);
        if (!global) break;

        var matchStr = toString_1(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString_1(result[0]);
        var position = max$1(min$4(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        var replacement;
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push$3(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat$1([matched], captures, position, S);
          if (namedCaptures !== undefined) push$3(replacerArgs, namedCaptures);
          replacement = toString_1(functionApply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice$3(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }

      return accumulatedResult + stringSlice$3(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

var NativePromisePrototype = promiseNativeConstructor && promiseNativeConstructor.prototype;

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!promiseNativeConstructor && fails(function () {
  // eslint-disable-next-line unicorn/no-thenable -- required for testing
  NativePromisePrototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
_export({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = isCallable(onFinally);
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (isCallable(promiseNativeConstructor)) {
  var method = getBuiltIn('Promise').prototype['finally'];
  if (NativePromisePrototype['finally'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'finally', method, { unsafe: true });
  }
}

// `Number.MAX_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.max_safe_integer
_export({ target: 'Number', stat: true, nonConfigurable: true, nonWritable: true }, {
  MAX_SAFE_INTEGER: 0x1FFFFFFFFFFFFF
});

var UNSUPPORTED_Y = regexpStickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min$3 = Math.min;
var push$2 = functionUncurryThis([].push);
var stringSlice$2 = functionUncurryThis(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

var BUGGY = 'abbc'.split(/(b)*/)[1] === 'c' ||
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  'test'.split(/(?:)/, -1).length !== 4 ||
  'ab'.split(/(?:ab)*/).length !== 2 ||
  '.'.split(/(.?)(.?)/).length !== 4 ||
  // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
  '.'.split(/()()/).length > 1 ||
  ''.split(/.?/).length;

// @@split logic
fixRegexpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit = '0'.split(undefined, 0).length ? function (separator, limit) {
    return separator === undefined && limit === 0 ? [] : functionCall(nativeSplit, this, separator, limit);
  } : nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = isObject(separator) ? getMethod(separator, SPLIT) : undefined;
      return splitter
        ? functionCall(splitter, separator, O, limit)
        : functionCall(internalSplit, toString_1(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString_1(string);

      if (!BUGGY) {
        var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
        if (res.done) return res.value;
      }

      var C = speciesConstructor(rx, RegExp);
      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');
      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return regexpExecAbstract(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = regexpExecAbstract(splitter, UNSUPPORTED_Y ? stringSlice$2(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min$3(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push$2(A, stringSlice$2(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push$2(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push$2(A, stringSlice$2(S, p));
      return A;
    }
  ];
}, BUGGY || !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = descriptors && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

var arraySetLength = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor$2(O, 'length').writable) {
    throw new $TypeError('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var max = Math.max;
var min$2 = Math.min;

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min$2(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
    }
    doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) deletePropertyOrThrow(O, k - 1);
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    arraySetLength(O, len - actualDeleteCount + insertCount);
    return A;
  }
});

var quot = /"/g;
var replace$1 = functionUncurryThis(''.replace);

// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
var createHtml = function (string, tag, attribute, value) {
  var S = toString_1(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + replace$1(toString_1(value), quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
var stringHtmlForced = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};

// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
_export({ target: 'String', proto: true, forced: stringHtmlForced('link') }, {
  link: function link(url) {
    return createHtml(this, 'a', 'href', url);
  }
});

var stringIndexOf = functionUncurryThis(''.indexOf);

// @@match logic
fixRegexpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = isObject(regexp) ? getMethod(regexp, MATCH) : undefined;
      return matcher ? functionCall(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString_1(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString_1(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      var flags = toString_1(regexpGetFlags(rx));

      if (stringIndexOf(flags, 'g') === -1) return regexpExecAbstract(rx, S);

      var fullUnicode = stringIndexOf(flags, 'u') !== -1;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regexpExecAbstract(rx, S)) !== null) {
        var matchStr = toString_1(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

var nativeJoin = functionUncurryThis([].join);

var ES3_STRINGS = indexedObject !== Object;
var FORCED = ES3_STRINGS || !arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
_export({ target: 'Array', proto: true, forced: FORCED }, {
  join: function join(separator) {
    return nativeJoin(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});

createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; };
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) });

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: true });
  defineProperty(
    GeneratorFunctionPrototype,
    "constructor",
    { value: GeneratorFunction, configurable: true }
  );
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    defineProperty(this, "_invoke", { value: enqueue });
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per GeneratorResume behavior specified since ES2015:
        // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
        // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method;
    var method = delegate.iterator[methodName];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method, or a missing .next method, always terminate the
      // yield* loop.
      context.delegate = null;

      // Note: ["return"] must be used for ES3 parsing compatibility.
      if (methodName === "throw" && delegate.iterator["return"]) {
        // If the delegate iterator has a return method, give it a
        // chance to clean up.
        context.method = "return";
        context.arg = undefined$1;
        maybeInvokeDelegate(delegate, context);

        if (context.method === "throw") {
          // If maybeInvokeDelegate(context) changed context.method from
          // "return" to "throw", let that override the TypeError below.
          return ContinueSentinel;
        }
      }
      if (methodName !== "return") {
        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a '" + methodName + "' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(val) {
    var object = Object(val);
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable != null) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    throw new TypeError(typeof iterable + " is not iterable");
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
});

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = functionUncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (descriptors && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  // eslint-disable-next-line es/no-array-prototype-foreach -- safe
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  var propertyIsEnumerable = objectPropertyIsEnumerable.f;
  while (argumentsLength > index) {
    var S = indexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!descriptors || functionCall(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
_export({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== objectAssign }, {
  assign: objectAssign
});

var Store = /*#__PURE__*/function () {
  function Store(storeName) {
    _classCallCheck(this, Store);

    this.storeName = storeName;
    var data = this.data();
    this.state = reactive(data);
  }

  _createClass(Store, [{
    key: "getState",
    value: function getState() {
      return readonly(this.state);
    }
  }]);

  return Store;
}();
var PersistentStore = /*#__PURE__*/function (_Store) {
  _inherits(PersistentStore, _Store);

  var _super = _createSuper(PersistentStore);

  function PersistentStore(storeName) {
    var _this;

    _classCallCheck(this, PersistentStore);

    _this = _super.call(this, storeName);

    _defineProperty(_assertThisInitialized(_this), "isInitialized", ref(false));

    _this.storeName = storeName;
    return _this;
  }

  _createClass(PersistentStore, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var stateFromIndexedDB;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.isInitialized) {
                  _context.next = 10;
                  break;
                }

                _context.next = 3;
                return get(this.storeName);

              case 3:
                _context.t0 = _context.sent;

                if (_context.t0) {
                  _context.next = 6;
                  break;
                }

                _context.t0 = '';

              case 6:
                stateFromIndexedDB = _context.t0;

                if (stateFromIndexedDB) {
                  Object.assign(this.state, JSON.parse(stateFromIndexedDB));
                }

                watch(function () {
                  return _this2.state;
                }, function (val) {
                  return set(_this2.storeName, JSON.stringify(val));
                }, {
                  deep: true
                });
                this.isInitialized.value = true;

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "getIsInitialized",
    value: function getIsInitialized() {
      return this.isInitialized;
    }
  }]);

  return PersistentStore;
}(Store); // https://medium.com/@mario.brendel1990/vue-3-the-new-store-a7569d4a546f
// https://github.com/Mario-Brendel/Vue3-Tests/tree/store/src/store

var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;







var slice = functionUncurryThisClause(''.slice);
var min$1 = Math.min;

var CORRECT_IS_REGEXP_LOGIC$1 = correctIsRegexpLogic('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG$1 = !CORRECT_IS_REGEXP_LOGIC$1 && !!function () {
  var descriptor = getOwnPropertyDescriptor$1(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
_export({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG$1 && !CORRECT_IS_REGEXP_LOGIC$1 }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = toString_1(requireObjectCoercible(this));
    notARegexp(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = that.length;
    var end = endPosition === undefined ? len : min$1(toLength(endPosition), len);
    var search = toString_1(searchString);
    return slice(that, end - search.length, end) === search;
  }
});

var domainRepository = {
  searchAddress: function searchAddress(searchText) {
    return new Promise(function (resolve, reject) {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + '/search_address',
        params: {
          q: searchText,
          lang: "de"
        }
      }).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getRegistrationConfig: function getRegistrationConfig() {
    return new Promise(function (resolve, reject) {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + '/register_config'
      }).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  postRegister: function postRegister(regData) {
    return new Promise(function (resolve, reject) {
      axiosWdw({
        method: 'POST',
        url: domainEndpoint() + '/register',
        data: regData
      }).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getDomainConfig: function getDomainConfig() {
    return new Promise(function (resolve, reject) {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint(),
        params: {
          fieldset: 'config'
        }
      }).then(function (response) {
        if (response && response.data.success) {
          resolve(response.data.data);
        } else {
          reject(response);
        }
      }).catch(function (error) {
        console.log(error);
        reject(error);
      });
    });
  },
  getDiscussConfig: function getDiscussConfig() {
    return new Promise(function (resolve, reject) {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + '/discuss'
      }).then(function (response) {
        if (response && response.data.success) {
          resolve(response.data.data);
        } else {
          reject(response);
        }
      }).catch(function (error) {
        console.log(error);
        reject(error);
      });
    });
  },
  getBmsDomainConfig: function getBmsDomainConfig() {
    return new Promise(function (resolve, reject) {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + '/bms',
        params: {
          fieldset: 'config'
        }
      }).then(function (response) {
        if (response && response.data.success) {
          resolve(response.data.data);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getBmsStatusList: function getBmsStatusList() {
    return new Promise(function (resolve, reject) {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + '/bms/status_list'
      }).then(function (response) {
        resolve(response.data.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getStreets: function getStreets(domainid, query) {
    return new Promise(function (resolve, reject) {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + '/get_streets?domainid=' + domainid + "&q=" + (query || "")
      }).then(function (response) {
        resolve(response.data.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getBmsAppDomainByQueryParams: function getBmsAppDomainByQueryParams(bmsAppId, params) {
    return new Promise(function (resolve, reject) {
      axiosWdw({
        method: 'GET',
        url: 'bmsapp/' + bmsAppId + '/domain',
        params: params
      }).then(function (response) {
        if (response && response.data.success) {
          resolve(response.data.data);
        } else {
          reject(response);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getBmsSearchAttributes: function getBmsSearchAttributes() {
    return new Promise(function (resolve, reject) {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + '/bms/search_attributes'
      }).then(function (response) {
        resolve(response.data.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  updateMessageState: function updateMessageState(params) {
    var formdata = new FormData();
    formdata.append('data', JSON.stringify(params.body));

    if (params.file) {
      formdata.append('picture', params.file);
    }

    return new Promise(function (resolve, reject) {
      axiosWdw({
        method: 'POST',
        url: domainEndpoint() + '/update',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formdata
      }).then(function (response) {
        if (response && response.data.success) {
          resolve(response.data.data);
        }
      }).catch(function (error) {
        console.log(error);
        reject(error);
      });
    });
  },
  postRefetchCaptcha: function postRefetchCaptcha() {
    return new Promise(function (resolve, reject) {
      axiosWdw({
        method: 'POST',
        url: domainEndpoint() + '/refetch_captcha'
      }).then(function (response) {
        if (response && response.data.success) {
          resolve(response.data.data);
        } else {
          reject(response);
        }
      }).catch(function (error) {
        console.log(error);
        reject(error);
      });
    });
  }
};

var DomainStore = /*#__PURE__*/function (_PersistentStore) {
  _inherits(DomainStore, _PersistentStore);

  var _super = _createSuper(DomainStore);

  function DomainStore() {
    _classCallCheck(this, DomainStore);

    return _super.apply(this, arguments);
  }

  _createClass(DomainStore, [{
    key: "data",
    value: function data() {
      return {
        domainid: null,
        domain: null,
        discuss: null,
        language: 'de',
        project_thought_term: ''
      };
    }
  }, {
    key: "setDiscuss",
    value: function setDiscuss(discuss) {
      this.state.discuss = discuss;
    }
  }, {
    key: "unsetDiscuss",
    value: function unsetDiscuss() {
      this.state.discuss = null;
    }
  }, {
    key: "setDomain",
    value: function setDomain(domain) {
      this.state.domain = domain;
    }
  }, {
    key: "unsetDomain",
    value: function unsetDomain() {
      this.state.domain = null;
    }
  }, {
    key: "updateLanguage",
    value: function updateLanguage(project_thought_term) {
      var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      if (lang) {
        this.state.language = lang;
      }

      this.state.project_thought_term = project_thought_term;

      if (this.state.project_thought_term) ;
    }
  }, {
    key: "translate",
    value: function translate(value) {
      // without explicitly resetting locale here, translations won't persist when hiding/reloading content
      if (this.state.project_thought_term) ; // return i18n.global.t(value);


      return value;
    }
  }, {
    key: "setDomainId",
    value: function setDomainId(domainid) {
      this.state.domainid = domainid;
      this.fetchDomainConfig(); // this.fetchDiscussConfig();
    }
  }, {
    key: "fetchDiscussConfig",
    value: function fetchDiscussConfig() {
      var _this = this;

      // if discuss config was already fetched, simply return
      if (this.state.discuss !== null && this.state.discuss.id == this.state.domainid) {
        return;
      } // if domainid got set, but discuss config is not yet fetched, fetch it


      if (this.state.domainid) {
        domainRepository.getDiscussConfig().then(function (response) {
          if (response) {
            _this.setDiscuss(response);
          } else {
            console.log('error');
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        // if we domainid is not set, unset Discuss data in store
        this.unsetDiscuss();
      }
    }
  }, {
    key: "fetchDomainConfig",
    value: function fetchDomainConfig() {
      var _this2 = this;

      // if domain was already fetched, simply return
      if (this.state.domain !== null && this.state.domain.id == this.state.domainid) {
        return this.state.domain;
      } // if domainid got set, but domain config is not yet fetched, fetch it


      if (this.state.domainid) {
        domainRepository.getDomainConfig().then(function (response) {
          if (response) {
            _this2.setDomain(response);
          } else {
            console.log('error');
          }
        }).catch(function (error) {
          console.error(error);
        });
      } else {
        // if we domainid is not set, unset Domain data in store
        this.unsetDomain();
      }

      return null;
    }
  }]);

  return DomainStore;
}(PersistentStore);

var domainStore = new DomainStore('DOMAIN_STORE');

/**
 * TODO Base Url on every axiosWdw instance should be overridden by the interceptor with base url from store
 * the following variable baseUrl should be removed after it is implemented
*/
// const baseUrl = "http://32-wdw.l.wdwtest.de:3000"

var axiosBasic = axios.create({
  headers: {
    Accept: 'application/json'
  }
});
var axiosWdwDomain = axios.create({
  baseURL: "/",
  withCredentials: true,
  headers: {
    Accept: 'application/json'
  }
});
var axiosWdw = axios.create({
  baseURL: '/api/v1/',
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'content-type': 'application/json'
  }
});
var axiosWdwCached = setupCache(axios.create({
  baseURL: '/api/v1/',
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'content-type': 'application/json'
  }
}), {
  headerInterpreter: function headerInterpreter(headers) {
    // Required so that we can ignore the "no-cache" policy from server
    return {
      cache: 60,
      stale: 60
    }; // 60 seconds TTL
  }
});

var domainEndpoint = function domainEndpoint() {
  // Get the domainid from DomainStore
  var domainid = domainStore.getState().domainid;

  if (domainid) {
    return 'domain/' + domainid;
  } else {
    console.error('domainid not initiated');
    return "";
  }
};

var removeLastSlash = function removeLastSlash(url) {
  if (url == "" || url == "/") return "";

  if (url.endsWith("/")) {
    return url.substring(0, url.length - 1);
  }

  return url;
};

axiosWdw.interceptors.request.use(function (request) {
  // Interceptor to add Bearer token if we have it set in userStore
  var authToken = wizardStore.getState().userAuthToken;
  var apiBaseUrl = wizardStore.getState().apiBaseUrl; // request.baseUrl on every axiosWdw instance should be overridden by the interceptor with base url from store

  request.baseURL = removeLastSlash(apiBaseUrl) + "" + request.baseURL; // console.log(authToken);

  if (authToken) {
    // console.log("setting auth-token header to request");
    request.headers['Authorization'] = 'Bearer ' + authToken;
  }

  if (typeof wdwWidgetsLang !== 'undefined' && wdwWidgetsLang) {
    request.params = _objectSpread2({
      // add default query-params (send with every request)
      lang: wdwWidgetsLang
    }, request.params);
  } // console.log('Starting Request', JSON.stringify(request, null, 2))


  return request;
});
axiosWdwCached.interceptors.request.use(function (request) {
  // Interceptor to add Bearer token if we have it set in userStore
  var authToken = wizardStore.getState().userAuthToken;
  var apiBaseUrl = wizardStore.getState().apiBaseUrl; // request.baseUrl on every axiosWdw instance should be overridden by the interceptor with base url from store

  request.baseURL = removeLastSlash(apiBaseUrl) + "" + request.baseURL;

  if (authToken) {
    // console.log("setting auth-token header to request");
    request.headers['Authorization'] = 'Bearer ' + authToken;
  } // console.log(request.headers);
  // console.log('Starting Request', JSON.stringify(request, null, 2))


  return request;
});
axiosWdwDomain.interceptors.request.use(function (request) {
  // Interceptor to add Bearer token if we have it set in userStore
  var authToken = wizardStore.getState().userAuthToken;
  var apiBaseUrl = wizardStore.getState().apiBaseUrl; // request.baseUrl on every axiosWdw instance should be overridden by the interceptor with base url from store

  request.baseURL = removeLastSlash(apiBaseUrl) + "" + request.baseURL; // console.log(authToken);

  if (authToken) {
    // console.log("setting auth-token header to request");
    request.headers['Authorization'] = 'Bearer ' + authToken;
  } // console.log('Starting Request', JSON.stringify(request, null, 2))


  return request;
});

var wizardRepository = {
  getConfig: function getConfig() {
    return new Promise(function (resolve, reject) {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + "/bms/wizard_config"
      }).then(function (response) {
        resolve(response.data.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  checkPosition: function checkPosition(params) {
    return new Promise(function (resolve, reject) {
      axiosWdw({
        method: 'GET',
        url: "bmsapp/1/domain",
        params: params
      }).then(function (response) {
        resolve(response.data.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  createMessage: function createMessage(payload) {
    return new Promise(function (resolve, reject) {
      axiosWdw({
        method: 'post',
        url: domainEndpoint() + '/message',
        data: payload
      }).then(function (response) {
        resolve(response.data.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

var endpoint = '/category';
var categoryRepository = {
  getCategoriesByKeyword: function getCategoriesByKeyword(keyword, extra) {
    return new Promise(function (resolve, reject) {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + endpoint + "/keyword_search",
        params: _objectSpread2({
          q: keyword
        }, extra)
      }).then(function (response) {
        resolve(response.data.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getCategoriesByQueryParams: function getCategoriesByQueryParams(params) {
    return new Promise(function (resolve, reject) {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + endpoint,
        params: params
      }).then(function (response) {
        resolve(response.data.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getCategoryById: function getCategoryById(categoryid) {
    return new Promise(function (resolve, reject) {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + endpoint + "/".concat(categoryid)
      }).then(function (response) {
        resolve(response.data.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

var captchaRepository = {
  validateCaptcha: function validateCaptcha(captchaId, userInput) {
    return new Promise(function (resolve, reject) {
      axiosWdw({
        method: 'POST',
        url: domainEndpoint() + '/verify_captcha',
        data: {
          id: captchaId,
          answer: userInput
        }
      }).then(function (res) {
        resolve(res.data.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  refetchCapcha: function refetchCapcha() {
    return new Promise(function (resolve, reject) {
      axiosWdw({
        method: 'POST',
        url: domainEndpoint() + '/refetch_captcha'
      }).then(function (res) {
        resolve(res.data.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  }
};

var filtertypeid = [];

var UserStore = /*#__PURE__*/function (_PersistentStore) {
  _inherits(UserStore, _PersistentStore);

  var _super = _createSuper(UserStore);

  function UserStore() {
    _classCallCheck(this, UserStore);

    return _super.apply(this, arguments);
  }

  _createClass(UserStore, [{
    key: "data",
    value: function data() {
      return {
        currentStep: 1,
        loading: false,
        categorys: [],
        overAndUnderCategory: false,
        currentStepdata: undefined,
        category: undefined,
        userEntrys: {},
        categorySeparator: '>',
        submitting: false,
        user: undefined,
        userAuthToken: undefined,
        apiBaseUrl: "/",
        termsAccepted: false,
        privacyAccepted: false
      };
    }
  }, {
    key: "setPrivacyAccepted",
    value: function setPrivacyAccepted(accepted) {
      this.state.privacyAccepted = accepted;
    }
  }, {
    key: "setTermsAccepted",
    value: function setTermsAccepted(accepted) {
      this.state.termsAccepted = accepted;
    }
  }, {
    key: "setLoggedInUser",
    value: function setLoggedInUser(user) {
      this.state.user = user;
    }
  }, {
    key: "setUserAuthToken",
    value: function setUserAuthToken(token) {
      this.state.userAuthToken = token;
    }
  }, {
    key: "setApiBaseUrl",
    value: function setApiBaseUrl(url) {
      this.state.apiBaseUrl = url;
    }
  }, {
    key: "isUserLoggedIn",
    value: function isUserLoggedIn() {
      return this.state.user && this.state.userAuthToken;
    }
  }, {
    key: "isUserAnAdmin",
    value: function isUserAnAdmin() {
      return this.state.user && this.state.user.type == "admin";
    }
  }, {
    key: "setSubmitting",
    value: function setSubmitting(value) {
      this.state.submitting = value;
      this.state.loading = value;
    }
  }, {
    key: "getWizardConfig",
    value: function getWizardConfig() {
      var _this = this;

      return new Promise(function (res, rej) {
        _this.state.loading = true;
        wizardRepository.getConfig().then(function (response) {
          // initial params will be handled by BmsWizard props, if any
          _this.state.config = response.wizard;

          _this.updateCurrentStepdata();

          res();
        }).catch(function () {
          rej();
        }).finally(function () {
          _this.state.loading = false;
        });
      });
    }
  }, {
    key: "getCategorys",
    value: function getCategorys() {
      var _this$state$currentSt,
          _filteredFields,
          _this2 = this,
          _this$state$config;

      this.state.categorys = [];
      this.state.overAndUnderCategory = false; // Filter by filtertypeid if any

      var filteredFields = JSON.parse(JSON.stringify((_this$state$currentSt = this.state.currentStepdata) === null || _this$state$currentSt === void 0 ? void 0 : _this$state$currentSt.fields));

      if (filtertypeid.length > 0) {
        filteredFields = filteredFields.filter(function (cat) {
          return filtertypeid.includes(cat.id);
        });
      }

      (_filteredFields = filteredFields) === null || _filteredFields === void 0 ? void 0 : _filteredFields.forEach(function (category) {
        var group = {
          title: category.name,
          ordering: Number.MAX_SAFE_INTEGER,
          // Smallest ordering from category
          items: []
        };

        if (category.name.includes(_this2.state.categorySeparator)) {
          _this2.state.overAndUnderCategory = true;

          var _category$name$split = category.name.split(_this2.state.categorySeparator),
              _category$name$split2 = _slicedToArray(_category$name$split, 2),
              groupTitle = _category$name$split2[0],
              itemTitle = _category$name$split2[1];

          groupTitle = groupTitle.trim();
          itemTitle = itemTitle.trim();
          group.title = groupTitle;
          category.name = itemTitle;
          group.items.push(category);
        } else {
          group.items.push(category);
        }

        var exists = false,
            existsIndex = undefined;

        for (var i = 0; i < _this2.state.categorys.length; i++) {
          if (_this2.state.categorys[i].title == group.title) {
            exists = true;
            existsIndex = i;
            break;
          }
        }

        if (exists && existsIndex !== undefined) {
          var existing = _this2.state.categorys.splice(existsIndex, 1)[0];

          existing.items.push(category);

          if (existing.ordering > category.ordering) {
            existing.ordering = category.ordering;
          }

          _this2.state.categorys.push(existing);
        } else {
          if (group.ordering > category.ordering) {
            group.ordering = category.ordering;
          }

          _this2.state.categorys.push(group);
        }
      }); //sort the items in each group based on the ORDERING number and the NAME

      for (var i = 0; i < this.state.categorys.length; i++) {
        this.state.categorys[i].items.sort(function (a, b) {
          return a.ordering === b.ordering ? a.name.localeCompare(b.name) : a.ordering - b.ordering;
        }); //sort the categorys in each group based on the ORDERING number and the NAME
      }

      this.state.categorys.sort(function (a, b) {
        return a.ordering === b.ordering ? a.title.localeCompare(b.title) : a.ordering - b.ordering;
      }); //Sort if rubric is enabled, CAtegories with rubrics come first

      if ((_this$state$config = this.state.config) !== null && _this$state$config !== void 0 && _this$state$config.BmsEnableRubrics) {
        this.state.categorys.sort(function (_, b) {
          // const aRubrics = a.items.some((obj: any) => obj.rubric);
          var bRubrics = b.items.some(function (obj) {
            return obj.rubric;
          }); // use -1 to indicate that 'b' should come before 'a' if 'b' has rubrics, and 1 otherwise.

          return bRubrics ? 1 : -1;
        });
      }
    }
  }, {
    key: "getCategory",
    value: function getCategory(categoryid) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        _this3.state.loading = true;
        categoryRepository.getCategoryById(categoryid).then(function (response) {
          _this3.state.category = response;
          _this3.state.userEntrys.typeid = response.id;
          resolve();
        }).catch(function () {
          return reject();
        }).finally(function () {
          _this3.state.loading = false;
        });
      });
    }
  }, {
    key: "setAddressSearch",
    value: function setAddressSearch(data) {
      this.state.userEntrys.addressSearch = data;
      this.state.userEntrys.lat = data.lat;
      this.state.userEntrys.lon = data.lon;
    }
  }, {
    key: "setAddressSearchText",
    value: function setAddressSearchText(text) {
      if (this.state.userEntrys.addressSearch) {
        this.state.userEntrys.addressSearch.queryAddress = text;
      }
    }
  }, {
    key: "nextStep",
    value: function nextStep() {
      window.scroll({
        top: 0,
        behavior: 'smooth' // This provides a smooth scroll effect, use 'auto' for instant scroll

      });
      this.state.currentStep += 1;
      this.updateCurrentStepdata();
    }
  }, {
    key: "removePositon",
    value: function removePositon() {
      this.state.userEntrys.addressSearch = undefined;
      this.state.userEntrys.lat = undefined;
      this.state.userEntrys.lon = undefined;
    }
  }, {
    key: "previousStep",
    value: function previousStep() {
      this.state.currentStep -= 1;
      this.updateCurrentStepdata();
    }
  }, {
    key: "setFields",
    value: function setFields(description, attribute_values, title, link_title, link) {
      this.state.userEntrys.description = description;
      this.state.userEntrys.title = title;
      this.state.userEntrys.link_title = link_title;
      this.state.userEntrys.link = link;
      this.state.userEntrys.attribute_values = attribute_values;
    }
  }, {
    key: "setDescription",
    value: function setDescription(desc) {
      this.state.userEntrys.description = desc;
    }
  }, {
    key: "setLatLon",
    value: function setLatLon(position) {
      this.state.userEntrys.lat = position.lat;
      this.state.userEntrys.lon = position.lon;
    }
  }, {
    key: "updateInitialLatLon",
    value: function updateInitialLatLon() {
      this.state.initial_lat = this.state.userEntrys.lat;
      this.state.initial_lon = this.state.userEntrys.lon;
    }
  }, {
    key: "setFiles",
    value: function setFiles(files) {
      files.forEach(function (file) {
        if (file.filename.match(/\.(jpg|jpeg|png|gif|svg)$/i)) {
          file.hasImage = true;
        }
      });
      this.state.userEntrys.expected_files = files;
    }
  }, {
    key: "isPositionSet",
    value: function isPositionSet() {
      return this.state.userEntrys.lat && this.state.userEntrys.lon;
    }
  }, {
    key: "getUserPosition",
    value: function getUserPosition() {
      return {
        lat: this.state.userEntrys.lat,
        lon: this.state.userEntrys.lon
      };
    }
  }, {
    key: "reFetchCaptcha",
    value: function reFetchCaptcha() {
      var _this4 = this;

      captchaRepository.refetchCapcha().then(function (res) {
        if (_this4.state.config && _this4.state.config.captcha) {
          _this4.state.config.captcha.audio = res.captcha_audio_url;
          _this4.state.config.captcha.id = res.captcha_id;
          _this4.state.config.captcha.image = res.captcha_image_url;
        } else {
          throw new Error('This is not supposed to happen - Wizard');
        }
      });
    }
  }, {
    key: "setBundleToken",
    value: function setBundleToken(bundleId) {
      this.state.userEntrys.bundle_token = bundleId;
    }
  }, {
    key: "setLoading",
    value: function setLoading(value) {
      this.state.loading = value;
    }
  }, {
    key: "resetMessageWizard",
    value: function resetMessageWizard() {
      this.state.currentStep = 1;
      this.state.loading = false;
      this.state.categorys = [];
      this.state.overAndUnderCategory = false;
      this.state.currentStepdata = undefined;
      this.state.category = undefined;
      this.state.userEntrys = {};
      this.state.categorySeparator = '>';
      this.state.submitting = false;
    }
  }, {
    key: "uploadMessage",
    value: function uploadMessage(payload) {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        _this5.state.loading = true;
        wizardRepository.createMessage(payload).then(function (response) {
          _this5.resetMessageWizard();

          resolve(response);
        }).catch(function (error) {
          reject(error);
        }).finally(function () {
          _this5.state.loading = false;
        });
      });
    }
  }, {
    key: "getMapImageUrl",
    value: function getMapImageUrl() {
      if (!this.state.userEntrys.lat || !this.state.userEntrys.lon) return undefined;
      var baseUrl = 'https://staticmap.werdenktwas.de/staticmap/';
      var params = {
        center: "".concat(this.state.userEntrys.lat, ",").concat(this.state.userEntrys.lon),
        zoom: 17,
        size: '900x300',
        markers: "".concat(this.state.userEntrys.lat, ",").concat(this.state.userEntrys.lon, ",marker-white-ci-new"),
        maptype: 'wdw-tiles-osm-liberty'
      };
      var paramsString = Object.keys(params).map(function (key) {
        return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]));
      }).join('&');
      var url = "".concat(baseUrl, "?").concat(paramsString);
      return url;
    }
  }, {
    key: "setInitialParams",
    value: function setInitialParams(param) {
      this.state.selectedtypeid = param.selectedTypeId;
      this.state.initial_lat = param.initialLat;
      this.state.initial_lon = param.initialLon;
      this.state.selected_rubric = param.selectedRubric;
      filtertypeid = param.filterTypeIds || [];

      if (this.state.selectedtypeid) {
        this.getCategory(this.state.selectedtypeid);
      }
    }
  }, {
    key: "updateCurrentStepdata",
    value: function updateCurrentStepdata() {
      var _this$state$config2,
          _this6 = this;

      this.state.currentStepdata = Object.keys((_this$state$config2 = this.state.config) === null || _this$state$config2 === void 0 ? void 0 : _this$state$config2.stepdata).sort().map(function (key) {
        var _this6$state$config;

        return (_this6$state$config = _this6.state.config) === null || _this6$state$config === void 0 ? void 0 : _this6$state$config.stepdata[key];
      })[this.state.currentStep - 1];
    }
  }]);

  return UserStore;
}(PersistentStore);

var wizardStore = new UserStore('WIZARD_STORE');

library.add(faQuestionCircle, faLocationDot, faFolderOpen, faFileLines, faList, faQuestionCircle, faCheck);
var script$e = {
  name: "WizardProgress",
  setup: function setup() {
    var currentstep = computed(function () {
      return wizardStore.getState().currentStep;
    });
    var steps = computed(function () {
      var _wizardStore$getState;

      return (_wizardStore$getState = wizardStore.getState().config) === null || _wizardStore$getState === void 0 ? void 0 : _wizardStore$getState.steps;
    });

    function isActiveStep(index) {
      return currentstep.value === index + 1;
    }

    function isCompleteStep(index) {
      return currentstep.value > index + 1;
    }

    function translateStepIcon(code) {
      switch (code) {
        case 'position':
          return 'location-dot';

        case 'category':
          return 'folder-open';

        case 'attributes':
          return 'file-lines';

        case 'summary':
          return 'list';

        default:
          return 'question-circle';
      }
    }

    return {
      steps: steps,
      isActiveStep: isActiveStep,
      isCompleteStep: isCompleteStep,
      translateStepIcon: translateStepIcon
    };
  }
};

var _hoisted_1$e = {
  id: "wizard-progress"
};
var _hoisted_2$e = {
  class: "step-indicator"
};
var _hoisted_3$e = ["id"];
var _hoisted_4$b = {
  class: "step"
};
var _hoisted_5$b = {
  class: "caption d-none d-md-block"
};
function render$e(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  return openBlock(), createElementBlock("div", _hoisted_1$e, [createElementVNode("ol", _hoisted_2$e, [(openBlock(true), createElementBlock(Fragment, null, renderList($setup.steps, function (step, index) {
    return openBlock(), createElementBlock("li", {
      class: normalizeClass({
        active: $setup.isActiveStep(index),
        complete: $setup.isCompleteStep(index)
      }),
      id: "wizard-step-".concat(index + 1),
      key: index
    }, [createElementVNode("div", _hoisted_4$b, [createVNode(_component_font_awesome_icon, {
      icon: $setup.translateStepIcon(step.code),
      class: "active-icon"
    }, null, 8, ["icon"]), createVNode(_component_font_awesome_icon, {
      icon: "check",
      class: "complete-icon"
    })]), createElementVNode("div", _hoisted_5$b, "Schritt " + toDisplayString(index + 1) + ": " + toDisplayString(step.label), 1)], 10, _hoisted_3$e);
  }), 128))])]);
}

script$e.render = render$e;
script$e.__scopeId = "data-v-026d6084";

var duplicateRepository = {
  fetchDuplicates: function fetchDuplicates(params) {
    return new Promise(function (resolve, reject) {
      axiosWdw({
        method: 'post',
        url: domainEndpoint() + '/bms/duplicates',
        data: params
      }).then(function (res) {
        resolve(res.data.data.duplicates);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};

/**
 *  Put all accessibility-related methods here. 
*/
var observer = null;
function useWizardAccessibility () {
  function focusStartOfStep() {
    var wizHintElem = document.getElementById("wdw-bms-wizard-hint-text");

    if (wizHintElem) {
      wizHintElem.scrollIntoView();
      wizHintElem.focus();
    }
  }

  function focusNextButton() {
    var wizNextBtn = document.getElementById("bms-wizard-btn-next");

    if (wizNextBtn) {
      wizNextBtn.scrollIntoView();
      wizNextBtn.focus();
    }
  }

  function focusOnSelect2InputField() {
    var searchField = document.querySelector('.select2-search__field');

    if (searchField) {
      searchField.focus();
    }
  }
  /**
   * Since we cannot directly access Select2 component with jQuery, we have to listen for DOM changes
   * This observer will notify us when a child DOM element is added. 
   * After that we just check if "select2-search__field" exists in DOM tree and focus on it 
   */


  function observeSelect2SearchField() {
    observer = new MutationObserver(function (list, obs) {
      var _iterator = _createForOfIteratorHelper(list),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mutation = _step.value;

          if (mutation.type === "childList") {
            var addedNode = mutation.addedNodes.item(0);

            if (addedNode && addedNode.classList && addedNode.classList.contains("select2-container--open")) {
              // try focusing of any search field
              focusOnSelect2InputField();
              break;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    observer.observe(document, {
      childList: true,
      subtree: true
    });
  }

  function destroySelect2Observer() {
    var _observer;

    (_observer = observer) === null || _observer === void 0 ? void 0 : _observer.disconnect();
  }

  return {
    focusStartOfStep: focusStartOfStep,
    focusNextButton: focusNextButton,
    focusOnSelect2InputField: focusOnSelect2InputField,
    observeSelect2SearchField: observeSelect2SearchField,
    destroySelect2Observer: destroySelect2Observer
  };
}

var _useWizardAccessibili = useWizardAccessibility(),
    focusNextButton = _useWizardAccessibili.focusNextButton;

var DuplicateStore = /*#__PURE__*/function (_PersistentStore) {
  _inherits(DuplicateStore, _PersistentStore);

  var _super = _createSuper(DuplicateStore);

  function DuplicateStore() {
    _classCallCheck(this, DuplicateStore);

    return _super.apply(this, arguments);
  }

  _createClass(DuplicateStore, [{
    key: "data",
    value: function data() {
      return {
        duplicates: [],
        isLoading: false,
        params: {}
      };
    }
  }, {
    key: "fetchDuplicates",
    value: function fetchDuplicates() {
      var _this = this;

      var jumpToNextBtn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.state.isLoading = true;
      duplicateRepository.fetchDuplicates(this.state.params).then(function (res) {
        _this.state.duplicates = res;
      }).finally(function () {
        _this.state.isLoading = false;

        if (jumpToNextBtn) {
          nextTick(function () {
            return focusNextButton();
          });
        }
      });
    }
  }, {
    key: "setParameters",
    value: function setParameters(keyValuePairs) {
      var jumpToNextBtn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var _iterator = _createForOfIteratorHelper(keyValuePairs),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var pair = _step.value;
          var _key = pair.key,
              value = pair.value;

          switch (_key) {
            case 'typeid':
              this.state.params.typeid = value;
              break;

            case 'position':
              this.state.params.lat = value.lat;
              this.state.params.lon = value.lon;
              break;

            case 'description':
              this.state.params.description = value;
              break;

            case 'title':
              this.state.params.title = value;
              break;

            case 'attributes':
              this.state.params.attributes = value;
              break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.fetchDuplicates(jumpToNextBtn);
    }
  }]);

  return DuplicateStore;
}(PersistentStore);

var duplicateStore = new DuplicateStore('CALENDAR_STORE');

var script$d = {
  name: "WizardDuplicateItem",
  props: {
    duplicate: {
      type: Object,
      required: true
    }
  },
  setup: function setup(props) {
    var _useConverter = useConverter(),
        timeDifference = _useConverter.timeDifference;

    var toggle = ref(false);
    var hasThumbnail = computed(function () {
      return props.duplicate.thumbnail_sq64 && props.duplicate.thumbnail_sq64 != "";
    });
    var thumbnailUrl = computed(function () {
      return props.duplicate.thumbnail_sq64;
    });
    var duplicatePanelClass = computed(function () {
      return {
        "col-md-8": hasThumbnail.value,
        "col-md-12": !hasThumbnail.value
      };
    });

    function toggleMessage() {
      toggle.value = !toggle.value;
    }

    return {
      toggle: toggle,
      duplicatePanelClass: duplicatePanelClass,
      hasThumbnail: hasThumbnail,
      thumbnailUrl: thumbnailUrl,
      toggleMessage: toggleMessage,
      timeDifference: timeDifference
    };
  }
};

var _withScopeId$8 = function _withScopeId(n) {
  return pushScopeId("data-v-0f987ab4"), n = n(), popScopeId(), n;
};

var _hoisted_1$d = {
  class: ""
};
var _hoisted_2$d = {
  class: "truncate-text mb-0"
};
var _hoisted_3$d = {
  key: 0,
  class: "col-md-4"
};
var _hoisted_4$a = ["src"];
var _hoisted_5$a = {
  key: 1,
  class: "m-1"
};
var _hoisted_6$7 = {
  key: 0,
  class: "p-2"
};

var _hoisted_7$6 = /*#__PURE__*/_withScopeId$8(function () {
  return /*#__PURE__*/createElementVNode("span", null, [/*#__PURE__*/createElementVNode("strong", null, "Beschreibung")], -1);
});

var _hoisted_8$6 = /*#__PURE__*/_withScopeId$8(function () {
  return /*#__PURE__*/createElementVNode("br", null, null, -1);
});

var _hoisted_9$6 = {
  class: "truncate-text truncate-four"
};

var _hoisted_10$4 = /*#__PURE__*/_withScopeId$8(function () {
  return /*#__PURE__*/createElementVNode("span", null, [/*#__PURE__*/createElementVNode("strong", null, "Erstellungszeitpunkt")], -1);
});

var _hoisted_11$4 = /*#__PURE__*/_withScopeId$8(function () {
  return /*#__PURE__*/createElementVNode("br", null, null, -1);
});

var _hoisted_12$3 = /*#__PURE__*/_withScopeId$8(function () {
  return /*#__PURE__*/createElementVNode("span", null, [/*#__PURE__*/createElementVNode("strong", null, "Status")], -1);
});

var _hoisted_13$2 = /*#__PURE__*/_withScopeId$8(function () {
  return /*#__PURE__*/createElementVNode("br", null, null, -1);
});

var _hoisted_14$1 = ["href"];
function render$d(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(Fragment, null, [createElementVNode("div", {
    class: "m-2 row duplicate-container",
    onClick: _cache[0] || (_cache[0] = function () {
      return $setup.toggleMessage && $setup.toggleMessage.apply($setup, arguments);
    })
  }, [createElementVNode("div", {
    class: normalizeClass($setup.duplicatePanelClass)
  }, [createElementVNode("p", _hoisted_1$d, "Nr. " + toDisplayString($props.duplicate.number), 1), createElementVNode("p", _hoisted_2$d, toDisplayString($props.duplicate.text), 1)], 2), $setup.hasThumbnail ? (openBlock(), createElementBlock("div", _hoisted_3$d, [createElementVNode("img", {
    src: $setup.thumbnailUrl,
    class: "float-end",
    alt: "Foto zur Meldung"
  }, null, 8, _hoisted_4$a)])) : createCommentVNode("", true), $setup.toggle ? (openBlock(), createElementBlock("hr", _hoisted_5$a)) : createCommentVNode("", true)]), $setup.toggle ? (openBlock(), createElementBlock("div", _hoisted_6$7, [createElementVNode("p", null, [_hoisted_7$6, _hoisted_8$6, createElementVNode("span", _hoisted_9$6, toDisplayString($props.duplicate.text), 1)]), createElementVNode("p", null, [_hoisted_10$4, _hoisted_11$4, createElementVNode("span", null, toDisplayString($setup.timeDifference($props.duplicate.created)), 1)]), createElementVNode("p", null, [_hoisted_12$3, _hoisted_13$2, createElementVNode("span", null, toDisplayString($props.duplicate.state_german), 1)]), createElementVNode("a", {
    href: '/bms/' + $props.duplicate.number,
    class: "btn btn-secondary",
    target: "_blank"
  }, "zur Meldung", 8, _hoisted_14$1)])) : createCommentVNode("", true)], 64);
}

script$d.render = render$d;
script$d.__scopeId = "data-v-0f987ab4";

var script$c = {
  name: "WizardDuplicates",
  components: {
    WizardDuplicateItem: script$d,
    Loading: script$f
  },
  setup: function setup() {
    // +----------------+
    // |    Computed    |
    // +----------------+
    var duplicates = computed(function () {
      return duplicateStore.getState().duplicates;
    });
    var isLoadingDuplicate = computed(function () {
      return duplicateStore.getState().isLoading;
    });
    return {
      isLoadingDuplicate: isLoadingDuplicate,
      duplicates: duplicates
    };
  }
};

var _withScopeId$7 = function _withScopeId(n) {
  return pushScopeId("data-v-e3205310"), n = n(), popScopeId(), n;
};

var _hoisted_1$c = /*#__PURE__*/_withScopeId$7(function () {
  return /*#__PURE__*/createElementVNode("p", {
    class: "step-title"
  }, "Mögliche Duplikate", -1);
});

var _hoisted_2$c = /*#__PURE__*/_withScopeId$7(function () {
  return /*#__PURE__*/createElementVNode("hr", null, null, -1);
});

var _hoisted_3$c = {
  key: 0,
  class: "fst-italic form-text"
};
var _hoisted_4$9 = {
  key: 1,
  class: "body overflow-auto"
};
var _hoisted_5$9 = {
  key: 0
};
var _hoisted_6$6 = {
  key: 1,
  class: "fst-italic form-text"
};
function render$c(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Loading = resolveComponent("Loading");

  var _component_WizardDuplicateItem = resolveComponent("WizardDuplicateItem");

  return openBlock(), createElementBlock("div", null, [_hoisted_1$c, _hoisted_2$c, $setup.isLoadingDuplicate ? (openBlock(), createElementBlock("div", _hoisted_3$c, [createVNode(_component_Loading, {
    spinnerStyle: "width: 35px; height: 35px;",
    "loading-message": "Suche nach Duplikaten..."
  })])) : (openBlock(), createElementBlock("div", _hoisted_4$9, [$setup.duplicates.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_5$9, [(openBlock(true), createElementBlock(Fragment, null, renderList($setup.duplicates, function (duplicate) {
    return openBlock(), createElementBlock("div", {
      class: "mb-3 border-1 border rounded-2",
      key: duplicate.id
    }, [createVNode(_component_WizardDuplicateItem, {
      duplicate: duplicate
    }, null, 8, ["duplicate"])]);
  }), 128))])) : (openBlock(), createElementBlock("p", _hoisted_6$6, "Keine Duplikate gefunden."))]))]);
}

script$c.render = render$c;
script$c.__scopeId = "data-v-e3205310";

var $propertyIsEnumerable = objectPropertyIsEnumerable.f;

var propertyIsEnumerable = functionUncurryThis($propertyIsEnumerable);
var push$1 = functionUncurryThis([].push);

// in some IE versions, `propertyIsEnumerable` returns incorrect result on integer keys
// of `null` prototype objects
var IE_BUG = descriptors && fails(function () {
  // eslint-disable-next-line es/no-object-create -- safe
  var O = Object.create(null);
  O[2] = 2;
  return !propertyIsEnumerable(O, 2);
});

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var IE_WORKAROUND = IE_BUG && objectGetPrototypeOf(O) === null;
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!descriptors || (IE_WORKAROUND ? key in O : propertyIsEnumerable(O, key))) {
        push$1(result, TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

var objectToArray = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod(false)
};

var $entries = objectToArray.entries;

// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
_export({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
var arrayFill = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = lengthOfArrayLike(O);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};

// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
_export({ target: 'Array', proto: true }, {
  fill: arrayFill
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('fill');

var script$b = {
  name: 'ol-map',
  props: {
    config: {
      required: true,
      type: Object
    },
    domainid: {
      required: true,
      type: Number
    },
    initial_lat: {
      required: false,
      type: Number,
      default: 0
    },
    initial_lon: {
      required: false,
      type: Number,
      default: 0
    },
    initial_zoom: {
      required: false,
      type: Number,
      default: 0
    },
    showMarkerAtInitialPosition: {
      required: false,
      type: String,
      default: ''
    },
    searchaddresssuffix: {
      required: false,
      type: String,
      default: ''
    },
    height: {
      type: Number,
      default: 450
    },
    sizeChanged: {
      type: Number,
      default: 0
    },
    refreshMarkers: {
      type: Number,
      default: 0
    },
    setMarkerAllowed: {
      type: Boolean,
      default: false
    },
    showPopupAllowed: {
      type: Boolean,
      default: true,
      required: false
    },
    hideNewMarkerLayer: {
      type: Boolean,
      default: true
    },
    filterParams: {
      required: false,
      type: Object,
      default: function _default() {
        return {};
      }
    },
    customButtonRenderer: {
      required: false,
      type: String,
      default: ''
    },
    useDeviceLocation: {
      required: false,
      type: Boolean,
      default: false
    },
    emitWarningInstead: {
      // If true, any warning will be emitted to parent component instead being displayed here
      required: false,
      type: Boolean,
      default: false
    },
    refetchMessages: {
      required: false,
      type: Boolean,
      default: false
    },
    centerSingleMarker: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  emits: ['open-feature', 'new-marker-position', 'warn-marker-position', 'new-center-position', 'new-map-extent'],
  setup: function setup(props, context) {
    var _getCurrentInstance;

    // props
    var center_lat = toRef(props, 'initial_lat');
    var center_lon = toRef(props, 'initial_lon');
    var center_zoom = toRef(props, 'initial_zoom');
    var center_custom_marker_uri = toRef(props, 'showMarkerAtInitialPosition');
    var sizeChanged = toRef(props, 'sizeChanged');
    var refreshMarkers = toRef(props, 'refreshMarkers');
    var setMarkerAllowed = toRef(props, 'setMarkerAllowed');
    var showPopupAllowed = toRef(props, 'showPopupAllowed');
    var hideNewMarkerLayer = toRef(props, 'hideNewMarkerLayer');
    var filterParams = toRef(props, 'filterParams');
    var useDeviceLocation = toRef(props, 'useDeviceLocation');
    var emitWarningInstead = toRef(props, 'emitWarningInstead'); // data

    var map = ref({});
    var layerSources = reactive([]);
    var markerLayerSources = reactive([]); // Store marker layers, so we can reload them once the map is moved or zoomed

    var layers = reactive([]);
    var baseProjection = 'EPSG:4326';
    var layerProjection = 'EPSG:3857'; // const clickMarkerLayer = ref({}); // Holds a vector layer, if a marker was clicked

    var renderer = ref('Default'); // unless otherwise specified

    var mapClickUri = ref(null); // This url will be called on map click

    var newMarkerLayer = ref({}); // Holds a vector layer, if a new marker was placed on map
    // const markerName = ref('marker-created-new.png');

    var popupContainer = ref(null); // Holds the popupContainer element

    var popup = ref(null); // Holds the ol overlay popup element

    var openedFeature = ref(null);
    var triggerReloadMarker = ref(true);
    var wmsZoomLevels = ref([]); // html elem

    var wdwMap = ref(null); // use component instance uid as unique id, in case of multiple components

    var uid = (_getCurrentInstance = getCurrentInstance()) === null || _getCurrentInstance === void 0 ? void 0 : _getCurrentInstance.uid; // computed

    var id = computed(function () {
      return "wdw-map-".concat(props.domainid, "-").concat(uid);
    });
    var popupId = computed(function () {
      return "".concat(id.value, "-balloon");
    });
    var mapStyle = computed(function () {
      return "height:".concat(props.height, "px");
    }); // methods

    /*
    function handleExistingMarker(markerLayer: any) {
        map.value.removeLayer(markerLayer);
    }
    */

    function addPopup() {
      popupContainer.value = document.getElementById(popupId.value);

      if (popupContainer.value) {
        popup.value = new Overlay({
          autoPan: true,
          autoPanAnimation: {
            duration: 250
          },
          element: popupContainer.value,
          offset: [0, -16],
          // Offset the popup by size of the pointing down arrow
          positioning: 'bottom-center',
          stopEvent: true
        });
        map.value.addOverlay(popup.value);
      } else {
        console.warn("Element #".concat(popupId.value, " not found!"));
      }
    }

    function hidePopup() {
      var _popup$value;

      (_popup$value = popup.value) === null || _popup$value === void 0 ? void 0 : _popup$value.setPosition(undefined);
      openedFeature.value = null;
      return false;
    }

    function emitOpenFeature(feature) {
      var _popup$value2;

      context.emit('open-feature', feature);
      (_popup$value2 = popup.value) === null || _popup$value2 === void 0 ? void 0 : _popup$value2.setPosition(undefined);
      openedFeature.value = null;

      if (document.fullscreenElement) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if ("webkitExitFullscreen" in document) {
          /* Safari */
          document.webkitExitFullscreen();
        } else if ("msExitFullscreen" in document) {
          /* IE11 */
          document.msExitFullscreen();
        }
      }
    }

    function setPopupContent(innerHTML, feature) {
      var _popupContainer$value, _popupContainer$value4, _popupContainer$value5, _popupContainer$value6;

      var contentElem = (_popupContainer$value = popupContainer.value) === null || _popupContainer$value === void 0 ? void 0 : _popupContainer$value.querySelector('.content');

      if (contentElem) {
        contentElem.innerHTML = innerHTML;
      }

      var featureId = feature.getId();

      if (props.customButtonRenderer == 'thought' && featureId) {
        var _popupContainer$value2;

        // set feature info, to show button to emit event
        openedFeature.value = {
          id: featureId,
          buttonTitle: domainStore.translate('thought.general.title') + ' ansehen'
        }; // remove the server side rendered button

        var serverButton = (_popupContainer$value2 = popupContainer.value) === null || _popupContainer$value2 === void 0 ? void 0 : _popupContainer$value2.querySelector('a.btn.infobox-button');
        serverButton === null || serverButton === void 0 ? void 0 : serverButton.remove();
      }

      if (props.customButtonRenderer == 'bmsBoard' && featureId) {
        var _popupContainer$value3;

        // set feature info, to show button to emit event
        openedFeature.value = {
          id: featureId,
          buttonTitle: 'Details ansehen'
        }; // remove the server side rendered button

        var _serverButton = (_popupContainer$value3 = popupContainer.value) === null || _popupContainer$value3 === void 0 ? void 0 : _popupContainer$value3.querySelector('a.btn.infobox-button');

        _serverButton === null || _serverButton === void 0 ? void 0 : _serverButton.remove();
      } // remove close button that was sent in the html from server


      var serverCloseButton = (_popupContainer$value4 = popupContainer.value) === null || _popupContainer$value4 === void 0 ? void 0 : _popupContainer$value4.querySelector('.content a.close');
      serverCloseButton === null || serverCloseButton === void 0 ? void 0 : serverCloseButton.remove(); // remove the server side rendered button if the rendered button is inside a div
      // Example in Marburg's thought_innerhalb.tt infobox

      var serverCloseButtonInsideDiv = (_popupContainer$value5 = popupContainer.value) === null || _popupContainer$value5 === void 0 ? void 0 : _popupContainer$value5.querySelector('div a.btn.infobox-button');

      if (serverCloseButtonInsideDiv) {
        serverCloseButtonInsideDiv.remove();
      } // remove the server side rendered "Neue Idee" button in Marburg's infobox


      var serverNewIdeaBtnInsideDiv = (_popupContainer$value6 = popupContainer.value) === null || _popupContainer$value6 === void 0 ? void 0 : _popupContainer$value6.querySelector('div a.btn.center-block.map-popover');

      if (serverNewIdeaBtnInsideDiv) {
        serverNewIdeaBtnInsideDiv.remove();
      }
    }

    function buildLayerSourceOptions() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = {};

      if (source.crossOrigin !== undefined) {
        options.crossOrigin = !source.crossOrigin ? null : source.crossOrigin;
      }

      if (source.maxZoom !== undefined) {
        options.maxZoom = source.maxZoom;
      }

      if (source.minZoom !== undefined) {
        options.minZoom = source.minZoom;
      }

      layerSources.push(options);
      return options;
    }

    function buildLayerOptions() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = {
        title: source.title || ''
      };

      if (source.base !== undefined && source.base) {
        options.type = 'base';
      }

      if (source.visible !== undefined) {
        options.visible = source.visible ? true : false;
      }

      if (source.opacity !== undefined) {
        options.opacity = source.opacity;
      }

      if (source.groupname !== undefined) {
        options.groupname = source.groupname;
      }

      if (source.type !== undefined) {
        options.wdwType = source.type;
      }

      layers.push(options);
      return options;
    }

    function getIconConfigForMarker() {
      return {
        src: '',
        scale: 0.8,
        // Openlayers sets the anchor of an image to the center
        // by default. The following line sets the anchor to the
        // bottom of the image, which is what we want for markers
        anchor: [0.5, 1]
      };
    }

    function setMarkerLayer(params) {
      var customMarkerUri = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var locationResultEl = document.getElementById('wdw-bms-map-location-result');

      if (locationResultEl) {
        locationResultEl.setAttribute('tabindex', '-1');
        locationResultEl.innerHTML = '';
        locationResultEl.style.visibility = 'hidden';
      }

      if (setMarkerAllowed.value && mapClickUri.value) {
        axiosWdw.get(mapClickUri.value, {
          params: params
        }).then(function (response) {
          console.log('mapClickUri not fully implemented');
          console.log(response);
        }).catch(function (err) {
          console.error('Error loading infobox');
          console.log(err);
        });
      } else {
        // First check if a marker already exists
        if (newMarkerLayer.value) {
          map.value.removeLayer(newMarkerLayer.value);
        }

        if (setMarkerAllowed.value) {
          context.emit('new-marker-position', params);
        }

        var markerStyleConfig = getIconConfigForMarker();
        markerStyleConfig.src = props.config.create_marker_uri;

        if (customMarkerUri) {
          markerStyleConfig.src = customMarkerUri;
        }

        var newMarker = new Vector$1({
          source: new Vector({
            features: [new Feature({
              geometry: new Point(ol_proj.fromLonLat([params.lon, params.lat])),
              name: 'Neuer Marker'
            })]
          }),
          style: new Style({
            image: new Icon(markerStyleConfig)
          })
        });
        newMarkerLayer.value = newMarker;
        map.value.addLayer(newMarker);
      }
    }
    /*
    function addMarker(coordinates: Coordinate) {
        const marker = new ol_feature({
            name: 'Marker',
            geometry: new geom_point(coordinates),
        });
        const vectorSource = new source_vector({
            features: [marker],
        });
        const vectorLayer = new layer_vector({
            source: vectorSource,
        });
        const markerLayer = clickMarkerLayer.value;
        if (markerLayer) {
            handleExistingMarker(markerLayer);
        }
        clickMarkerLayer.value = vectorLayer;
        map.value.addLayer(vectorLayer);
    }
    */


    function handleClickOnMap(e) {
      var _popup$value3;

      (_popup$value3 = popup.value) === null || _popup$value3 === void 0 ? void 0 : _popup$value3.setPosition(undefined);
      openedFeature.value = null;

      if (!setMarkerAllowed.value) {
        return;
      }

      var coordinatesTransform = ol_proj.transform(e.coordinate, layerProjection, baseProjection);
      var params = {
        lat: coordinatesTransform[1],
        lon: coordinatesTransform[0]
      };
      handleClickOnMapWithCoordinates(params);
    }

    function handleClickOnMapWithCoordinates(coord) {
      var panToCoord = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      setMarkerLayer(coord);
      var locationResultEl = document.getElementById('wdw-bms-map-location-result');

      if (locationResultEl) {
        locationResultEl.innerHTML = '';
        locationResultEl.style.visibility = 'hidden';
      }

      if (panToCoord) {
        centerMapAtPosition(coord);
      }
    }

    function handleClickOnFeature(e, feature, layer, coordinate) {
      var infoboxUri = feature.get('infobox_uri');

      if (infoboxUri) {
        var params = {
          renderer: renderer.value
        };

        if (showPopupAllowed.value) {
          axiosWdwDomain.get(infoboxUri, {
            params: params
          }).then(function (response) {
            var _popup$value4;

            setPopupContent(response.data.data.html, feature);
            (_popup$value4 = popup.value) === null || _popup$value4 === void 0 ? void 0 : _popup$value4.setPosition(e.coordinate);
          }).catch(function (err) {
            console.error('Error loading infobox');
            console.log(err);
          });
        }
      } else if (layer.get('infobox_uri')) {
        // Per T17350, check feature parameters and coordinate if layer has infobox_uri
        openedFeature.value = null; // Build parameters

        var layerInfoboxUri = layer.get('infobox_uri');
        var coordTransform = ol_proj.transform(coordinate, layerProjection, baseProjection);
        var _params = {
          renderer: renderer.value,
          lat: coordTransform[1],
          lon: coordTransform[0]
        };

        if (layer !== null) {
          _params.layer = layer.get('title');
        }

        axiosWdwDomain.get(layerInfoboxUri, {
          params: _params
        }).then(function (response) {
          if (showPopupAllowed.value) {
            var _popup$value5;

            setPopupContent(response.data.data.html, feature);
            (_popup$value5 = popup.value) === null || _popup$value5 === void 0 ? void 0 : _popup$value5.setPosition(coordinate);
          }
          /**
           * Per T17350,
           *    if the user clicks on a feature while creating new thought,
           *    it should emit the new-marker-position event so the coordinate can be captured by the form along with other additional data.
           *
           *    For now, this only applies on feature in a layer with the given infobox_uri due to the fact that additional data is passed
           *    together with rendered HTML.
           * */


          if (setMarkerAllowed.value) {
            // Set the marker
            var additional_data = response.data.data.infobox_data ? response.data.data.infobox_data.create_defaults : {};
            setMarkerLayer({
              lat: _params.lat,
              lon: _params.lon,
              additional_data: additional_data
            });
          }
        }).catch(function (err) {
          console.error('Error loading infobox');
          console.log(err);
        });
      } else {
        handleClickOnMap(e);
      }
    }

    function handleClick(e) {
      // Avoid popups when links are clicked
      var clickedElement = e.originalEvent.target;
      var clickedElementTagName = clickedElement.nodeName.toLowerCase();

      if (clickedElementTagName == 'a') {
        return;
      }

      var featureLayer = map.value.forEachFeatureAtPixel(e.pixel, function (feature, layer) {
        return {
          feature: feature,
          layer: layer
        };
      });
      var feature = featureLayer ? featureLayer.feature : null;
      var layer = featureLayer ? featureLayer.layer : null; // when layer is clustered, we need to take an extra step to get the single feature

      if (props.config.cluster_markers && feature && feature.get('features') && feature.get('features').length == 1) {
        feature = feature.get('features')[0];
      }

      if (feature) {
        handleClickOnFeature(e, feature, layer, e.coordinate);
      } else {
        handleClickOnMap(e);
      }
    }

    function getMapExtent() {
      var mapExtent = map.value.getView().calculateExtent(map.value.getSize()); // [minx, miny, maxx, maxy]

      return ol_proj.transformExtent(mapExtent, layerProjection, baseProjection);
    }
    /**
     * helper method to get mdv specific values for template placeholders like {colMin}
     * @inner
     * @param {L.Point} tilePoint point that specifies a specific tile of the map
     * @returns {Object} dictionary containing values for colMin, colMax, rowMin and rowMax
     */


    function get_mdv_path_elems(x, y) {
      var colMin = Math.floor(x / 100) * 100,
          rowMin = Math.floor(y / 100) * 100;
      return {
        colMin: colMin,
        colMax: colMin + 99,
        rowMin: rowMin,
        rowMax: rowMin + 99
      };
    }

    function centerMapAtPosition(params) {
      var coordinatesTransform = ol_proj.transform([params.lon, params.lat], baseProjection, layerProjection);
      var view = map.value.getView();
      view.setCenter(coordinatesTransform);

      if (params.zoom !== undefined) {
        view.setZoom(params.zoom);
      }
    }

    function recenterMapToConfig() {
      var params = {
        lat: props.config.lat,
        lon: props.config.lon,
        zoom: props.config.zoom
      };
      centerMapAtPosition(params);
    }

    function getLoaderFunction(url, baseProjection, layerProjection, params) {
      var onInit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      function handleResponse(response) {
        if (props.centerSingleMarker && response.data.features && response.data.features.length === 1) {
          var coordinates = response.data.features[0].geometry.coordinates;
          centerMapAtPosition({
            lon: coordinates[0],
            lat: coordinates[1]
          });
        }

        var features = new GeoJSON().readFeatures(response.data, {
          dataProjection: baseProjection,
          featureProjection: layerProjection
        });
        this.addFeatures(features);
      }

      if (onInit) {
        return function () {
          var _this = this;

          axiosWdw.get(url, {
            params: params
          }).then(function (response) {
            handleResponse.call(_this, response);
          });
        };
      }

      return new Promise(function (resolve, reject) {
        axiosWdw.get(url, {
          params: params
        }).then(function (response) {
          resolve(function () {
            return handleResponse.call(this, response);
          });
        }).catch(function () {
          return reject();
        });
      });
    }

    function handlePositionChange(event) {
      var newCenterCoords = [ol_proj.transform(event.map.getView().getCenter(), layerProjection, baseProjection), event.map.getView().getZoom()];
      context.emit('new-center-position', newCenterCoords);
    }

    function reloadMarkers() {
      // loop all map layers
      var layerGroups = map.value.getLayers().getArray();
      layerGroups.forEach(function (group) {
        if (group instanceof Group) {
          var _layers = group.getLayers();

          _layers.forEach(function (layer) {
            var source = layer.getSource();

            if (source instanceof Vector && layer.get('wdwType') == 'marker_overlay') {
              markerLayerSources.forEach(function (markerSource) {
                //MarkerlaterSource && layer.get('title') are both undefined... idk why , but when its true it works.
                // if (layer.get('title') === markerSource.title)
                var url = markerSource.source_url;
                var params = {};

                if (markerSource.forceParams && _typeof(markerSource.forceParams) === 'object') {
                  // get forceParams object copy, to ensure not changing original reference
                  params = JSON.parse(JSON.stringify(markerSource.forceParams));
                } // remove rows, page & sort params if they exist


                for (var _i = 0, _Object$entries = Object.entries(filterParams.value); _i < _Object$entries.length; _i++) {
                  var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
                      key = _Object$entries$_i[0],
                      value = _Object$entries$_i[1];

                  if (key !== 'rows' && key !== 'sort' && key !== 'page') {
                    Object.assign(params, _defineProperty({}, key, value));
                  }
                }

                var mapExtent = getMapExtent();
                var mapParams = {
                  left: mapExtent[0],
                  bottom: mapExtent[1],
                  right: mapExtent[2],
                  top: mapExtent[3],
                  zoom: map.value.getView().getZoom()
                };
                Object.assign(params, mapParams);
                context.emit('new-map-extent', mapParams);
                getLoaderFunction(url, baseProjection, layerProjection, params).then(function (r) {
                  markerSource.options.loader = r;
                  var new_source = new Vector(markerSource.options);
                  var orig_source = layer.getSource();

                  if (layer.get('wdwUsingCluster') && typeof orig_source.getSource == 'function') {
                    // is a cluster. update source on the cluster instead
                    // hierarchy: layer -> cluster source -> vector source
                    orig_source.setSource(new_source);
                  } else {
                    // not a cluster, normally update the layer source
                    // hierarchy: layer -> vector source
                    layer.setSource(new_source);
                  }

                  map.value.updateSize();
                });
              });
            }
          });
        }
      });
    }

    function registerListeners() {
      map.value.on('click', function (e) {
        handleClick(e);
      });

      if (props.refetchMessages == true) {
        map.value.on('moveend', function (e) {
          if (triggerReloadMarker.value) {
            reloadMarkers();
            triggerReloadMarker.value = false;
          }

          setTimeout(function () {
            triggerReloadMarker.value = true;
          }, 1200);
          nextTick(function () {
            return handlePositionChange(e);
          });
        });
      } // map.value.on('dragend', debounce(reloadMarkers, 1000));

    }

    function mapLocate() {
      var protocol = location.protocol.slice(0, -1);

      if (protocol === 'https') {
        if ('geolocation' in navigator) {
          navigator.geolocation.getCurrentPosition(function (position) {
            var params = {
              lat: position.coords.latitude,
              lon: position.coords.longitude,
              zoom: 16
            };

            if (setMarkerAllowed.value) {
              // set the marker layer
              //return clicked events?
              setMarkerLayer(params);
            }

            centerMapAtPosition(params); // Bus.emit('wdw-map-current-coordinates', {
            //     lon: position.coords.longitude,
            //     lat: position.coords.latitude,
            //     zoom: this.mapLocateDefaulZoom,
            // });
            // Do reverse geocoding

            var url = 'domain/' + props.domainid + '/address_from_latlon?';
            url += 'lat=' + position.coords.latitude;
            url += '&lon=' + position.coords.longitude;
            axiosWdw.get(url).then(function (response) {
              // TODO map location result elem
              // TODO refactor jquery stuff...
              // Build warn text
              var warnText = '';

              if (response.data && response.data.data && response.data.data !== '') {
                warnText = 'Der Marker wurde an der ' + response.data.data + ' platziert. Bitte korrigieren Sie Ihre Eingabe/den Marker falls die Meldung an einer anderen Position platziert werden soll.';
              } else {
                warnText = 'Die Standortermittlung liefert keine gültige Adresse. Bitte korrigieren Sie Ihre Eingabe/den Marker falls die Meldung an einer anderen Position platziert werden soll.';
              } // Check whether to display warning here or emit to parent


              if (emitWarningInstead.value) {
                context.emit('warn-marker-position', {
                  text: warnText
                });
              } else {
                var warnElem = document.getElementById('wdw-bms-map-location-result');

                if (warnElem) {
                  warnElem.innerHTML = "<p class='alert alert-warning'>" + warnText + '</p>';
                  warnElem.style.visibility = 'visible';
                }
              }
            }).catch(function (err) {
              // Uncomment if you want to test warning display

              /*
              const warnText =
                  'Der Marker wurde an der Test Standort 12345' +
                  ' platziert. Bitte korrigieren Sie Ihre Eingabe/den Marker falls die Meldung an einer anderen Position platziert werden soll.';
              context.emit("warn-marker-position", { text: warnText });
              */
              console.error('Error reversegeocoding user location:');
              console.log(err);
            });
          }, function (error) {
            var errorTypes = {
              0: 'Unbekannter Fehler',
              1: 'Die Geoposition wurde vom Nutzer nicht freigegeben',
              2: 'Geoposition nicht verfügbar',
              3: 'Request timeout'
            };
            var errorMessage = errorTypes[error.code];

            if (error.code == 0 || error.code == 2) {
              errorMessage += ': ' + error.message;
            }

            console.error(errorMessage); // On error, go to center position of the given suffix or 0,0 if no suffix

            if (error.code == 2 || error.code == 3) {
              if (props.searchaddresssuffix == '') ;
            }
          });
        } else {
          console.warn('Geolocation support is not available.');
        }
      } else {
        console.warn("Geolocation is only available in https context");
      }
    } // function triggered on change:visible event for map_overlay layers


    function onVisibleLayer(evt) {
      var layer = evt.target; // if layer was hidden becomes visible

      if (evt.oldValue == false && layer.get(evt.key) == true) {
        // if exclusiveVisibility is set, hide all other layers with same groupname
        var exclusive_visibility = layer.get('exclusiveVisibility');

        if (exclusive_visibility) {
          var groupname = layer.get('groupname');
          var title = layer.get('title');

          if (groupname !== undefined) {
            map.value.getLayers().forEach(function (l) {
              if (l instanceof Group) {
                // layer group
                l.getLayers().forEach(function (subl) {
                  if (subl.get('title') != title && subl.get('groupname') == groupname) {
                    subl.setVisible(0);
                  }
                });
              } else {
                // Individual layer
                if (l.get('title') != title && l.get('groupname') == groupname) {
                  l.setVisible(0);
                }
              }
            });
          }
        } // if callback for onVisible is defined, try executing it.


        var callback = layer.get('onVisibleCallback');

        if (callback !== undefined) {
          new Function('return ' + callback)();
        }
      }
    }

    function initMap() {
      var layers = [];
      var layer;
      var layerGroupsJs = [];
      var layerGroups = [];

      if (props.config.renderer !== undefined) {
        renderer.value = props.config.renderer;
      }

      if (props.config.mapClickUri !== undefined) {
        mapClickUri.value = props.config.mapClickUri;
      }

      props.config.sources.forEach(function (source) {
        var groupname = source.group;
        var attribution = source.attribution;
        var layerSourceOptions = buildLayerSourceOptions(source);
        var layerOptions = buildLayerOptions(source);

        if (groupname !== undefined) {
          layerOptions.groupname = groupname;
        }

        if (attribution !== undefined) {
          layerSourceOptions.attributions = attribution;
        }

        if (source.type == 'map_overlay') {
          if (source.url !== undefined) {
            layerSourceOptions.url = source.url;
          } else {
            console.warn('Url not defined in source, but this param is mandatory!');
          }

          layerOptions.onVisibleCallback = source.onVisibleFunction || null;
          layerOptions.exclusiveVisibility = source.exclusive_visibility ? true : false;
          layerOptions.source = new TileImage(layerSourceOptions);
          layer = new Tile(layerOptions);
          layers.push(new Tile(layerOptions));

          if (layerOptions.exclusiveVisibility || layerOptions.onVisibleCallback) {
            layer.on('change:visible', onVisibleLayer);
          }
        } else if (source.type == 'marker_overlay') {
          var styleCache = {};

          var styleFunction = function styleFunction(feature) {
            var marker_uri = feature.get('marker_uri');

            if (!styleCache[marker_uri]) {
              var markerStyleConfig = getIconConfigForMarker();
              markerStyleConfig.src = marker_uri;
              styleCache[marker_uri] = new Style({
                image: new Icon(markerStyleConfig)
              });
            }

            return [styleCache[marker_uri]];
          };

          layerSourceOptions.format = new GeoJSON();
          var features;

          if (source.url) {
            var source_url = source.url; // TODO -> if we wanna fetch thoughts  dynamically on moving map we have to do it here
            // [minx, miny, maxx, maxy]
            // const mapExtent = getMapExtent();
            // const params = {
            //     minLon: mapExtent[0],
            //     minLat: mapExtent[1],
            //     maxLon: mapExtent[2],
            //     maxLat: mapExtent[3],
            // }

            var params = {};

            if (source.forceParams && _typeof(source.forceParams) === 'object') {
              params = source.forceParams;
            } // remove rows, page & sort params if they exist


            for (var _i2 = 0, _Object$entries2 = Object.entries(filterParams.value); _i2 < _Object$entries2.length; _i2++) {
              var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
                  key = _Object$entries2$_i[0],
                  value = _Object$entries2$_i[1];

              if (key !== 'rows' && key !== 'sort' && key !== 'page') {
                Object.assign(params, _defineProperty({}, key, value));
              }
            }

            layerSourceOptions.loader = getLoaderFunction(source_url, baseProjection, layerProjection, params, true);
            markerLayerSources.push({
              title: source.title,
              source_url: source_url,
              projection: baseProjection,
              options: layerSourceOptions,
              forceParams: source.forceParams
            });
          } else if (features) {
            layerSourceOptions.features = new GeoJSON().readFeatures(features, {
              dataProjection: baseProjection,
              featureProjection: layerProjection
            });
          } else {
            console.warn('neither url nor features defined for layer ' + source.title);
          }

          if (props.config.cluster_markers) {
            // use a cluster on layer-source
            var _source = new Vector(layerSourceOptions);

            var clusterSource = new Cluster({
              distance: 50,
              source: _source
            });
            layerOptions.source = clusterSource;
            var styleCacheCluster = {};

            var clusterStyleFunction = function clusterStyleFunction(feature) {
              var size = feature.get('features').length;
              var style = styleCacheCluster[size];

              if (!style) {
                style = new Style({
                  image: new Circle({
                    radius: 12,
                    stroke: new Stroke({
                      color: '#fff'
                    }),
                    fill: new Fill({
                      color: '#398C8C'
                    })
                  }),
                  text: new Text({
                    text: size.toString(),
                    font: 'bold 12px sans-serif',
                    fill: new Fill({
                      color: '#fff'
                    })
                  })
                });
                styleCacheCluster[size] = style;
              }

              return style;
            };

            var getStyle = function getStyle(feature) {
              if (feature.get('features') && feature.get('features').length > 1) {
                return clusterStyleFunction(feature);
              } else if (feature.get('features') && feature.get('features').length == 1) {
                return styleFunction(feature.get('features')[0]);
              }

              return styleFunction(feature);
            };

            layerOptions.style = getStyle;
            layerOptions.wdwUsingCluster = true;
          } else {
            layerOptions.source = new Vector(layerSourceOptions);
            layerOptions.style = styleFunction;
          }

          layers.push(new Vector$1(layerOptions));
          layer = new Vector$1(layerOptions);
        } else if (source.type == 'map_overlay_wms') {
          if (source.url !== undefined) {
            layerSourceOptions.url = source.url;
          } else {
            console.warn('Url not defined in source, but this param is mandatory!');
          }

          if (source.wmsParams !== undefined) {
            layerSourceOptions.params = source.wmsParams; // T17185 required for specific wms only using this projection

            if (source.wmsParams.projection === 'EPSG:4326') {
              layerSourceOptions.projection = ol_proj.get('EPSG:4326');
            }
          }

          if (source.wmsZoomLevels !== undefined) {
            wmsZoomLevels.value = source.wmsZoomLevels;
          }

          layerOptions.source = new TileWMS(layerSourceOptions);
          layers.push(new Tile(layerOptions));
          layer = new Tile(layerOptions);
        } else if (source.type == 'map_overlay_xyz') {
          var baseUrl = '';

          if (source.url !== undefined) {
            baseUrl = source.url;
          } else {
            console.warn('Url not defined in source, but this param is mandatory!');
          }

          if (source.xyzParams !== undefined) {
            layerSourceOptions.params = source.xyzParams;
          }

          if (source.xyzParams.xyzTileFunction === 'RadroutenplanerMVV') {
            layerSourceOptions.tileUrlFunction = function (coord) {
              var zoom = coord[0];
              var x = coord[1];
              var y = coord[2];
              var path_elems = get_mdv_path_elems(x, y);
              var z = zoom - 3;
              var uri = baseUrl + '/zoomlevel' + z + '/columns' + path_elems.colMin + '-' + path_elems.colMax + '/column' + x + '/rows' + path_elems.rowMin + '-' + path_elems.rowMax + '/' + y + '_' + x + '_' + z + '.png';
              return uri;
            };
          } else {
            console.warn('map type xyz with unhandled xyzTileFunction');
          }

          layerOptions.source = new XYZ(layerSourceOptions);
          layers.push(new Tile(layerOptions));
          layer = new Tile(layerOptions);
        } else if (source.type == 'geojson_overlay') {
          var _styleCache = {};

          var _styleFunction = function _styleFunction(feature) {
            var id = feature.get('id');

            if (!_styleCache[id]) {
              var styleObj = {};
              var sourceStyle = source.style;

              if (Object.prototype.hasOwnProperty.call(sourceStyle, 'fill')) {
                styleObj.fill = new Fill(sourceStyle.fill);
              }

              if (Object.prototype.hasOwnProperty.call(sourceStyle, 'stroke')) {
                styleObj.stroke = new Stroke(sourceStyle.stroke);
              }

              _styleCache[id] = new Style(styleObj);
            }

            return [_styleCache[id]];
          };

          layerSourceOptions.format = new GeoJSON();
          layerOptions.style = _styleFunction;

          if (source.url) {
            layerSourceOptions.loader = function () {
              var _this2 = this;

              axiosBasic.get(source.url).then(function (response) {
                var features = new GeoJSON().readFeatures(response.data, {
                  dataProjection: baseProjection,
                  featureProjection: layerProjection
                });

                _this2.addFeatures(features);
              });
            };
          } else {
            console.log('Url is not defined for geojson layer ' + source.title);
          }

          layerOptions.onVisibleCallback = source.onVisibleFunction || null;
          layerOptions.exclusiveVisibility = source.exclusive_visibility ? true : false;
          layerOptions.infobox_uri = source.infobox_uri || null;
          layerOptions.source = new Vector(layerSourceOptions);
          layer = new Vector$1(layerOptions);
          layers.push(layer);

          if (layerOptions.exclusiveVisibility || layerOptions.onVisibleCallback) {
            layer.on('change:visible', onVisibleLayer);
          }
        }

        var layerGroup = undefined;
        layerGroupsJs.forEach(function (group) {
          if (group.title == groupname) {
            layerGroup = group;
          }
        });

        if (layerGroup !== undefined) {
          layerGroup.layers.push(layer);
        } else {
          var newLayerGroup = {
            title: groupname,
            layers: [layer]
          };
          layerGroupsJs.push(newLayerGroup);
        }
      }); // Convert to layer group objects

      layerGroupsJs.forEach(function (group) {
        layerGroups.push(new Group(group));
      });
      var viewOptions = {
        center: ol_proj.fromLonLat([props.config.lon, props.config.lat]),
        zoom: props.config.zoom
      };

      if (props.config.bounds !== undefined) {
        if (props.config.bounds.length == 4) {
          viewOptions.extent = ol_proj.transformExtent(props.config.bounds, baseProjection, layerProjection);
        }

        if (props.config.maxZoom) {
          viewOptions.maxZoom = props.config.maxZoom;
        }

        if (props.config.minZoom) {
          viewOptions.minZoom = props.config.minZoom;
        }
      }

      var mapConfig = {
        target: id.value,
        layers: layerGroups,
        controls: ol_control.defaults().extend([new ol_control.FullScreen({
          tipLabel: 'Vollbild'
        }), new ol_control.ScaleLine({
          units: 'metric'
        })]),
        view: new View(viewOptions)
      };

      if (useDeviceLocation.value) {
        // Create the position button
        var button = document.createElement('button');
        button.innerHTML = '<i class="fa fa-map-marker-alt"></i>';
        button.title = 'Aktuellen Standort anzeigen';

        var handleCurrentPosition = function handleCurrentPosition() {
          mapLocate();
        };

        button.addEventListener('click', handleCurrentPosition, false);
        button.addEventListener('touchstart', handleCurrentPosition, false);
        var element = document.createElement('div');
        element.className = 'map-locate ol-unselectable ol-control ol-position';
        element.style.top = "80px";
        element.style.position = "absolute";
        element.appendChild(button); // Add the button

        mapConfig.controls.extend([new ol_control.Control({
          element: element
        })]);
      }

      map.value = new Map(mapConfig);
      var layerSwitcher = new LayerSwitcher();
      map.value.addControl(layerSwitcher);
      addPopup();
      registerListeners(); // If initial lat-lon is given, process it as if the user clicks on it

      var data = {};

      if (props.initial_lat !== null && props.initial_lon !== null && props.initial_lat !== 0 && props.initial_lon !== 0) {
        data = {
          lat: props.initial_lat,
          lon: props.initial_lon
        };
      }

      if (props.initial_zoom > 0) {
        data.zoom = props.initial_zoom;
      }

      if (Object.keys(data).length > 0) {
        setMarkerLayer(data);
        centerMapAtPosition(data);
      }
    }

    onMounted(function () {
      var _document$getElements, _document$getElements2;

      initMap();
      var newLayerSwitcherButton = document.createElement('i');
      newLayerSwitcherButton.classList.add('fas', 'fa-layer-group');
      var layerSwitcherButton = (_document$getElements = document.getElementsByClassName('layer-switcher')) === null || _document$getElements === void 0 ? void 0 : (_document$getElements2 = _document$getElements.item(0)) === null || _document$getElements2 === void 0 ? void 0 : _document$getElements2.firstChild;
      layerSwitcherButton === null || layerSwitcherButton === void 0 ? void 0 : layerSwitcherButton.appendChild(newLayerSwitcherButton); // hide map-location-results

      var locationResultEl = document.getElementById('wdw-bms-map-location-result');

      if (locationResultEl) {
        locationResultEl.setAttribute('tabindex', '-1');
        locationResultEl.innerHTML = '';
        locationResultEl.style.visibility = 'hidden';
      } // watch dom to replace <i> elements with <svg> elements in map context (fontawesome)
      // limit to required context so as not to influence any elements outside this scope
      // required for location-icon in map


      var mapHtmlElem = document.getElementById(id.value);

      if (mapHtmlElem) {
        dom.i2svg({
          node: mapHtmlElem
        });
      }
    });
    watch([center_lat, center_lon], function (_ref, _ref2) {
      var _ref3 = _slicedToArray(_ref, 2),
          lat = _ref3[0],
          lon = _ref3[1];

      var _ref4 = _slicedToArray(_ref2, 2),
          prevLat = _ref4[0],
          prevLon = _ref4[1];

      if (lat !== prevLat || lon !== prevLon) {
        if (lat !== null && lat !== 0 && lon !== null && lon !== 0) {
          // lat/lon was provided a new value, so zoom map to that
          var params = {
            lat: lat,
            lon: lon
          };

          if (center_zoom.value > 0) {
            params.zoom = center_zoom.value;
          }

          centerMapAtPosition(params); // if custom marker uri is provided for in addition to these params, show it

          if (center_custom_marker_uri.value) {
            setMarkerLayer(params, center_custom_marker_uri.value);
          } else if (newMarkerLayer.value) {
            map.value.removeLayer(newMarkerLayer.value);
          }
        } else {
          // lat/lon was reset to 0/0 center map back to default position
          recenterMapToConfig(); // also reset marker layer

          map.value.removeLayer(newMarkerLayer.value);
        }
      }
    });
    watch(sizeChanged, function (newVal, oldVal) {
      if (newVal !== oldVal && newVal !== 0 && map.value) {
        setTimeout(function () {
          map.value.updateSize();
        }, 1200);
      }
    });
    watch(refreshMarkers, function (newVal, oldVal) {
      if (newVal !== oldVal && newVal !== 0 && map.value) {
        // loop all map layers
        var layerGroups = map.value.getLayers().getArray();
        layerGroups.forEach(function (group) {
          if (group instanceof Group) {
            var _layers2 = group.getLayers();

            _layers2.forEach(function (layer) {
              var source = layer.getSource();

              if (source instanceof Vector && layer.get('wdwType') == 'marker_overlay') {
                layer.getSource().refresh();
                map.value.updateSize();
              }
            });
          }
        });
      }
    });
    watch(filterParams, function (newVal, oldVal) {
      if (!newVal !== null && _typeof(newVal) === 'object' && map.value && newVal != oldVal) {
        // loop all map layers
        var layerGroups = map.value.getLayers().getArray();
        layerGroups.forEach(function (group) {
          if (group instanceof Group) {
            var _layers3 = group.getLayers();

            _layers3.forEach(function (layer) {
              var source = layer.getSource();

              if (source instanceof Vector && layer.get('wdwType') == 'marker_overlay') {
                markerLayerSources.forEach(function (markerSource) {
                  if (layer.get('title') === markerSource.title) {
                    var url = markerSource.source_url;
                    var params = {};

                    if (markerSource.forceParams && _typeof(markerSource.forceParams) === 'object') {
                      // get forceParams object copy, to ensure not changing original reference
                      params = JSON.parse(JSON.stringify(markerSource.forceParams));
                    } // remove rows, page & sort params if they exist


                    for (var _i3 = 0, _Object$entries3 = Object.entries(filterParams.value); _i3 < _Object$entries3.length; _i3++) {
                      var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2),
                          key = _Object$entries3$_i[0],
                          value = _Object$entries3$_i[1];

                      if (key !== 'rows' && key !== 'sort' && key !== 'page') {
                        Object.assign(params, _defineProperty({}, key, value));
                      }
                    }

                    var mapExtent = getMapExtent();
                    Object.assign(params, {
                      left: mapExtent[0],
                      bottom: mapExtent[1],
                      right: mapExtent[2],
                      top: mapExtent[3]
                    });
                    getLoaderFunction(url, baseProjection, layerProjection, params).then(function (e) {
                      markerSource.options.loader = e;
                      var new_source = new Vector(markerSource.options);
                      var orig_source = layer.getSource();

                      if (layer.get('wdwUsingCluster') && typeof orig_source.getSource == 'function') {
                        // is a cluster. update source on the cluster instead
                        // hierarchy: layer -> cluster source -> vector source
                        orig_source.setSource(new_source);
                      } else {
                        // not a cluster, normally update the layer source
                        // hierarchy: layer -> vector source
                        layer.setSource(new_source);
                      }

                      map.value.updateSize();
                    });
                  }
                });
              }
            });
          }
        });
      }
    });
    watch(hideNewMarkerLayer, function (newVal, oldVal) {
      if (newVal && newVal != oldVal && newMarkerLayer.value) {
        map.value.removeLayer(newMarkerLayer.value);
      }
    });
    context.expose({
      handleClickOnMapWithCoordinates: handleClickOnMapWithCoordinates,
      mapLocate: mapLocate
    });
    return {
      id: id,
      popupId: popupId,
      map: map,
      mapStyle: mapStyle,
      wdwMap: wdwMap,
      openedFeature: openedFeature,
      emitOpenFeature: emitOpenFeature,
      hidePopup: hidePopup
    };
  }
};

var _withScopeId$6 = function _withScopeId(n) {
  return pushScopeId("data-v-151e935b"), n = n(), popScopeId(), n;
};

var _hoisted_1$b = ["id"];
var _hoisted_2$b = ["id"];

var _hoisted_3$b = /*#__PURE__*/_withScopeId$6(function () {
  return /*#__PURE__*/createElementVNode("div", {
    class: "content"
  }, null, -1);
});

function render$b(_ctx, _cache, $props, $setup, $data, $options) {
  var _directive_dompurify_html = resolveDirective("dompurify-html");

  return openBlock(), createElementBlock("div", {
    class: "wdw-map",
    id: $setup.id,
    style: normalizeStyle($setup.mapStyle),
    ref: "wdwMap"
  }, [createElementVNode("div", {
    class: "wdw-map-balloon",
    id: $setup.popupId
  }, [createElementVNode("a", {
    class: "close",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $setup.hidePopup();
    })
  }), _hoisted_3$b, $setup.openedFeature ? withDirectives((openBlock(), createElementBlock("button", {
    key: 0,
    type: "button",
    class: "btn btn-primary center-block my-1 infobox-button",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $setup.emitOpenFeature($setup.openedFeature);
    })
  }, null, 512)), [[_directive_dompurify_html, $setup.openedFeature.buttonTitle]]) : createCommentVNode("", true)], 8, _hoisted_2$b)], 12, _hoisted_1$b);
}

script$b.render = render$b;
script$b.__scopeId = "data-v-151e935b";

var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;







var stringSlice$1 = functionUncurryThisClause(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegexpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
_export({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString_1(requireObjectCoercible(this));
    notARegexp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString_1(searchString);
    return stringSlice$1(that, index, index + search.length) === search;
  }
});

var $RangeError = RangeError;
var fromCharCode$1 = String.fromCharCode;
// eslint-disable-next-line es/no-string-fromcodepoint -- required for testing
var $fromCodePoint = String.fromCodePoint;
var join$1 = functionUncurryThis([].join);

// length should be 1, old FF problem
var INCORRECT_LENGTH = !!$fromCodePoint && $fromCodePoint.length !== 1;

// `String.fromCodePoint` method
// https://tc39.es/ecma262/#sec-string.fromcodepoint
_export({ target: 'String', stat: true, arity: 1, forced: INCORRECT_LENGTH }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  fromCodePoint: function fromCodePoint(x) {
    var elements = [];
    var length = arguments.length;
    var i = 0;
    var code;
    while (length > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10FFFF) !== code) throw new $RangeError(code + ' is not a valid code point');
      elements[i] = code < 0x10000
        ? fromCharCode$1(code)
        : fromCharCode$1(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00);
    } return join$1(elements, '');
  }
});

var ITERATOR$1 = wellKnownSymbol('iterator');

var urlConstructorDetection = !fails(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'https://a');
  var params = url.searchParams;
  var params2 = new URLSearchParams('a=1&a=2&b=3');
  var result = '';
  url.pathname = 'c%20d';
  params.forEach(function (value, key) {
    params['delete']('b');
    result += key + value;
  });
  params2['delete']('a', 2);
  // `undefined` case is a Chromium 117 bug
  // https://bugs.chromium.org/p/v8/issues/detail?id=14222
  params2['delete']('b', undefined);
  return (isPure && (!url.toJSON || !params2.has('a', 1) || params2.has('a', 2) || !params2.has('a', undefined) || params2.has('b')))
    || (!params.size && (isPure || !descriptors))
    || !params.sort
    || url.href !== 'https://a/c%20d?a=1&c=3'
    || params.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !params[ITERATOR$1]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('https://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('https://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('https://x', undefined).host !== 'x';
});

var defineBuiltIns = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

































var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState$1 = internalState.set;
var getInternalParamsState = internalState.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = internalState.getterFor(URL_SEARCH_PARAMS_ITERATOR);

var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var TypeError$1 = globalThis_1.TypeError;
var encodeURIComponent$1 = globalThis_1.encodeURIComponent;
var fromCharCode = String.fromCharCode;
var fromCodePoint = getBuiltIn('String', 'fromCodePoint');
var $parseInt = parseInt;
var charAt = functionUncurryThis(''.charAt);
var join = functionUncurryThis([].join);
var push = functionUncurryThis([].push);
var replace = functionUncurryThis(''.replace);
var shift = functionUncurryThis([].shift);
var splice = functionUncurryThis([].splice);
var split = functionUncurryThis(''.split);
var stringSlice = functionUncurryThis(''.slice);
var exec = functionUncurryThis(/./.exec);

var plus = /\+/g;
var FALLBACK_REPLACER = '\uFFFD';
var VALID_HEX = /^[0-9a-f]+$/i;

var parseHexOctet = function (string, start) {
  var substr = stringSlice(string, start, start + 2);
  if (!exec(VALID_HEX, substr)) return NaN;

  return $parseInt(substr, 16);
};

var getLeadingOnes = function (octet) {
  var count = 0;
  for (var mask = 0x80; mask > 0 && (octet & mask) !== 0; mask >>= 1) {
    count++;
  }
  return count;
};

var utf8Decode = function (octets) {
  var codePoint = null;

  switch (octets.length) {
    case 1:
      codePoint = octets[0];
      break;
    case 2:
      codePoint = (octets[0] & 0x1F) << 6 | (octets[1] & 0x3F);
      break;
    case 3:
      codePoint = (octets[0] & 0x0F) << 12 | (octets[1] & 0x3F) << 6 | (octets[2] & 0x3F);
      break;
    case 4:
      codePoint = (octets[0] & 0x07) << 18 | (octets[1] & 0x3F) << 12 | (octets[2] & 0x3F) << 6 | (octets[3] & 0x3F);
      break;
  }

  return codePoint > 0x10FFFF ? null : codePoint;
};

var decode = function (input) {
  input = replace(input, plus, ' ');
  var length = input.length;
  var result = '';
  var i = 0;

  while (i < length) {
    var decodedChar = charAt(input, i);

    if (decodedChar === '%') {
      if (charAt(input, i + 1) === '%' || i + 3 > length) {
        result += '%';
        i++;
        continue;
      }

      var octet = parseHexOctet(input, i + 1);

      // eslint-disable-next-line no-self-compare -- NaN check
      if (octet !== octet) {
        result += decodedChar;
        i++;
        continue;
      }

      i += 2;
      var byteSequenceLength = getLeadingOnes(octet);

      if (byteSequenceLength === 0) {
        decodedChar = fromCharCode(octet);
      } else {
        if (byteSequenceLength === 1 || byteSequenceLength > 4) {
          result += FALLBACK_REPLACER;
          i++;
          continue;
        }

        var octets = [octet];
        var sequenceIndex = 1;

        while (sequenceIndex < byteSequenceLength) {
          i++;
          if (i + 3 > length || charAt(input, i) !== '%') break;

          var nextByte = parseHexOctet(input, i + 1);

          // eslint-disable-next-line no-self-compare -- NaN check
          if (nextByte !== nextByte) {
            i += 3;
            break;
          }
          if (nextByte > 191 || nextByte < 128) break;

          push(octets, nextByte);
          i += 2;
          sequenceIndex++;
        }

        if (octets.length !== byteSequenceLength) {
          result += FALLBACK_REPLACER;
          continue;
        }

        var codePoint = utf8Decode(octets);
        if (codePoint === null) {
          result += FALLBACK_REPLACER;
        } else {
          decodedChar = fromCodePoint(codePoint);
        }
      }
    }

    result += decodedChar;
    i++;
  }

  return result;
};

var find = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace(encodeURIComponent$1(it), find, replacer);
};

var URLSearchParamsIterator = iteratorCreateConstructor(function Iterator(params, kind) {
  setInternalState$1(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    target: getInternalParamsState(params).entries,
    index: 0,
    kind: kind
  });
}, URL_SEARCH_PARAMS, function next() {
  var state = getInternalIteratorState(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = null;
    return createIterResultObject(undefined, true);
  }
  var entry = target[index];
  switch (state.kind) {
    case 'keys': return createIterResultObject(entry.key, false);
    case 'values': return createIterResultObject(entry.value, false);
  } return createIterResultObject([entry.key, entry.value], false);
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt(init, 0) === '?' ? stringSlice(init, 1) : init : toString_1(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var entries = this.entries;
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;
      while (!(step = functionCall(next, iterator)).done) {
        entryIterator = getIterator(anObject(step.value));
        entryNext = entryIterator.next;
        if (
          (first = functionCall(entryNext, entryIterator)).done ||
          (second = functionCall(entryNext, entryIterator)).done ||
          !functionCall(entryNext, entryIterator).done
        ) throw new TypeError$1('Expected sequence with length 2');
        push(entries, { key: toString_1(first.value), value: toString_1(second.value) });
      }
    } else for (var key in object) if (hasOwnProperty_1(object, key)) {
      push(entries, { key: key, value: toString_1(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var entries = this.entries;
      var attributes = split(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split(attribute, '=');
          push(entries, {
            key: decode(shift(entry)),
            value: decode(join(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push(result, serialize(entry.key) + '=' + serialize(entry.value));
    } return join(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var state = setInternalState$1(this, new URLSearchParamsState(init));
  if (!descriptors) this.size = state.entries.length;
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

defineBuiltIns(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength(arguments.length, 2);
    push(state.entries, { key: toString_1(name), value: toString_1(value) });
    if (!descriptors) this.length++;
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name /* , value */) {
    var state = getInternalParamsState(this);
    var length = validateArgumentsLength(arguments.length, 1);
    var entries = state.entries;
    var key = toString_1(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : toString_1($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index];
      if (entry.key === key && (value === undefined || entry.value === value)) {
        splice(entries, index, 1);
        if (value !== undefined) break;
      } else index++;
    }
    if (!descriptors) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength(arguments.length, 1);
    var key = toString_1(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    var entries = getInternalParamsState(this).entries;
    validateArgumentsLength(arguments.length, 1);
    var key = toString_1(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name /* , value */) {
    var entries = getInternalParamsState(this).entries;
    var length = validateArgumentsLength(arguments.length, 1);
    var key = toString_1(name);
    var $value = length < 2 ? undefined : arguments[1];
    var value = $value === undefined ? $value : toString_1($value);
    var index = 0;
    while (index < entries.length) {
      var entry = entries[index++];
      if (entry.key === key && (value === undefined || entry.value === value)) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    var state = getInternalParamsState(this);
    validateArgumentsLength(arguments.length, 1);
    var entries = state.entries;
    var found = false;
    var key = toString_1(name);
    var val = toString_1(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push(entries, { key: key, value: val });
    if (!descriptors) this.size = entries.length;
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = functionBindContext(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
defineBuiltIn(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
defineBuiltIn(URLSearchParamsPrototype, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

// `URLSearchParams.prototype.size` getter
// https://github.com/whatwg/url/pull/734
if (descriptors) defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
  get: function size() {
    return getInternalParamsState(this).entries.length;
  },
  configurable: true,
  enumerable: true
});

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

_export({ global: true, constructor: true, forced: !urlConstructorDetection }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!urlConstructorDetection && isCallable(Headers)) {
  var headersHas = functionUncurryThis(HeadersPrototype.has);
  var headersSet = functionUncurryThis(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return objectCreate(init, {
          body: createPropertyDescriptor(0, toString_1(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable(nativeFetch)) {
    _export({ global: true, enumerable: true, dontCallGetSet: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    _export({ global: true, constructor: true, dontCallGetSet: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

var domain;
var bms;
'domain/' + domainStore.getState().domainid;
function fetchDomainConfig() {
  return new Promise(function (resolve, reject) {
    domainRepository.getDomainConfig().then(function (domainResponse) {
      domain = domainResponse;
      'domain/' + domain.id;
      domainRepository.getBmsDomainConfig().then(function (bmsResponse) {
        bms = bmsResponse;
        'bmsapp/' + bmsResponse.appid;
        resolve();
      }).catch(function (e) {
        return reject(e);
      });
    }).catch(function (e) {
      return reject(e);
    });
  });
}

var domainid = computed(function () {
  return domainStore.getState().domainid;
});
function useMapWizard() {
  var map = {
    baseUrl: 'http://tile.openstreetmap.org/{z}/{x}/{y}.png',
    create_marker_uri: (bms === null || bms === void 0 ? void 0 : bms.map_settings.create_marker_uri) || undefined,
    type: 'osm',
    lat: 49.870577,
    lon: 8.652393,
    zoom: 16
  };

  function getSingleMarkerLayer(messageId, domainEndpoint) {
    return {
      group: 'Marker',
      title: 'Meldung',
      opacity: 1,
      type: 'marker_overlay',
      url: domainEndpoint + '/message/' + messageId + '/item_geojson',
      visible: true,
      preventClickOnLayerFeatures: true
    };
  } // Helper function to handle additional layers


  function handleAdditionalLayers(mapSettingsSources) {
    var result = [];
    var base_url = wizardStore.getState().apiBaseUrl;

    if (base_url == '/') {
      base_url = window.location.protocol + '//' + window.location.host;
    }

    mapSettingsSources.forEach(function (s) {
      var layer_url = s.url && s.url.startsWith("https://") ? s.url : base_url + s.url;
      result.push({
        base: s.base == 1,
        format: s.format,
        group: s.group,
        opacity: s.opacity,
        style: s.style,
        title: s.title,
        type: s.type,
        url: layer_url,
        visible: s.visible == 1,
        wmsParams: s.wmsParams
      });
    });
    return result;
  } // Helper function to handle extra layers


  function handleExtraLayers(extraLayers) {
    var result = [];
    var base_url = wizardStore.getState().apiBaseUrl;

    if (base_url == '/') {
      base_url = window.location.protocol + '//' + window.location.host;
    }

    extraLayers.forEach(function (s) {
      var geojson_uri = s.geometry.geojson_uri;
      var layer_url = geojson_uri && geojson_uri.startsWith("https://") ? geojson_uri : base_url + geojson_uri;
      result.push({
        base: 0,
        format: 'geojson',
        group: 'Gebiete',
        opacity: 1,
        style: s.style,
        title: s.geometry.display_name,
        type: 'geojson_overlay',
        url: layer_url,
        visible: 1
      });
    });
    return result;
  }

  function mapConfig(theDomainEndpoint, mapsettings, defaultMarkerLayer) {
    var singleMarkerLayerId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var extraLayers = arguments.length > 4 ? arguments[4] : undefined;
    var bounds = undefined;
    var baseMapUrl = map.baseUrl,
        lat = map.lat,
        lon = map.lon,
        zoom = map.zoom,
        maxZoom = map.maxZoom,
        minZoom = map.minZoom,
        mapType = map.type,
        mapParams = map.type_parameters,
        wmsBaseLayerUrls = map.wmsBaseLayerUrls,
        attribution = map.attribution,
        cluster_message_markers = map.cluster_message_markers;

    if ('bounds' in mapsettings && mapsettings.bounds.length != 0) {
      bounds = mapsettings.bounds;
    }

    if ('position' in mapsettings) {
      if ('lat' in mapsettings.position) {
        lat = mapsettings.position.lat;
      }

      if ('lon' in mapsettings.position) {
        lon = mapsettings.position.lon;
      }
    }

    if ('zoom' in mapsettings) {
      if ('default' in mapsettings.zoom) {
        zoom = mapsettings.zoom.default;
      }

      if ('max' in mapsettings.zoom) {
        maxZoom = mapsettings.zoom.max;
      }

      if ('min' in mapsettings.zoom) {
        minZoom = mapsettings.zoom.min;
      }
    }

    if ('tiles' in mapsettings) {
      if ('url' in mapsettings.tiles && mapsettings.tiles.url) {
        baseMapUrl = mapsettings.tiles.url;
      }
    }

    if ('bounds' in mapsettings && mapsettings.bounds.length != 0) {
      bounds = mapsettings.bounds;
    }

    if ('type' in mapsettings && mapsettings.type) {
      mapType = mapsettings.type;
    }

    if ('type_parameters' in mapsettings && mapsettings.type_parameters) {
      mapParams = mapsettings.type_parameters;
    }
    /*
    if ('wms_layers_zoom_levels' in mapsettings && mapsettings.wms_layers_zoom_levels) {
        wmsZoomLevels = mapsettings.wms_layers_zoom_levels;
    }
    */


    if ('wms_base_layer_urls' in mapsettings && mapsettings.wms_base_layer_urls) {
      wmsBaseLayerUrls = mapsettings.wms_base_layer_urls;
    }

    if ('attribution' in mapsettings && mapsettings.attribution) {
      attribution = mapsettings.attribution;
    }

    if ('cluster_message_markers' in mapsettings && mapsettings.cluster_message_markers) {
      cluster_message_markers = mapsettings.cluster_message_markers;
    }

    var sources = []; // Handle base layers or fallback to default base layer
    // Handling wmsBaseLayerUrls or baseMapUrl if no other sources are present

    if (wmsBaseLayerUrls && Object.keys(wmsBaseLayerUrls).length > 0) {
      // We have multiple sources of maps.
      // order layers alphabetically by key
      var ordered_layers = Object.keys(wmsBaseLayerUrls).sort().reduce(function (result, key) {
        result[key] = wmsBaseLayerUrls[key];
        return result;
      }, {});
      Object.entries(ordered_layers).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        var baseLayer = {
          base: true,
          crossorigin: false,
          group: 'Karten',
          title: key,
          type: 'map_overlay',
          url: value.url,
          visible: true,
          attribution: attribution
        }; // siteadmin -> Mängelmelder -> Kartentyp (WMS-Karte) || wmsParams

        if (value.mapType == 'wms' || !value.mapType && mapType == 'wms' || value.wmsParams) {
          baseLayer.type = 'map_overlay_wms';
          baseLayer.wmsParams = value.wmsParams;
        } else {
          baseLayer.url = baseLayer.url.replace('${z}', '{z}');
          baseLayer.url = baseLayer.url.replace('${y}', '{y}');
          baseLayer.url = baseLayer.url.replace('${x}', '{x}');
        }

        sources.push(baseLayer);
      });
    } else {
      // No other map sources
      var baseLayer = {
        base: true,
        crossorigin: false,
        group: 'Karten',
        title: 'Basiskarte',
        type: 'map_overlay',
        url: baseMapUrl,
        visible: true,
        attribution: attribution
      };

      if (mapType == 'wms') {
        baseLayer.type = 'map_overlay_wms';
        baseLayer.wmsParams = mapParams;
      }

      if (mapType == 'xyz') {
        baseLayer.type = 'map_overlay_xyz';
        baseLayer.xyzParams = mapParams;
      } else {
        // Replace placeholders in URL if not wms or xyz type
        baseLayer.url = baseLayer.url.replace('${z}', '{z}');
        baseLayer.url = baseLayer.url.replace('${y}', '{y}');
        baseLayer.url = baseLayer.url.replace('${x}', '{x}');
      }

      sources.push(baseLayer);
    } // Handle additional layers from mapsettings


    if ('sources' in mapsettings && mapsettings.sources.length > 0) {
      sources.push.apply(sources, _toConsumableArray(handleAdditionalLayers(mapsettings.sources)));
    } // Handle extra layers if provided


    if (extraLayers !== undefined && extraLayers.length > 0) {
      sources.push.apply(sources, _toConsumableArray(handleExtraLayers(extraLayers)));
    } // Handle single marker layer if singleMarkerLayerId is provided


    if (singleMarkerLayerId && singleMarkerLayerId > 0) {
      sources.push(getSingleMarkerLayer(singleMarkerLayerId, theDomainEndpoint));
    }

    if (defaultMarkerLayer) {
      var markerLayer = {
        group: 'Marker',
        title: 'Meldungen',
        opacity: 1,
        type: 'marker_overlay',
        url: theDomainEndpoint + '/message/geojson',
        forceParams: {
          rows: 200,
          sort: '-id'
        },
        visible: true
      };
      sources.push(markerLayer);
    } else {
      var markerLayerUrl = mapsettings.marker_layer_url || "/api/v1/domain/".concat(domainid.value, "/message/geojson?sort=-created");
      var _markerLayer = {
        opacity: 1,
        type: 'marker_overlay',
        // remove /api/v1 so that it isnt double (gets added by axios)
        url: markerLayerUrl.slice(7),
        visible: true
      };
      sources.push(_markerLayer);
    }

    return {
      bounds: bounds,
      lat: lat,
      lon: lon,
      maxZoom: maxZoom,
      minZoom: minZoom,
      renderer: 'Message',
      zoom: zoom,
      sources: sources,
      cluster_message_markers: cluster_message_markers,
      create_marker_uri: map.create_marker_uri || (bms === null || bms === void 0 ? void 0 : bms.map_settings.create_marker_uri)
    };
  }

  function checkBmsAppDependencies(location) {
    var domainid = domainStore.getState().domainid;
    return new Promise(function (resolve, reject) {
      var _wizardStore$getState, _wizardStore$getState2;

      // Case with ADFC and Bremen
      var checkIndividualTypes = ((_wizardStore$getState = wizardStore.getState().config) === null || _wizardStore$getState === void 0 ? void 0 : (_wizardStore$getState2 = _wizardStore$getState.bms) === null || _wizardStore$getState2 === void 0 ? void 0 : _wizardStore$getState2.is_primary) == 0;
      var data = {
        // If domain has default == 1 and allow_default == 0
        allowNoDefault: false,
        // If a different domain should be used for this position
        differentDomain: false,
        differentDomainHref: '',
        differentDomainTitle: '',
        showNoNew: false,
        showMessageNotPossible: false
      };

      if (bms.appid) {
        domainRepository.getBmsAppDomainByQueryParams(bms.appid, _objectSpread2(_objectSpread2({}, location), {}, {
          proxy_domains: 1,
          category_fieldset: "wizard"
        })).then(function (response) {
          if (response.types && response.types.length == 0) {
            // No categories available here
            data.showMessageNotPossible = true;
          } else if (checkIndividualTypes) {
            // check we have categories for this domain
            var contains_own_types = false;
            var types = response.types;

            for (var i = 0; i < types.length; i++) {
              var type = types[i];

              if (type.domain.id == domainid) {
                contains_own_types = true;
                break;
              }
            }

            if (contains_own_types) {
              // Reset anything that has been set
              data.allowNoDefault = false;
              data.differentDomain = false;
              data.differentDomainTitle = '';
              data.differentDomainHref = '';
            } else {
              data.differentDomain = true;
              data.differentDomainTitle = response.primary_domain.name;
              data.differentDomainHref = response.primary_domain.links.web_message_create.href;
            }
          } else {
            // Check typeids as well 
            if (response.is_default && !response.allow_default) {
              data.allowNoDefault = true;
            } else if (response.primary_domain.id !== domainid) {
              data.differentDomain = true;
              data.differentDomainTitle = response.primary_domain.name;
              data.differentDomainHref = response.primary_domain.links.web_message_create.href;
            } else {
              // Reset anything that has been set
              data.allowNoDefault = false;
              data.differentDomain = false;
              data.differentDomainHref = '';
              data.differentDomainTitle = '';
            }
          }
        }).catch(function (error) {
          console.log(error);
          reject(error);
        }).finally(function () {
          resolve(data);
        });
      }
    });
  }

  function getCurrentPosition() {
    return new Promise(function (res, rej) {
      var protocol = location.protocol.slice(0, -1);

      if (protocol !== "https") {
        rej("geolocation cannot be used outside https context");
      } else if (!('geolocation' in navigator)) {
        rej("Geolocation support is not available.");
      } else {
        navigator.geolocation.getCurrentPosition(function (position) {
          res({
            lat: position.coords.latitude,
            lon: position.coords.longitude
          });
        }, function (error) {
          rej("geolocation returns error code " + error.code);
        });
      }
    });
  }

  return {
    getCurrentPosition: getCurrentPosition,
    checkBmsAppDependencies: checkBmsAppDependencies,
    mapConfig: mapConfig
  };
}

library.add(faSearch);
var script$a = {
  name: "MapSearchAddress",
  props: {
    usesStreet: {
      type: Boolean,
      default: false,
      required: false
    },
    bmsContext: {
      type: Boolean,
      default: false,
      required: false
    },
    canSkipPosition: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  components: {
    SelectComp: script$g
  },
  emits: ["addressCoordinatesReceived", "positionSkipped"],
  setup: function setup(props, context) {
    var messageInformation = ref({
      text: '',
      severity: 'warning'
    });
    var address = ref("");
    var housenum = ref('');
    var toggleMessage = ref(false);
    var domainid = domainStore.getState().domainid; //functions

    function selectedElem(event) {
      address.value = event.value;
    }

    function focusResultMessage() {
      var elem = document.getElementById("map-search-addr-message");

      if (elem) {
        elem.scrollIntoView({
          behavior: "smooth"
        });
        elem.focus();
      }
    }

    function searchAddress() {
      toggleMessage.value = false;
      var addrInput = address.value;

      if (props.usesStreet) {
        addrInput = address.value.replace(',', ' ' + housenum.value + ', ');
      }

      domainRepository.searchAddress(addrInput).then(function (response) {
        var apiData = response.data.data;
        var emitItem;
        var locationData;
        var queryAddress; //check if we get results

        if (apiData.status != 'ZERO_RESULTS' && apiData.results && apiData.results.length > 0) {
          queryAddress = apiData.results[0].formatted_address; // check if results are approximated or not

          if (apiData.is_approximate) {
            messageInformation.value = {
              severity: 'warning',
              text: 'Die von Ihnen eingegebene Adresse konnte möglicherweise nicht gefunden werden.' + ' Die Meldung wird an der Adresse ' + queryAddress + ' platziert.' + ' Zur Änderung der Position geben Sie bitte eine andere Adresse über das Suchfeld ein,' + ' oder setzen Sie die Markerposition manuell über die Karte.'
            };
            toggleMessage.value = true;
            focusResultMessage();
          } //assign correct values and emit if its correct


          locationData = apiData.results[0].geometry.location;
          emitItem = {
            query: address.value,
            lon: locationData.lng,
            lat: locationData.lat,
            zoom: 18
          };
          context.emit('addressCoordinatesReceived', emitItem);
        } else {
          messageInformation.value = {
            severity: 'danger',
            text: 'Die eingegebene Adresse konnte leider nicht gefunden werden.'
          };
          toggleMessage.value = true;
          focusResultMessage();
        }
      });
    }

    var streetSearchSelect2AdditionalSettings = computed(function () {
      return {
        // This is Select2's AJAX property
        ajax: {
          delay: 500,
          transport: function transport(params, success, failure) {
            var term = params.data.term;
            if (term == undefined || term == "" || term.length < 2) return null;
            var api = domainRepository.getStreets(domainid, term);
            api.then(success);
            api.catch(failure);
            return api;
          },
          processResults: function processResults(response) {
            var results = response.streets.map(function (e) {
              return {
                id: e.street,
                text: e.street
              };
            });
            return {
              results: results
            };
          }
        },
        templateResult: function templateResult(item) {
          var parent = document.createElement("div");
          parent.innerHTML = item.text;
          return parent;
        }
      };
    });
    /*
    onMounted(() => {
        if (props.usesStreet) {
            const domainid = domainStore.getState().domainid;
            if (domainid) {
                domainRepository.getStreets(domainid).then(res => {
                    streetsName.value = res.streets.map((element: any) => {
                        return { id: element.id, text: element.street };
                    });
                });
            }
        }
    });
    */

    return {
      streetSearchSelect2AdditionalSettings: streetSearchSelect2AdditionalSettings,
      housenum: housenum,
      address: address,
      toggleMessage: toggleMessage,
      messageInformation: messageInformation,
      selectedElem: selectedElem,
      searchAddress: searchAddress
    };
  }
};

var _hoisted_1$a = ["placeholder"];

var _hoisted_2$a = /*#__PURE__*/createTextVNode(" Meldung hat keine Position ");

var _hoisted_3$a = {
  key: 0,
  id: "map-search-addr-message"
};
function render$a(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_SelectComp = resolveComponent("SelectComp");

  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  return openBlock(), createElementBlock(Fragment, null, [createElementVNode("div", {
    class: normalizeClass(["wdw-map-search-address search-wrapper-elem d-flex justify-content-start", {
      'bms-context': $props.bmsContext
    }])
  }, [$props.usesStreet ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [createVNode(_component_SelectComp, {
    name: "streets",
    typeable: true,
    "allow-clear": true,
    class: "streets",
    "additional-settings": $setup.streetSearchSelect2AdditionalSettings,
    onSelected: _cache[0] || (_cache[0] = function ($event) {
      return $setup.selectedElem($event);
    })
  }, null, 8, ["additional-settings"]), withDirectives(createElementVNode("input", {
    type: "text",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $setup.housenum = $event;
    }),
    class: "house-number form-control me-2",
    placeholder: "Haus Nr.",
    "aria-label": "Suchen",
    "aria-describedby": "search-button"
  }, null, 512), [[vModelText, $setup.housenum]])], 64)) : withDirectives((openBlock(), createElementBlock("input", {
    key: 1,
    type: "text",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $setup.address = $event;
    }),
    onKeyup: _cache[3] || (_cache[3] = withKeys(function ($event) {
      return $setup.searchAddress();
    }, ["enter"])),
    class: "address-search-input form-control me-2",
    placeholder: $props.bmsContext ? 'Straße, Hausnummer und Ort eingeben' : 'Suchen',
    "aria-label": "Suchen",
    "aria-describedby": "search-button"
  }, null, 40, _hoisted_1$a)), [[vModelText, $setup.address]]), createElementVNode("button", {
    onClick: _cache[4] || (_cache[4] = function ($event) {
      return $setup.searchAddress();
    }),
    class: "btn btn-primary btn-search-button",
    id: "search-button"
  }, [createVNode(_component_font_awesome_icon, {
    icon: "search"
  })]), $props.canSkipPosition ? (openBlock(), createElementBlock("button", {
    key: 2,
    class: "btn mx-2 btn-secondary no-address",
    onClick: _cache[5] || (_cache[5] = function ($event) {
      return _ctx.$emit('positionSkipped');
    })
  }, [createVNode(_component_font_awesome_icon, {
    icon: ['fas', 'location-dot']
  }), _hoisted_2$a])) : createCommentVNode("", true)], 2), $setup.toggleMessage ? (openBlock(), createElementBlock("div", _hoisted_3$a, [createElementVNode("div", {
    class: normalizeClass('popup-message wdw-map-search-address alert alert-' + $setup.messageInformation.severity)
  }, toDisplayString($setup.messageInformation.text), 3)])) : createCommentVNode("", true)], 64);
}

script$a.render = render$a;
script$a.__scopeId = "data-v-15fb6209";

var script$9 = {
  name: "WizardStepPosition",
  props: {
    showAddressSearch: {
      required: false,
      default: true
    }
  },
  emits: ["selection", "nextStep", "returnToOverview"],
  components: {
    OlMap: script$b,
    Loading: script$f,
    MapSearchAddress: script$a
  },
  setup: function setup(props, context) {
    var _useMapWizard = useMapWizard(),
        mapConfig = _useMapWizard.mapConfig,
        checkBmsAppDependencies = _useMapWizard.checkBmsAppDependencies; // +----------------+
    // |   Variables    |
    // +----------------+


    var bmsDependencies = ref({});
    var theDomainEndpoint = domainEndpoint();
    var olMapRef = ref(); // +----------------+
    // |    Computed    |
    // +----------------+

    var domainid = computed(function () {
      return domainStore.getState().domainid;
    });
    var initial_lat = computed(function () {
      return wizardStore.getState().initial_lat;
    });
    var initial_lon = computed(function () {
      return wizardStore.getState().initial_lon;
    });
    var skipPosition = computed(function () {
      var _wizardStore$getState;

      return ((_wizardStore$getState = wizardStore.getState().config) === null || _wizardStore$getState === void 0 ? void 0 : _wizardStore$getState.allow_skip_position) || wizardStore.isUserAnAdmin();
    });
    var wizardLoading = computed(function () {
      return wizardStore.getState().loading;
    });
    var positionOutOfAppArea = computed(function () {
      return bmsDependencies.value.differentDomain;
    });
    var messageNotAllowedHere = computed(function () {
      return bmsDependencies.value.showMessageNotPossible;
    });
    var wizardBmsMapConfig = computed(function () {
      return wizardStore.getState().config.bms.map;
    });
    var wizardUseStreetDir = computed(function () {
      var _wizardStore$getState2;

      return (_wizardStore$getState2 = wizardStore.getState().config) === null || _wizardStore$getState2 === void 0 ? void 0 : _wizardStore$getState2.use_street_directory;
    }); // +----------------+
    // |    Methods     |
    // +----------------+

    function onMapClicked(newPosition) {
      var storeUserEntrys = wizardStore.getState().userEntrys;

      if (!storeUserEntrys || storeUserEntrys.lat !== newPosition.lat || storeUserEntrys.lon !== newPosition.lon) {
        wizardStore.setLoading(true);
        wizardStore.setLatLon(newPosition);
        wizardStore.setAddressSearchText(""); // Remove the last search text

        duplicateStore.setParameters([{
          key: 'position',
          value: newPosition
        }]);
        checkBmsAppDependencies(newPosition).then(function (res) {
          bmsDependencies.value = res;
          context.emit('selection', !positionOutOfAppArea.value && !messageNotAllowedHere.value);
        }).finally(function () {
          return wizardStore.setLoading(false);
        });
      }

      if (storeUserEntrys && storeUserEntrys.lat == newPosition.lat && storeUserEntrys.lon == newPosition.lon) {
        context.emit('selection', true);
      }
    }

    function addressCoordinates(data) {
      olMapRef.value.handleClickOnMapWithCoordinates({
        lat: data.lat,
        lon: data.lon,
        zoom: 20
      }, true);
      wizardStore.setAddressSearch(data);
      onMapClicked(data);
    }

    function noPosition() {
      wizardStore.removePositon();
      context.emit('nextStep');
    }

    function onFeatureClicked(feature) {
      var messageid = feature.id;
      window.open("/bms/" + messageid, "_blank");
    } // +----------------+
    // |   Lifecycle    |
    // +----------------+


    onMounted(function () {
      var _wizardStore$getState3;

      if ((_wizardStore$getState3 = wizardStore.getState().config) !== null && _wizardStore$getState3 !== void 0 && _wizardStore$getState3.auto_location_request) {
        var _olMapRef$value;

        // Automatically ask for user location
        (_olMapRef$value = olMapRef.value) === null || _olMapRef$value === void 0 ? void 0 : _olMapRef$value.mapLocate();
      }
    });
    onUnmounted(function () {
      wizardStore.updateInitialLatLon();
    });
    return {
      olMapRef: olMapRef,
      theDomainEndpoint: theDomainEndpoint,
      domainid: domainid,
      initial_lat: initial_lat,
      initial_lon: initial_lon,
      skipPosition: skipPosition,
      wizardLoading: wizardLoading,
      wizardBmsMapConfig: wizardBmsMapConfig,
      wizardUseStreetDir: wizardUseStreetDir,
      positionOutOfAppArea: positionOutOfAppArea,
      messageNotAllowedHere: messageNotAllowedHere,
      bmsDependencies: bmsDependencies,
      mapConfig: mapConfig,
      onMapClicked: onMapClicked,
      addressCoordinates: addressCoordinates,
      noPosition: noPosition,
      onFeatureClicked: onFeatureClicked
    };
  }
};

var _withScopeId$5 = function _withScopeId(n) {
  return pushScopeId("data-v-e9af183c"), n = n(), popScopeId(), n;
};

var _hoisted_1$9 = {
  id: "wdw-map-wizard"
};
var _hoisted_2$9 = {
  key: 1,
  class: "map-overlay"
};
var _hoisted_3$9 = {
  key: 0,
  class: "alert alert-info position-relative"
};

var _hoisted_4$8 = /*#__PURE__*/_withScopeId$5(function () {
  return /*#__PURE__*/createElementVNode("div", {
    class: "my-1",
    id: "wdw-bms-map-location-result",
    role: "alert",
    tabindex: "0"
  }, null, -1);
});

var _hoisted_5$8 = {
  key: 1,
  class: "alert alert-warning position-relative"
};

var _hoisted_6$5 = /*#__PURE__*/createTextVNode(" Die von Ihnen gewählte Position befindet sich außerhalb des Geltungsbereichs dieses Systems. Bitte prüfen Sie Ihre Angaben. ");

var _hoisted_7$5 = /*#__PURE__*/_withScopeId$5(function () {
  return /*#__PURE__*/createElementVNode("br", null, null, -1);
});

var _hoisted_8$5 = /*#__PURE__*/createTextVNode(" Zuständiges Kundensystem: ");

var _hoisted_9$5 = ["href"];
function render$9(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_OlMap = resolveComponent("OlMap");

  var _component_MapSearchAddress = resolveComponent("MapSearchAddress");

  var _component_Loading = resolveComponent("Loading");

  return openBlock(), createElementBlock(Fragment, null, [createElementVNode("div", _hoisted_1$9, [$setup.theDomainEndpoint && $setup.domainid ? (openBlock(), createBlock(_component_OlMap, {
    key: 0,
    ref: "olMapRef",
    customButtonRenderer: "bmsBoard",
    config: $setup.mapConfig($setup.theDomainEndpoint, $setup.wizardBmsMapConfig),
    setMarkerAllowed: true,
    domainid: $setup.domainid,
    initial_lat: $setup.initial_lat,
    initial_lon: $setup.initial_lon,
    refetchMessages: true,
    "use-device-location": true,
    onOpenFeature: $setup.onFeatureClicked,
    onNewMarkerPosition: $setup.onMapClicked
  }, null, 8, ["config", "domainid", "initial_lat", "initial_lon", "onOpenFeature", "onNewMarkerPosition"])) : createCommentVNode("", true), $props.showAddressSearch ? (openBlock(), createElementBlock("div", _hoisted_2$9, [createVNode(_component_MapSearchAddress, {
    "bms-context": true,
    usesStreet: $setup.wizardUseStreetDir,
    "can-skip-position": $setup.skipPosition,
    onAddressCoordinatesReceived: $setup.addressCoordinates,
    onPositionSkipped: $setup.noPosition
  }, null, 8, ["usesStreet", "can-skip-position", "onAddressCoordinatesReceived", "onPositionSkipped"])])) : createCommentVNode("", true)]), createElementVNode("div", null, [$setup.wizardLoading ? (openBlock(), createBlock(_component_Loading, {
    key: 0,
    spinnerStyle: "width: 35px; height: 35px;",
    "loading-message": "Position validieren..."
  })) : createCommentVNode("", true)]), $setup.messageNotAllowedHere ? (openBlock(), createElementBlock("div", _hoisted_3$9, " Die angegebene Position befindet sich außerhalb des zulässigen Bereichs. An dieser Position kann keine Meldung erstellt werden. ")) : createCommentVNode("", true), _hoisted_4$8, $setup.positionOutOfAppArea && !$setup.wizardLoading ? (openBlock(), createElementBlock("div", _hoisted_5$8, [_hoisted_6$5, $setup.bmsDependencies.differentDomainHref ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [_hoisted_7$5, _hoisted_8$5, createElementVNode("a", {
    href: $setup.bmsDependencies.differentDomainHref
  }, toDisplayString($setup.bmsDependencies.differentDomainTitle ? $setup.bmsDependencies.differentDomainTitle : $setup.bmsDependencies.differentDomainHref), 9, _hoisted_9$5)], 64)) : createCommentVNode("", true)])) : createCommentVNode("", true)], 64);
}

script$9.render = render$9;
script$9.__scopeId = "data-v-e9af183c";

// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it


var arrayBufferNonExtensible = fails(function () {
  if (typeof ArrayBuffer == 'function') {
    var buffer = new ArrayBuffer(8);
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', { value: 8 });
  }
});

// eslint-disable-next-line es/no-object-isextensible -- safe
var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails(function () { $isExtensible(1); });

// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
var objectIsExtensible = (FAILS_ON_PRIMITIVES || arrayBufferNonExtensible) ? function isExtensible(it) {
  if (!isObject(it)) return false;
  if (arrayBufferNonExtensible && classofRaw(it) === 'ArrayBuffer') return false;
  return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;

var freezing = !fails(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});

var internalMetadata = createCommonjsModule(function (module) {





var defineProperty = objectDefineProperty.f;






var REQUIRED = false;
var METADATA = uid('meta');
var id = 0;

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + id++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!hasOwnProperty_1(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!objectIsExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!hasOwnProperty_1(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!objectIsExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (freezing && REQUIRED && objectIsExtensible(it) && !hasOwnProperty_1(it, METADATA)) setMetadata(it);
  return it;
};

var enable = function () {
  meta.enable = function () { /* empty */ };
  REQUIRED = true;
  var getOwnPropertyNames = objectGetOwnPropertyNames.f;
  var splice = functionUncurryThis([].splice);
  var test = {};
  test[METADATA] = 1;

  // prevent exposing of metadata key
  if (getOwnPropertyNames(test).length) {
    objectGetOwnPropertyNames.f = function (it) {
      var result = getOwnPropertyNames(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice(result, i, 1);
          break;
        }
      } return result;
    };

    _export({ target: 'Object', stat: true, forced: true }, {
      getOwnPropertyNames: objectGetOwnPropertyNamesExternal.f
    });
  }
};

var meta = module.exports = {
  enable: enable,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;
});

var collection = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = globalThis_1[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var uncurriedNativeMethod = functionUncurryThis(NativePrototype[KEY]);
    defineBuiltIn(NativePrototype, KEY,
      KEY === 'add' ? function add(value) {
        uncurriedNativeMethod(this, value === 0 ? 0 : value);
        return this;
      } : KEY === 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY === 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY === 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced_1(
    CONSTRUCTOR_NAME,
    !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    internalMetadata.enable();
  } else if (isForced_1(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, NativePrototype);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  _export({ global: true, constructor: true, forced: Constructor !== NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};

var fastKey = internalMetadata.fastKey;


var setInternalState = internalState.set;
var internalStateGetterFor = internalState.getterFor;

var collectionStrong = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: objectCreate(null),
        first: null,
        last: null,
        size: 0
      });
      if (!descriptors) that.size = 0;
      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: null,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (descriptors) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key === key) return entry;
      }
    };

    defineBuiltIns(Prototype, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = null;
          entry = entry.next;
        }
        state.first = state.last = null;
        state.index = objectCreate(null);
        if (descriptors) state.size = 0;
        else that.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first === entry) state.first = next;
          if (state.last === entry) state.last = prev;
          if (descriptors) state.size--;
          else that.size--;
        } return !!entry;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = functionBindContext(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    defineBuiltIns(Prototype, IS_MAP ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (descriptors) defineBuiltInAccessor(Prototype, 'size', {
      configurable: true,
      get: function () {
        return getInternalState(this).size;
      }
    });
    return Constructor;
  },
  setStrong: function (Constructor, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
    // https://tc39.es/ecma262/#sec-map.prototype.entries
    // https://tc39.es/ecma262/#sec-map.prototype.keys
    // https://tc39.es/ecma262/#sec-map.prototype.values
    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
    // https://tc39.es/ecma262/#sec-set.prototype.entries
    // https://tc39.es/ecma262/#sec-set.prototype.keys
    // https://tc39.es/ecma262/#sec-set.prototype.values
    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
    iteratorDefine(Constructor, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: null
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = null;
        return createIterResultObject(undefined, true);
      }
      // return step by kind
      if (kind === 'keys') return createIterResultObject(entry.key, false);
      if (kind === 'values') return createIterResultObject(entry.value, false);
      return createIterResultObject([entry.key, entry.value], false);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // `{ Map, Set }.prototype[@@species]` accessors
    // https://tc39.es/ecma262/#sec-get-map-@@species
    // https://tc39.es/ecma262/#sec-get-set-@@species
    setSpecies(CONSTRUCTOR_NAME);
  }
};

// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
collection('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);

var script$8 = {
  name: "WizardCategoryGroupWrapper",
  emits: ["groupOpened", "groupClosed"],
  props: {
    open: {
      required: false,
      type: Boolean,
      default: false
    },
    group: {
      required: true,
      type: Object,
      default: function _default() {
        return {};
      }
    },
    singlecolumn: {
      required: false,
      type: Boolean,
      default: false
    },
    parentId: {
      required: false,
      type: String,
      default: "wdw-bms-category-groups"
    }
  },
  setup: function setup(props) {
    var _getCurrentInstance;

    var uid = (_getCurrentInstance = getCurrentInstance()) === null || _getCurrentInstance === void 0 ? void 0 : _getCurrentInstance.uid;
    var parentClass = computed(function () {
      return props.singlecolumn ? 'col-sm-12' : 'col-md-6';
    });
    var groupId = computed(function () {
      return 'category-group-' + uid;
    });
    var headingId = computed(function () {
      return 'category-group-heading-' + uid;
    });
    var bodyId = computed(function () {
      return 'category-group-body-' + uid;
    });
    var panelHeadingClass = computed(function () {
      return {
        'panel-heading': true,
        'collapsed': !props.open
      };
    });
    var bodyClass = computed(function () {
      return {
        'panel-collapse': true,
        'collapse': true,
        'show': props.open
      };
    });

    var togglePanel = function togglePanel() {
      var parent = document.getElementById(props.parentId);
      var collapsibles = parent === null || parent === void 0 ? void 0 : parent.querySelectorAll(".panel-collapse");

      if (collapsibles) {
        for (var i = 0; i < (collapsibles === null || collapsibles === void 0 ? void 0 : collapsibles.length); i++) {
          var elem = collapsibles.item(i);
          var elemGroupHeaderId = elem.getAttribute("data-groupid");
          var panelHeading = document.getElementById(elemGroupHeaderId);

          if ((elem === null || elem === void 0 ? void 0 : elem.id) == bodyId.value) {
            if (elem.classList.contains("show")) {
              panelHeading === null || panelHeading === void 0 ? void 0 : panelHeading.classList.add("collapsed");
              elem.classList.remove("show");
            } else {
              panelHeading === null || panelHeading === void 0 ? void 0 : panelHeading.classList.remove("collapsed");
              elem === null || elem === void 0 ? void 0 : elem.classList.add("show");
            }
          } else {
            panelHeading === null || panelHeading === void 0 ? void 0 : panelHeading.classList.add("collapsed");
            elem.classList.remove("show");
          }
        }
      }
    };

    var onPanelClicked = function onPanelClicked() {
      togglePanel();
    };

    var onPanelClickedEnterBtn = function onPanelClickedEnterBtn() {
      togglePanel();
    };

    return {
      groupId: groupId,
      parentClass: parentClass,
      headingId: headingId,
      bodyId: bodyId,
      bodyClass: bodyClass,
      panelHeadingClass: panelHeadingClass,
      onPanelClicked: onPanelClicked,
      onPanelClickedEnterBtn: onPanelClickedEnterBtn
    };
  }
};

var _hoisted_1$8 = ["id"];
var _hoisted_2$8 = ["id", "aria-controls", "data-target"];
var _hoisted_3$8 = {
  role: "button"
};
var _hoisted_4$7 = {
  class: "panel-title"
};
var _hoisted_5$7 = ["id", "data-groupid", "aria-labelledby"];
function render$8(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass($setup.parentClass)
  }, [createElementVNode("div", {
    class: "panel-group",
    id: $setup.groupId,
    role: "tablist",
    "aria-multiselectable": "true"
  }, [createElementVNode("div", {
    class: "panel panel-default",
    tabindex: "0",
    onClick: _cache[0] || (_cache[0] = function () {
      return $setup.onPanelClicked && $setup.onPanelClicked.apply($setup, arguments);
    }),
    onKeyup: _cache[1] || (_cache[1] = withKeys(function () {
      return $setup.onPanelClickedEnterBtn && $setup.onPanelClickedEnterBtn.apply($setup, arguments);
    }, ["enter"]))
  }, [createElementVNode("div", {
    class: normalizeClass($setup.panelHeadingClass),
    role: "tab",
    id: $setup.headingId,
    "data-toggle": "collapse",
    "aria-expanded": "false",
    "aria-controls": $setup.bodyId,
    "data-target": '#' + $setup.bodyId
  }, [createElementVNode("a", _hoisted_3$8, [createElementVNode("h4", _hoisted_4$7, toDisplayString($props.group.title), 1)])], 10, _hoisted_2$8)], 32)], 8, _hoisted_1$8), createElementVNode("div", {
    id: $setup.bodyId,
    class: normalizeClass($setup.bodyClass),
    role: "tabpanel",
    "data-groupid": $setup.headingId,
    "aria-labelledby": $setup.headingId
  }, [createElementVNode("div", null, [renderSlot(_ctx.$slots, "default")])], 10, _hoisted_5$7)], 2);
}

script$8.render = render$8;

var script$7 = {
  name: "WizardStepCategoryEntry",
  props: {
    underCategory: {
      required: true,
      type: Object
    },
    id: {
      required: true,
      type: Number
    },
    can_interact: {
      type: Boolean,
      default: true
    },
    overCategory: {
      type: String,
      required: false,
      default: undefined
    }
  },
  emits: ['categorySelected', 'returnToOverview'],
  setup: function setup(props, context) {
    var setSelected = ref(false); // +----------------+
    // |    Computed    |
    // +----------------+

    var selected = computed(function () {
      return setSelected.value;
    });
    var wrapperClassObject = computed(function () {
      return {
        panel: true,
        'panel-default': true,
        media: true,
        'wizard-category-item': true,
        selected: props.can_interact ? selected.value : false
      };
    });
    var markerClassObject = computed(function () {
      var markerClassObject = {
        'bms-marker': true
      };

      if (props.underCategory) {
        markerClassObject[props.underCategory.marker_class] = true;
      }

      return markerClassObject;
    }); // +----------------+
    // |   Functions    |
    // +----------------+

    function setCategorySelected(value, id) {
      if (value && !setSelected.value) context.emit('categorySelected', props.underCategory); // Don't setSelected on category with external_uri
      // the external uri will be opened by WizardStepCategory.vue

      setCategorySelectedDisplay(value, id);
    }

    function setCategorySelectedDisplay(value, id) {
      // Don't setSelected on category with external_uri
      // the external uri will be opened by WizardStepCategory.vue
      if (!props.underCategory.external_uri || props.underCategory.external_uri == "") {
        if (id && props.underCategory.id) {
          if (id == props.underCategory.id) {
            setSelected.value = value;
          }
        } else {
          setSelected.value = value;
        }
      }
    }

    context.expose({
      setCategorySelected: setCategorySelected,
      setCategorySelectedDisplay: setCategorySelectedDisplay,
      id: props.underCategory.id,
      overCategory: props.overCategory,
      rubric: props.underCategory.rubric // isPreSelected: props.selected

    });
    return {
      wrapperClassObject: wrapperClassObject,
      markerClassObject: markerClassObject,
      setCategorySelected: setCategorySelected
    };
  }
};

var _hoisted_1$7 = ["id"];
var _hoisted_2$7 = {
  class: "media-left media-middle"
};
var _hoisted_3$7 = {
  class: "media-body media-middle pe-3"
};
var _hoisted_4$6 = ["textContent"];
var _hoisted_5$6 = ["innerHTML"];
function render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    id: String($props.id),
    class: normalizeClass($setup.wrapperClassObject),
    tabindex: "0",
    role: "button",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $setup.setCategorySelected(true);
    }),
    onKeyup: _cache[1] || (_cache[1] = withKeys(function ($event) {
      return $setup.setCategorySelected(true);
    }, ["enter"]))
  }, [createElementVNode("div", _hoisted_2$7, [createElementVNode("div", {
    class: normalizeClass($setup.markerClassObject),
    style: normalizeStyle([{
      "width": "38px",
      "height": "48px"
    }, $props.underCategory ? $props.underCategory.marker_url_css_var : ''])
  }, null, 6)]), createElementVNode("div", _hoisted_3$7, [createElementVNode("h4", {
    class: "media-heading category-heading",
    textContent: toDisplayString($props.underCategory ? $props.underCategory.name : '')
  }, null, 8, _hoisted_4$6), $props.underCategory && $props.underCategory.description ? (openBlock(), createElementBlock("span", {
    key: 0,
    class: "category-description",
    innerHTML: $props.underCategory.description
  }, null, 8, _hoisted_5$6)) : createCommentVNode("", true)])], 42, _hoisted_1$7);
}

script$7.render = render$7;
script$7.__scopeId = "data-v-75fee568";

var script$6 = {
  name: "WizardStepCategory",
  emits: ['selection', 'returnToOverview', 'nextStep'],
  props: {},
  components: {
    TabView: TabView,
    TabPanel: TabPanel,
    Dialog: Dialog,
    SelectComp: script$g,
    WizardStepCategoryGroupWrapper: script$8,
    WizardStepCategoryEntry: script$7
  },
  // @ts-ignore
  setup: function setup(props, context) {
    var _wizardStore$getState;

    // initialize categorys
    wizardStore.getCategorys(); // +----------------+
    // |   Variables    |
    // +----------------+

    var categoryRefs = ref([]); // fix for Refs inside v-for Loop source:  https://stackoverflow.com/a/71417860

    var skipUnwrap = {
      itemRefs: categoryRefs
    };
    var categorySearchRef = ref(null);
    var activeAccordion = ref();
    var activeTabView = ref();
    var activeTabViewSet = ref(false);
    var canShowInfopageForCategory = ref(false);
    var showExternalUriInformation = ref(false);
    var lastSelectedCategory = ref();
    var isSingleColumn = ref((_wizardStore$getState = wizardStore.getState().config) === null || _wizardStore$getState === void 0 ? void 0 : _wizardStore$getState.single_column_categories); // +----------------+
    // |    Computed    |
    // +----------------+

    var config = computed(function () {
      return wizardStore.getState().config;
    });
    var categorys = computed(function () {
      return wizardStore.getState().categorys;
    });
    var enableCategorySearch = computed(function () {
      var _wizardStore$getState2;

      return (_wizardStore$getState2 = wizardStore.getState().config) === null || _wizardStore$getState2 === void 0 ? void 0 : _wizardStore$getState2.BmsEnableTypeKeywords;
    });
    var overAndUnderCategorys = computed(function () {
      return wizardStore.getState().overAndUnderCategory;
    });
    var rubrics = computed(function () {
      var uniqueRubrics = Array.from(new Set(categorys.value.map(function (category) {
        var rubric = category.items[0].rubric;

        if (rubric !== null) {
          return rubric;
        }
      })));
      return uniqueRubrics.filter(function (rubric) {
        return rubric !== undefined;
      });
    });
    var categorySearchAdditionalSettings = computed(function () {
      return {
        // This is Select2's AJAX property
        ajax: {
          delay: 500,
          transport: function transport(params, success, failure) {
            var term = params.data.term;
            if (term == undefined || term == "") return null;
            var api = categoryRepository.getCategoriesByKeyword(term, {
              fields: "id,name,marker_url,external_uri,description"
            });
            api.then(success);
            api.catch(failure);
            return api;
          },
          processResults: function processResults(response) {
            var results = response.map(function (e) {
              return {
                id: e.id,
                text: e.name,
                marker_url: e.marker_url,
                description: e.description,
                external_uri: e.external_uri
              };
            });
            return {
              results: results
            };
          }
        },
        templateResult: function templateResult(item) {
          var parent = document.createElement("div");
          parent.setAttribute("aria-label", item.text + ". " + item.description);
          parent.style.paddingLeft = "5px";
          parent.style.display = "flex";
          var iconParent = document.createElement("div");
          var markerImg = document.createElement("img");

          if (item.marker_url) {
            markerImg.setAttribute("src", item.marker_url);
            iconParent.appendChild(markerImg);
          }

          var textParent = document.createElement("div");
          textParent.style.paddingLeft = "10px";
          var title = document.createElement("div");
          title.innerHTML = "<b>" + (item.text || "") + "</b>";
          var desc = document.createElement("div");
          desc.classList.add("text-small");
          desc.innerHTML = item.description || "";
          textParent.appendChild(title);
          textParent.appendChild(desc);
          parent.appendChild(iconParent);
          parent.appendChild(textParent);
          return parent;
        }
      };
    }); // +----------------+
    // |    Methods     |
    // +----------------+

    function categoryRemovedFromSearch() {
      lastSelectedCategory.value = undefined;
      categoryRefs.value.forEach(function (categoryRef) {
        categoryRef.setCategorySelectedDisplay(false);
      });
      duplicateStore.setParameters([{
        key: 'typeid',
        value: 0
      }]);
      context.emit('selection', false);
    }

    function newCategorySelected(newCategory) {
      var fromSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      lastSelectedCategory.value = newCategory;

      if (newCategory.external_uri != null && newCategory.external_uri != "") {
        // if it has external uri, show confirmation on opening external uri
        showExternalUriInformation.value = true;
        return;
      }

      wizardStore.getCategory(newCategory.id);
      categoryRefs.value.forEach(function (categoryRef) {
        // If category is selected from category search, we only need the category item display being highlighted
        // without triggering emitter
        if (fromSearch) {
          categoryRef.setCategorySelectedDisplay(newCategory.id == categoryRef.id);
        } else {
          categoryRef.setCategorySelected(false);
        }
      });
      duplicateStore.setParameters([{
        key: 'typeid',
        value: newCategory.id
      }]);

      if (newCategory.infopage && newCategory.infopage.content != "") {
        // Category has infopage? Show it first before committing
        canShowInfopageForCategory.value = true;
        return;
      }

      context.emit('selection', newCategory, fromSearch ? "category_selected_from_search" : "");
    }

    function onCategoryFromSearchSelected(item) {
      var id = item.value;
      var selectedCategory = undefined;

      var _iterator = _createForOfIteratorHelper(categorys.value),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var group = _step.value;
          selectedCategory = group.items.find(function (x) {
            return x.id == id;
          });

          if (selectedCategory !== undefined) {
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (selectedCategory) {
        updateActiveAccordion(selectedCategory);
        newCategorySelected(selectedCategory, true);
      } else {
        // Nothing selected? We assume the user removed it
        categoryRemovedFromSearch();
      }
    }

    function onCategoryInfopageConfirm() {
      canShowInfopageForCategory.value = false;
      context.emit('selection', lastSelectedCategory);
    }

    function onExternalUriConfirm() {
      showExternalUriInformation.value = false;

      if (lastSelectedCategory.value != null && lastSelectedCategory.value.external_uri) {
        var _lastSelectedCategory;

        window.open((_lastSelectedCategory = lastSelectedCategory.value) === null || _lastSelectedCategory === void 0 ? void 0 : _lastSelectedCategory.external_uri, "_blank");
      }
    }

    function onExternalUriCancel() {
      var _categorySearchRef$va;

      showExternalUriInformation.value = false;
      (_categorySearchRef$va = categorySearchRef.value) === null || _categorySearchRef$va === void 0 ? void 0 : _categorySearchRef$va.resetSelect();
    }

    function setActiveRubric(rubric) {
      if (!rubric) return;
      activeTabView.value = rubrics.value.findIndex(function (ele) {
        return ele == rubric;
      });
      activeTabViewSet.value = true;
    }

    function updateActiveAccordion(category) {
      if (category == null) {
        categoryRefs.value.forEach(function (c) {
          c.setCategorySelected(false);
        });
      } else {
        var items = categoryRefs.value.find(function (element) {
          return element.id == (category === null || category === void 0 ? void 0 : category.id);
        });
        items === null || items === void 0 ? void 0 : items.setCategorySelected(true);

        if (overAndUnderCategorys.value) {
          activeAccordion.value = categorys.value.findIndex(function (ele) {
            return ele.items.some(function (el) {
              return el.id === (category === null || category === void 0 ? void 0 : category.id);
            });
          });
        }
      }
    }

    function doAssignMultiColumnClassToAccordionTabs() {
      // For accordion only:
      // If multi-column, we need to programmatically add "col-md-6" to accordion tabs 
      // since the tabs don't capture "class" parameter
      if (!isSingleColumn.value) {
        var accordionGroup = document.getElementById("category-accordion");

        if (accordionGroup) {
          var tabs = accordionGroup.getElementsByClassName("p-accordion-tab");

          for (var i = 0; i < tabs.length; i++) {
            var _tabs$item;

            (_tabs$item = tabs.item(i)) === null || _tabs$item === void 0 ? void 0 : _tabs$item.classList.add("col-md-6");
          }
        }
      }
    }

    function onCategoryTabToggled() {
      doAssignMultiColumnClassToAccordionTabs();
    } // +----------------+
    // |   Lifecycle    |
    // +----------------+


    onMounted(function () {
      var _preselectedCategory$;

      var preselectedRubric = wizardStore.getState().selected_rubric;
      var preselectedCategory = wizardStore.getState().category; // react to "selected_rubric"

      if (preselectedRubric || preselectedCategory) setActiveRubric((_preselectedCategory$ = preselectedCategory === null || preselectedCategory === void 0 ? void 0 : preselectedCategory.rubric) !== null && _preselectedCategory$ !== void 0 ? _preselectedCategory$ : preselectedRubric); // react to "selectedtypeid"

      if (preselectedCategory) {
        updateActiveAccordion(preselectedCategory);
      }

      doAssignMultiColumnClassToAccordionTabs();
    });
    return {
      isSingleColumn: isSingleColumn,
      overAndUnderCategorys: overAndUnderCategorys,
      config: config,
      activeAccordion: activeAccordion,
      categorys: categorys,
      skipUnwrap: skipUnwrap,
      activeTabView: activeTabView,
      activeTabViewSet: activeTabViewSet,
      rubrics: rubrics,
      enableCategorySearch: enableCategorySearch,
      canShowInfopageForCategory: canShowInfopageForCategory,
      showExternalUriInformation: showExternalUriInformation,
      lastSelectedCategory: lastSelectedCategory,
      categorySearchAdditionalSettings: categorySearchAdditionalSettings,
      onCategoryFromSearchSelected: onCategoryFromSearchSelected,
      onExternalUriConfirm: onExternalUriConfirm,
      onExternalUriCancel: onExternalUriCancel,
      onCategoryInfopageConfirm: onCategoryInfopageConfirm,
      newCategorySelected: newCategorySelected,
      onCategoryTabToggled: onCategoryTabToggled
    };
  }
};

var _hoisted_1$6 = {
  key: 1,
  id: "wdw-bms-category-groups",
  class: "row"
};
var _hoisted_2$6 = {
  key: 0,
  class: "d-flex flex-column justify-content-center align-content-center"
};
var _hoisted_3$6 = ["onClick"];
var _hoisted_4$5 = ["id"];
var _hoisted_5$5 = {
  key: 1,
  class: "row"
};
var _hoisted_6$4 = ["innerHTML"];
var _hoisted_7$4 = {
  class: "float-end"
};

var _hoisted_8$4 = /*#__PURE__*/createTextVNode(" Meldungen der Kategorie ");

var _hoisted_9$4 = /*#__PURE__*/createTextVNode(" können nicht auf dieser Plattform erstellt werden. Für Ihre Meldung werden Sie auf ");

var _hoisted_10$3 = /*#__PURE__*/createTextVNode(" weitergeleitet. Möchten Sie die Seite in einem neuen Tab öffnen? ");

var _hoisted_11$3 = {
  class: "float-end",
  style: {
    "margin-top": "10px"
  }
};
function render$6(_ctx, _cache, $props, $setup, $data, $options) {
  var _$setup$config, _$setup$config2, _$setup$config3, _$setup$lastSelectedC3, _$setup$lastSelectedC6;

  var _component_SelectComp = resolveComponent("SelectComp");

  var _component_WizardStepCategoryEntry = resolveComponent("WizardStepCategoryEntry");

  var _component_WizardStepCategoryGroupWrapper = resolveComponent("WizardStepCategoryGroupWrapper");

  var _component_TabPanel = resolveComponent("TabPanel");

  var _component_TabView = resolveComponent("TabView");

  var _component_Dialog = resolveComponent("Dialog");

  return openBlock(), createElementBlock(Fragment, null, [$setup.enableCategorySearch ? (openBlock(), createBlock(_component_SelectComp, {
    key: 0,
    ref: "categorySearchRef",
    name: "keyword",
    allowClear: true,
    typeable: true,
    label: "Nach Kategorie suchen",
    "additional-settings": $setup.categorySearchAdditionalSettings,
    onSelected: $setup.onCategoryFromSearchSelected
  }, null, 8, ["additional-settings", "onSelected"])) : createCommentVNode("", true), $setup.overAndUnderCategorys && !((_$setup$config = $setup.config) !== null && _$setup$config !== void 0 && _$setup$config.BmsEnableRubrics) ? (openBlock(), createElementBlock("div", _hoisted_1$6, [(openBlock(true), createElementBlock(Fragment, null, renderList($setup.categorys, function (category) {
    return openBlock(), createBlock(_component_WizardStepCategoryGroupWrapper, {
      key: category.title,
      singlecolumn: $setup.isSingleColumn,
      open: $setup.lastSelectedCategory && category.items.find(function (x) {
        var _$setup$lastSelectedC;

        return x.id == ((_$setup$lastSelectedC = $setup.lastSelectedCategory) === null || _$setup$lastSelectedC === void 0 ? void 0 : _$setup$lastSelectedC.id);
      }) != undefined,
      group: category
    }, {
      default: withCtx(function () {
        return [(openBlock(true), createElementBlock(Fragment, null, renderList(category.items, function (underCategory) {
          return openBlock(), createElementBlock("div", {
            key: underCategory.id
          }, [createVNode(_component_WizardStepCategoryEntry, {
            ref_for: true,
            ref: $setup.skipUnwrap.itemRefs,
            id: underCategory.id,
            "over-category": category.title,
            "under-category": underCategory,
            onCategorySelected: $setup.newCategorySelected
          }, null, 8, ["id", "over-category", "under-category", "onCategorySelected"])]);
        }), 128))];
      }),
      _: 2
    }, 1032, ["singlecolumn", "open", "group"]);
  }), 128))])) : (_$setup$config2 = $setup.config) !== null && _$setup$config2 !== void 0 && _$setup$config2.BmsEnableRubrics ? (openBlock(), createElementBlock(Fragment, {
    key: 2
  }, [!$setup.activeTabViewSet ? (openBlock(), createElementBlock("div", _hoisted_2$6, [(openBlock(true), createElementBlock(Fragment, null, renderList($setup.rubrics, function (rubric, index) {
    return openBlock(), createElementBlock("button", {
      key: index,
      class: "btn btn-primary m-1 rounded-1",
      onClick: function onClick($event) {
        $setup.activeTabView = index;
        $setup.activeTabViewSet = true;
      }
    }, toDisplayString(rubric), 9, _hoisted_3$6);
  }), 128))])) : createCommentVNode("", true), withDirectives(createVNode(_component_TabView, {
    class: normalizeClass({
      'hide-tab-view': !((_$setup$config3 = $setup.config) !== null && _$setup$config3 !== void 0 && _$setup$config3.BmsEnableRubrics)
    }),
    "active-index": $setup.activeTabView
  }, {
    default: withCtx(function () {
      var _$setup$config4;

      return [!!((_$setup$config4 = $setup.config) !== null && _$setup$config4 !== void 0 && _$setup$config4.BmsEnableRubrics) ? (openBlock(true), createElementBlock(Fragment, {
        key: 0
      }, renderList($setup.rubrics, function (rubric, index) {
        return openBlock(), createBlock(_component_TabPanel, {
          key: index,
          header: rubric
        }, {
          default: withCtx(function () {
            return [$setup.overAndUnderCategorys ? (openBlock(), createElementBlock("div", {
              key: 0,
              id: 'wdw-bms-category-groups-' + index,
              class: "row"
            }, [(openBlock(true), createElementBlock(Fragment, null, renderList($setup.categorys.filter(function (category) {
              return category.items.some(function (item) {
                return item.rubric === rubric;
              });
            }), function (category) {
              return openBlock(), createBlock(_component_WizardStepCategoryGroupWrapper, {
                "parent-id": 'wdw-bms-category-groups-' + index,
                key: category.title,
                open: $setup.lastSelectedCategory && category.items.find(function (x) {
                  var _$setup$lastSelectedC2;

                  return x.id == ((_$setup$lastSelectedC2 = $setup.lastSelectedCategory) === null || _$setup$lastSelectedC2 === void 0 ? void 0 : _$setup$lastSelectedC2.id);
                }) != undefined,
                singlecolumn: $setup.isSingleColumn,
                group: category
              }, {
                default: withCtx(function () {
                  return [(openBlock(true), createElementBlock(Fragment, null, renderList(category.items, function (underCategory) {
                    return openBlock(), createElementBlock("div", {
                      key: underCategory.id
                    }, [underCategory.rubric == rubric ? (openBlock(), createBlock(_component_WizardStepCategoryEntry, {
                      key: 0,
                      ref_for: true,
                      ref: $setup.skipUnwrap.itemRefs,
                      id: underCategory.id,
                      "over-category": category.title,
                      "under-category": underCategory,
                      onCategorySelected: $setup.newCategorySelected
                    }, null, 8, ["id", "over-category", "under-category", "onCategorySelected"])) : createCommentVNode("", true)]);
                  }), 128))];
                }),
                _: 2
              }, 1032, ["parent-id", "open", "singlecolumn", "group"]);
            }), 128))], 8, _hoisted_4$5)) : (openBlock(), createElementBlock("div", _hoisted_5$5, [(openBlock(true), createElementBlock(Fragment, null, renderList($setup.categorys.filter(function (category) {
              return category.items.some(function (item) {
                return item.rubric === rubric;
              });
            }), function (category) {
              return openBlock(), createElementBlock("div", {
                key: category.title,
                class: "col-md-6"
              }, [createVNode(_component_WizardStepCategoryEntry, {
                ref_for: true,
                ref: $setup.skipUnwrap.itemRefs,
                id: category.items[0].id,
                "over-category": category.title,
                "under-category": category.items[0],
                onCategorySelected: $setup.newCategorySelected
              }, null, 8, ["id", "over-category", "under-category", "onCategorySelected"])]);
            }), 128))]))];
          }),
          _: 2
        }, 1032, ["header"]);
      }), 128)) : createCommentVNode("", true)];
    }),
    _: 1
  }, 8, ["class", "active-index"]), [[vShow, $setup.activeTabViewSet]])], 64)) : (openBlock(), createBlock(_component_TabPanel, {
    key: 3,
    header: "Kategorien"
  }, {
    default: withCtx(function () {
      return [createElementVNode("div", {
        class: normalizeClass($setup.isSingleColumn ? '' : 'row')
      }, [(openBlock(true), createElementBlock(Fragment, null, renderList($setup.categorys, function (category) {
        return openBlock(), createElementBlock("div", {
          key: category.title,
          class: normalizeClass($setup.isSingleColumn ? '' : 'col-md-6')
        }, [createVNode(_component_WizardStepCategoryEntry, {
          ref_for: true,
          ref: $setup.skipUnwrap.itemRefs,
          id: category.items[0].id,
          "over-category": category.title,
          "under-category": category.items[0],
          onCategorySelected: $setup.newCategorySelected
        }, null, 8, ["id", "over-category", "under-category", "onCategorySelected"])], 2);
      }), 128))], 2)];
    }),
    _: 1
  })), createVNode(_component_Dialog, {
    visible: $setup.canShowInfopageForCategory,
    "onUpdate:visible": _cache[1] || (_cache[1] = function ($event) {
      return $setup.canShowInfopageForCategory = $event;
    }),
    header: (_$setup$lastSelectedC3 = $setup.lastSelectedCategory) === null || _$setup$lastSelectedC3 === void 0 ? void 0 : _$setup$lastSelectedC3.name,
    style: {
      width: '50vw'
    },
    breakpoints: {
      '1199px': '75vw',
      '575px': '90vw'
    },
    modal: ""
  }, {
    default: withCtx(function () {
      var _$setup$lastSelectedC4, _$setup$lastSelectedC5;

      return [createElementVNode("div", {
        innerHTML: (_$setup$lastSelectedC4 = $setup.lastSelectedCategory) === null || _$setup$lastSelectedC4 === void 0 ? void 0 : (_$setup$lastSelectedC5 = _$setup$lastSelectedC4.infopage) === null || _$setup$lastSelectedC5 === void 0 ? void 0 : _$setup$lastSelectedC5.content
      }, null, 8, _hoisted_6$4), createElementVNode("div", _hoisted_7$4, [createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = function () {
          return $setup.onCategoryInfopageConfirm && $setup.onCategoryInfopageConfirm.apply($setup, arguments);
        })
      }, "Bestätigen")])];
    }),
    _: 1
  }, 8, ["visible", "header"]), createVNode(_component_Dialog, {
    visible: $setup.showExternalUriInformation,
    "onUpdate:visible": _cache[4] || (_cache[4] = function ($event) {
      return $setup.showExternalUriInformation = $event;
    }),
    style: {
      width: '50vw'
    },
    breakpoints: {
      '1199px': '75vw',
      '575px': '90vw'
    },
    header: (_$setup$lastSelectedC6 = $setup.lastSelectedCategory) === null || _$setup$lastSelectedC6 === void 0 ? void 0 : _$setup$lastSelectedC6.name,
    modal: ""
  }, {
    default: withCtx(function () {
      var _$setup$lastSelectedC7, _$setup$lastSelectedC8;

      return [createElementVNode("div", null, [_hoisted_8$4, createElementVNode("b", null, toDisplayString((_$setup$lastSelectedC7 = $setup.lastSelectedCategory) === null || _$setup$lastSelectedC7 === void 0 ? void 0 : _$setup$lastSelectedC7.name), 1), _hoisted_9$4, createElementVNode("b", null, toDisplayString((_$setup$lastSelectedC8 = $setup.lastSelectedCategory) === null || _$setup$lastSelectedC8 === void 0 ? void 0 : _$setup$lastSelectedC8.external_uri), 1), _hoisted_10$3]), createElementVNode("div", _hoisted_11$3, [createElementVNode("button", {
        class: "btn btn-primary",
        style: {
          "margin-right": "5px"
        },
        onClick: _cache[2] || (_cache[2] = function () {
          return $setup.onExternalUriConfirm && $setup.onExternalUriConfirm.apply($setup, arguments);
        })
      }, "Ja, Seite öffnen"), createElementVNode("button", {
        class: "btn btn-danger",
        onClick: _cache[3] || (_cache[3] = function () {
          return $setup.onExternalUriCancel && $setup.onExternalUriCancel.apply($setup, arguments);
        })
      }, "Abbrechen")])];
    }),
    _: 1
  }, 8, ["visible", "header"])], 64);
}

script$6.render = render$6;
script$6.__scopeId = "data-v-466c70b8";

var $values = objectToArray.values;

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
_export({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});

var fileUploadRepository = {
  getBundleToken: function getBundleToken() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", new Promise(function (resolve, reject) {
                axiosWdw({
                  method: 'POST',
                  url: domainEndpoint() + '/bundle'
                }).then(function (res) {
                  resolve(res.data.data.token);
                }).catch(function (err) {
                  reject(err);
                });
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  uploadFile: function uploadFile(file, bundleId) {
    return new Promise(function (resolve, reject) {
      var form = new FormData();
      form.append('picture', file);
      axiosWdw({
        method: 'POST',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        url: domainEndpoint() + '/bundle/' + bundleId + '/file',
        data: form
      }).then(function (res) {
        resolve(res.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  deleteFile: function deleteFile(fileid, bundleId) {
    return new Promise(function (resolve, reject) {
      axiosWdw({
        method: 'GET',
        url: domainEndpoint() + '/bundle/' + bundleId + '/file/' + fileid + '/delete'
      }).then(function (res) {
        resolve(res.data);
      }).catch(function (err) {
        reject(err);
      });
    });
  }
};

library.add(faTrashAlt);
var script$5 = {
  name: 'FileBundle',
  emits: ['files-uploaded', 'set-bundle-token'],
  props: {
    name: {
      required: true,
      type: String
    },
    code: {
      required: false,
      type: String,
      default: ''
    },
    label: {
      required: false,
      type: String,
      default: undefined
    },
    additionalrules: {
      required: false,
      type: Array,
      default: function _default() {
        return [];
      }
    },
    maxFileCount: {
      required: false,
      type: Number,
      default: 5
    },
    additionalLabelClasses: {
      required: false,
      type: String,
      default: ''
    },
    bundle_token: {
      required: false,
      type: String,
      default: ''
    },
    files: {
      type: Object,
      default: function _default() {
      },
      required: false
    },
    required: {
      required: false,
      type: Boolean,
      default: false
    },
    infotext: {
      required: false,
      type: String,
      default: "Sie können nur Anlagen in den folgenden Dateiformaten hinzufügen: PNG, JPG, PDF, DOC und ODT."
    }
  },
  setup: function setup(props, context) {
    var bundleId = ref('');
    var uploadedFiles = ref([]);
    var isProcessingFile = ref(false);
    var errorMessage = ref(); //+---------------------------+
    //|         computed          |
    //+---------------------------+

    var labelClass = computed(function () {
      return props.additionalLabelClasses;
    });
    var labelText = computed(function () {
      return "Foto/Anhang (maximal ".concat(props.maxFileCount, " Dateien)");
    });
    var idInput = computed(function () {
      return 'wdw-bms-attr-filebundle-' + 'form-control-file-bundle';
    }); //+---------------------------+
    //|         methods           |
    //+---------------------------+

    function uploadFile(file) {
      return fileUploadRepository.uploadFile(file, bundleId.value).then(function (res) {
        return res.data;
      });
    }

    function massUpload(files) {
      var promises = [];

      var _iterator = _createForOfIteratorHelper(files),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var file = _step.value;
          promises.push(uploadFile(file));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      Promise.all(promises).then(function (res) {
        var allFiles = res.reduce(function (acc, obj) {
          return obj.files.length > acc.files.length ? obj : acc;
        });

        if (allFiles) {
          uploadedFiles.value = [];

          var _iterator2 = _createForOfIteratorHelper(allFiles.files),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var file = _step2.value;
              uploadedFiles.value.push(file);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      }).finally(function () {
        isProcessingFile.value = false;
        wizardStore.setSubmitting(false);
        context.emit('files-uploaded', uploadedFiles.value);
      });
    }

    function processFile(e) {
      var field = e.target;
      var files = field.files;

      if (files) {
        if (files.length + uploadedFiles.value.length > props.maxFileCount) {
          errorMessage.value = 'Sie können maximal 5 Dateien auswählen';
        } else {
          wizardStore.setSubmitting(true);
          errorMessage.value = '';
          isProcessingFile.value = true;

          if (!bundleId.value) {
            fileUploadRepository.getBundleToken().then(function (res) {
              bundleId.value = res;
              context.emit('set-bundle-token', res);
              massUpload(files);
            });
          } else {
            massUpload(files);
            isProcessingFile.value = false;
          }
        }
      }
    }

    function deleteFile(fileid) {
      fileUploadRepository.deleteFile(fileid, bundleId.value).then(function (res) {
        uploadedFiles.value = res.data.files;
        context.emit('files-uploaded', uploadedFiles.value);

        if (!uploadedFiles.value) {
          bundleId.value = '';
        }
      });
    }

    function filesize(size) {
      return (size / (1000 * 1000)).toFixed(2) + ' MB';
    } //+---------------------------+
    //|         Lifecycle         |
    //+---------------------------+


    onMounted(function () {
      if (props.bundle_token) {
        bundleId.value = props.bundle_token;

        if (props.files.length) {
          uploadedFiles.value = props.files;
        }
      }
    });
    return {
      idInput: idInput,
      labelClass: labelClass,
      labelText: labelText,
      isProcessingFile: isProcessingFile,
      errorMessage: errorMessage,
      uploadedFiles: uploadedFiles,
      filesize: filesize,
      deleteFile: deleteFile,
      processFile: processFile
    };
  }
};

var _withScopeId$4 = function _withScopeId(n) {
  return pushScopeId("data-v-3d02899f"), n = n(), popScopeId(), n;
};

var _hoisted_1$5 = {
  class: "my-3"
};
var _hoisted_2$5 = ["for"];
var _hoisted_3$5 = ["name", "id", "required", "disabled", "data-vv-as", "data-wdw-code"];
var _hoisted_4$4 = {
  key: 0,
  class: "small help-block"
};
var _hoisted_5$4 = {
  key: 1,
  class: "alert alert-danger"
};
var _hoisted_6$3 = {
  key: 2,
  class: "m-2"
};

var _hoisted_7$3 = /*#__PURE__*/_withScopeId$4(function () {
  return /*#__PURE__*/createElementVNode("p", null, "Ausgewählte Dateien:", -1);
});

var _hoisted_8$3 = {
  class: "col-sm-6 d-flex align-items-center justify-content-between"
};
var _hoisted_9$3 = {
  class: "me-2"
};
function render$5(_ctx, _cache, $props, $setup, $data, $options) {
  var _$props$label, _$props$label2, _$setup$uploadedFiles;

  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  var _directive_dompurify_html = resolveDirective("dompurify-html");

  return openBlock(), createElementBlock("div", _hoisted_1$5, [createElementVNode("label", {
    for: $setup.idInput,
    class: normalizeClass($setup.labelClass)
  }, toDisplayString((_$props$label = $props.label) !== null && _$props$label !== void 0 ? _$props$label : $setup.labelText), 11, _hoisted_2$5), createElementVNode("input", {
    name: $props.name,
    id: $setup.idInput,
    required: $props.required,
    disabled: $setup.isProcessingFile,
    "data-vv-as": (_$props$label2 = $props.label) !== null && _$props$label2 !== void 0 ? _$props$label2 : $setup.labelText,
    "data-wdw-code": $props.code,
    class: "form-control",
    type: "file",
    accept: "image/*,.pdf,.doc,.odt,.docx",
    onChange: _cache[0] || (_cache[0] = function ($event) {
      return $setup.processFile($event);
    }),
    multiple: true,
    tabindex: "0"
  }, null, 40, _hoisted_3$5), $props.infotext ? withDirectives((openBlock(), createElementBlock("p", _hoisted_4$4, null, 512)), [[_directive_dompurify_html, $props.infotext]]) : createCommentVNode("", true), $setup.errorMessage ? (openBlock(), createElementBlock("div", _hoisted_5$4, toDisplayString($setup.errorMessage), 1)) : createCommentVNode("", true), (_$setup$uploadedFiles = $setup.uploadedFiles) !== null && _$setup$uploadedFiles !== void 0 && _$setup$uploadedFiles.length ? (openBlock(), createElementBlock("div", _hoisted_6$3, [_hoisted_7$3, (openBlock(true), createElementBlock(Fragment, null, renderList($setup.uploadedFiles, function (file) {
    return openBlock(), createElementBlock("div", {
      class: "d-flex my-2",
      key: file.id
    }, [createElementVNode("div", _hoisted_8$3, [createElementVNode("span", _hoisted_9$3, "- " + toDisplayString(file.filename) + " (" + toDisplayString($setup.filesize(file.size)) + ")", 1), createVNode(_component_font_awesome_icon, {
      icon: "trash-alt",
      class: "clickable",
      onClick: function onClick($event) {
        return $setup.deleteFile(file.id);
      }
    }, null, 8, ["onClick"])])]);
  }), 128))])) : createCommentVNode("", true)]);
}

script$5.render = render$5;
script$5.__scopeId = "data-v-3d02899f";

/**
 * This composable is an utility to check dependencies between fields in a form.
 * e.g. field A should be shown only if field B has certain value selected
 */
function useFormInputDependency () {
  /**
   * Use DOM traversal to check whether the dependency on another field is fulfilled or not.
   * - This means that both fields have to be under the same parent.
   * - Each field also needs to have attribute "data-wdw-code='<code>'" in its input field
   * You can use this method for checking between 2 different inputs. For whole Form-checking, use evaluateFormIfCode.
   *
   * TODO possibly use jQuery instead of normal JS for DOM manipulation???
   *
   * @param ifCode
   * @param ifValue
   * @param parentFormId
   */
  function evaluateIfCodeValue(ifCode, ifValue, parentFormId) {
    if (ifCode == null || ifCode === '' || ifValue == null || parentFormId == null || parentFormId === '') return true;
    var parentForm = document.getElementById(parentFormId);
    var field = parentForm === null || parentForm === void 0 ? void 0 : parentForm.querySelector("[data-wdw-code='" + ifCode + "']");

    if (field) {
      var realValue = field.value;
      var comparedValue = ifValue;

      if (field.type === 'checkbox') {
        realValue = field.checked;
        comparedValue = ifValue === '1' || ifValue === 'true';
      } else if (field.type === 'select') {
        realValue = field.value[0];
      }

      return comparedValue === realValue;
    }

    return true;
  }
  /**
   * Evaluate the whole form from a change on the given field. It is recommended that all fields checked should be within a parent form
   *
   * @param parentFormId ID of the parent form
   * @param ifKey the key on each element in fieldsList that points to the ifCode (e.g. xxx_if_code)
   * @param ifValue the key on each element in fieldsList that points to the ifValue (e.g. xxx_if_value)
   * @param previousEvaluation the list of last evaluations. If the ifCode doesn't apply, it will take the previous evaluation result (or true as fallback)
   * @param fieldsList List of fields.
   *      Example of each element:
   *      { code: "<code>", type: "<field type>", "<ifKey>": "<if-code>", "<valueKey>": "<value-for-if-to-be-true>" }
   * @param changedFieldCode which code is being changed
   * @param changedFieldValue the value of the code
   * @returns hash containing { <field_name> : true|false }
   */


  function evaluateFormIfCode(ifKey, valueKey, previousEvaluation, fieldsList, changedFieldCode, changedFieldValue, changedFieldType) {
    var evaluation = {};
    fieldsList.forEach(function (field) {
      var fieldIfCode = field[ifKey];
      var fieldIfValue = field[valueKey];

      if (fieldIfCode == null || fieldIfValue == null || fieldIfCode === '') {
        // The checked field has no ifCode requirement. We return last evaluation by default (or true)
        evaluation[field.code] = previousEvaluation[field.code] !== undefined ? previousEvaluation[field.code] : true;
      } else if (fieldIfCode !== changedFieldCode) {
        // The checked field's ifCode is not the same as the changed code. Therefore, this field is not dependant on the change
        // We return last evaluation by default (or true)
        evaluation[field.code] = previousEvaluation[field.code] !== undefined ? previousEvaluation[field.code] : true;
      } else {
        // We try to compare the value and the changed value
        if (changedFieldType === 'checkbox') {
          // fieldIfValue contains string "1" as opposed to true/false since it comes from the server
          evaluation[field.code] = fieldIfValue === '1' === changedFieldValue;
        } else if (changedFieldType == 'valuelist' || changedFieldType == 'select') {
          // Possible array (if the dependency allows multivalues, we check if the changedvalue has the ifvalue)
          var arrayValues = Array.isArray(changedFieldValue) ? changedFieldValue : [changedFieldValue];
          evaluation[field.code] = arrayValues.findIndex(function (x) {
            return x == fieldIfValue;
          }) >= 0;
        } else {
          // Others? just normal comparison
          evaluation[field.code] = fieldIfValue === changedFieldValue;
        }
      }
    });
    return evaluation;
  }
  /**
   *    T22311: get fields (its code) that should be emptied before evaluation by evaluateFormIfCode(). The problem is regarding transitive dependency
   *    e.g. Attribute C is shown if Attribute B has value B1. Attribute B is shown only if Attribute A has value A1
   *        A (A1) -> B (B1) -> C
   *        if A's value is changed to A2, Attribute C will still be shown since the value of attribute B is still B1
   *        so, whenever the value of attribute A is changed, we need to make sure that attribute B's value is cleared so that attribute C won't be shown before we evaluate everything
   *
   *    This method runs recursively. For every field that should be emptied, we use its code as parameter to recursively call the same method
   *    so we can make sure that chaining dependency gets resolved no matter how far the chain is
   *    e.g. A (A1) -> B (B1) -> C (C1) -> D (D1) -> E
   *        based on the structure above,
   *        if we change the value of attribute A, we need to clear value of Attribute B, C, D, and E
   *        if we change the value of attribute B, we need to clear value of Attribute C, D, and E
   *        if we change the value of attribute C, we need to clear value of Attribute D and E
   *
   *    IMPORTANT: This can result in unending recursion if you make 2 fields dependant on each other! So don't do it.
   *
   * @param ifKey the key for visibility dependant field
   * @param ifValue the key for visibility dependant value
   * @param fieldList List of fields
   * @param changedFieldCode the code of the field whose value is changed
   * @param changedFieldValue the changed value
   * @param fieldsToBeEmptied Set of string containing the code of the fields that needs to be emptied. Default is empty Set
   */


  function getTransitiveDependencyFieldsToBeEmptied(ifKey, ifValue, fieldList, changedFieldCode, changedFieldValue) {
    var fieldsToBeEmptied = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : new Set();
    var changedField = fieldList.find(function (x) {
      return x.code == changedFieldCode;
    });

    if (changedField != null) {
      // Find other fields whose visibility/required depend on this field
      // We have to check the value as well if it matches. If it doesn't match, then we need to remove it
      var affectedFields = fieldList.filter(function (x) {
        var dependantField = x[ifKey] == changedFieldCode;
        var notItsOwn = x.code != changedFieldCode;
        var valueMatch = Array.isArray(changedFieldValue) && changedFieldValue[0] == x[ifValue] || changedFieldValue == x[ifValue];
        return dependantField && notItsOwn && !valueMatch;
      });
      affectedFields.forEach(function (x) {
        fieldsToBeEmptied.add(x.code);
        getTransitiveDependencyFieldsToBeEmptied(ifKey, ifValue, fieldList, x.code, x[ifValue], fieldsToBeEmptied);
      });
    }

    return fieldsToBeEmptied;
  }
  /**
   * T22311: Get fields that can be safely removed depending on visible_if_code and visible_if_value rule
   * It basically goes through every field, find the dependant field, and compare whether the entered value matches the assigned value
   * if not, we can safely remove it
   *
   * Only for attribute fields
   *
   * @param fieldList List of attribute fields
   * @param fieldValues hash of id-value (e.g. { 'attribute-1': "xxx", 'attribute-2': "yyy", .... })
   * @param ifKey the key for visibility dependency. Default is 'visible_if_code'
   * @param valueKey the key for visibility dependency value. Default is 'visible_if_value'
   * @param fieldsToBeEmptied Set of string containing the attribute name of the fields that can be safely removed. Default is empty Set
   * @returns modified `fieldsToBeEmptied`
   */


  function getRemovableAttributeFields(fieldList, fieldValues) {
    var ifKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'visible_if_code';
    var valueKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'visible_if_value';
    var fieldsToBeEmptied = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : new Set();
    fieldList.forEach(function (x) {
      if (x[ifKey] == null || x[valueKey] == null || x[ifKey] == '') ; else {
        var supposedValue = x[valueKey]; // always scalar

        var dependantField = fieldList.find(function (y) {
          return x[ifKey] == y.code && y.code != x.code;
        });

        if (dependantField != null) {
          var enteredValue = fieldValues['attribute-' + dependantField.id]; // Can be array or scalar

          var valuesAreDifferent = false;

          if (Array.isArray(enteredValue)) {
            valuesAreDifferent = enteredValue.find(function (x) {
              return x == supposedValue;
            }) == null;
          } else {
            valuesAreDifferent = supposedValue != enteredValue;
          }

          if (valuesAreDifferent) {
            // if the value is different from the assigned dependency value, we can safely remove this attribute's value from submission
            fieldsToBeEmptied.add('attribute-' + x.id); // we need to remove the entered values as well so the next attributes to check have the up-to-date values

            delete fieldValues['attribute-' + x.id];
          }
        }
      }
    });
    return fieldsToBeEmptied;
  }
  /**
   * Insert a submit button on a form and execute it
   * @param formid the form id
   */


  function insertSubmitButtonOnFormAndExecute(formid) {
    // Get the form element by its ID
    var form = document.getElementById(formid);
    if (!form) return; // Create an invisible submit button

    var submitButton = document.createElement('button');
    submitButton.type = 'submit';
    submitButton.style.display = 'none'; // Append the button to the form

    form.appendChild(submitButton); // Trigger the form submission

    submitButton.click();
    form.removeChild(submitButton);
  }

  return {
    insertSubmitButtonOnFormAndExecute: insertSubmitButtonOnFormAndExecute,
    evaluateIfCodeValue: evaluateIfCodeValue,
    evaluateFormIfCode: evaluateFormIfCode,
    getTransitiveDependencyFieldsToBeEmptied: getTransitiveDependencyFieldsToBeEmptied,
    getRemovableAttributeFields: getRemovableAttributeFields
  };
}

var _excluded = ["title", "text", "link", "link_title", "picture"];
var script$4 = {
  name: "WizardStepFields",
  props: {},
  emits: ['selection', 'returnToOverview', 'nextStep'],
  components: {
    Form: Form,
    FormControlInput: script$h,
    FormControlTextarea: script$i,
    FormControlAttributes: script$j,
    FileBundle: script$5
  },
  setup: function setup(props, context) {
    configure({
      validateOnBlur: true
    }); // +----------------+
    // |   Variables    |
    // +----------------

    var _useFormInputDependen = useFormInputDependency(),
        evaluateFormIfCode = _useFormInputDependen.evaluateFormIfCode,
        insertSubmitButtonOnFormAndExecute = _useFormInputDependen.insertSubmitButtonOnFormAndExecute;

    var formEvaluation = reactive({
      // Server-related errors
      errors: {},
      // Evaluation of visible_if_code and visible_if_value
      visibleIfResult: {},
      // Evaluation of required_if_code and required_if_value
      requiredIfResult: {},
      // Success message
      success: ''
    });
    var attributeFormValues = reactive({}); // +----------------+
    // |    Computed    |
    // +----------------+

    var categoryAttributes = computed(function () {
      var _wizardStore$getState;

      return (_wizardStore$getState = wizardStore.getState().category) === null || _wizardStore$getState === void 0 ? void 0 : _wizardStore$getState.attributes;
    });
    var useTitle = computed(function () {
      var _wizardStore$getState2;

      return (_wizardStore$getState2 = wizardStore.getState().config) === null || _wizardStore$getState2 === void 0 ? void 0 : _wizardStore$getState2.bms.use_message_title;
    });
    var useLink = computed(function () {
      var _wizardStore$getState3;

      return (_wizardStore$getState3 = wizardStore.getState().config) === null || _wizardStore$getState3 === void 0 ? void 0 : _wizardStore$getState3.bms.allow_attach_links;
    });
    var attachmentHintText = computed(function () {
      var _wizardStore$getState4, _wizardStore$getState5;

      return (_wizardStore$getState4 = wizardStore.getState().config) === null || _wizardStore$getState4 === void 0 ? void 0 : (_wizardStore$getState5 = _wizardStore$getState4.stepdata["step3"]) === null || _wizardStore$getState5 === void 0 ? void 0 : _wizardStore$getState5.hint_text_attachment;
    });
    var localstorage = localStorage;
    var userEntry = computed(function () {
      return wizardStore.getState().userEntrys;
    });
    var bundleId = computed(function () {
      return wizardStore.getState().userEntrys.bundle_token;
    });
    var uploadedFiles = computed(function () {
      return wizardStore.getState().userEntrys.expected_files;
    });
    var user = computed(function () {
      return wizardStore.getState().user;
    });
    var descriptionFieldHelpError = computed(function () {
      return "Die Beschreibung wird öffentlich im Internet angezeigt. Bitte tragen Sie keine Klarnamen, Firmennamen oder andere Daten mit Personenbezug ein.";
    }); // +----------------+
    // |    Methods     |
    // +----------------+

    function onValidatedFormField(fieldValue) {
      if (categoryAttributes.value) {
        // Evaluate the whole attribute fields based on its visible_if_code
        formEvaluation.visibleIfResult = evaluateFormIfCode('visible_if_code', 'visible_if_value', formEvaluation.visibleIfResult, categoryAttributes.value, fieldValue.code, fieldValue.value, fieldValue.type); // Evaluate the whole attribute fields based on its required_if_code

        formEvaluation.requiredIfResult = evaluateFormIfCode('required_if_code', 'required_if_value', formEvaluation.requiredIfResult, categoryAttributes.value, fieldValue.code, fieldValue.value, fieldValue.type);
      }

      attributeFormValues[fieldValue.name] = fieldValue;
    }

    function getDefaultValue(id) {
      var _categoryAttributes$v, _user$value;

      var result;
      var attribute = (_categoryAttributes$v = categoryAttributes.value) === null || _categoryAttributes$v === void 0 ? void 0 : _categoryAttributes$v.find(function (attr) {
        return attr.id == id;
      });

      if (user.value && !((_user$value = user.value) !== null && _user$value !== void 0 && _user$value.virtual)) {
        switch (attribute === null || attribute === void 0 ? void 0 : attribute.code) {
          case 'first_name':
            result = user.value.firstname || '';
            break;

          case 'last_name':
            result = user.value.lastname || '';
            break;

          case 'email':
            result = user.value.email || '';
            break;

          default:
            result = localstorage.getItem(String(id)) || '';
        }
      } else {
        result = localstorage.getItem(String(id)) || '';
      }

      return result;
    }

    var attributeEditInitialValues = computed(function () {
      var _categoryAttributes$v2;

      var result = {};
      (_categoryAttributes$v2 = categoryAttributes.value) === null || _categoryAttributes$v2 === void 0 ? void 0 : _categoryAttributes$v2.forEach(function (attribute) {
        result['attribute-' + attribute.id] = getDefaultValue(attribute.id);
      });
      return result;
    });

    function fileUploaded(files) {
      wizardStore.setFiles(files);
    }

    function setBundle(bundleid) {
      wizardStore.setBundleToken(bundleid);
    }

    function emitFormSubmission(values) {
      for (var value in values) {
        localStorage.setItem(value.substring('attribute-'.length), values[value]);
      }

      var title = values.title,
          text = values.text,
          link = values.link,
          link_title = values.link_title;
          values.picture;
          var attribute_values = _objectWithoutProperties(values, _excluded);

      duplicateStore.setParameters([{
        key: 'title',
        value: title
      }, {
        key: 'attributes',
        value: attribute_values
      }], false); // T23601: Don't immediately focus on next button since duplicate check is fired off every time value changes

      wizardStore.setFields(text, attribute_values, title, link_title, link);
      context.emit('selection', values);
    }

    function submitAttributeForm() {
      insertSubmitButtonOnFormAndExecute("wizardForm");
    }

    function checkFormCompleted() {
      var _wizardStore$getState6;

      var attrHasError = Object.values(attributeFormValues).find(function (x) {
        return !x.validated;
      }) != undefined;
      return !attrHasError && ((_wizardStore$getState6 = wizardStore.getState().userEntrys.description) === null || _wizardStore$getState6 === void 0 ? void 0 : _wizardStore$getState6.trim()) !== "";
    }

    function fetchDuplicates(params, value) {
      // Should the duplicates be fetched after ANY user input or just after the description ??
      duplicateStore.setParameters([{
        key: params,
        value: value
      }], false);
    }

    var fetchDebouncedDuplicates = debounce(function (value) {
      wizardStore.setDescription(value.value);
      fetchDuplicates('description', value.value);
    }, 500);
    context.expose({
      submitForm: submitAttributeForm,
      formCompleted: checkFormCompleted
    }); // +----------------+
    // |   Lifecycle    |
    // +----------------+

    onMounted(function () {
      // preload positionimage for summary (next step)
      var url = wizardStore.getMapImageUrl();

      if (url) {
        var link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = url;
        document.head.appendChild(link);
      }
    });
    return {
      user: user,
      useTitle: useTitle,
      userEntry: userEntry,
      useLink: useLink,
      fetchDebouncedDuplicates: fetchDebouncedDuplicates,
      uploadedFiles: uploadedFiles,
      bundleId: bundleId,
      attributeEditInitialValues: attributeEditInitialValues,
      descriptionFieldHelpError: descriptionFieldHelpError,
      formEvaluation: formEvaluation,
      categoryAttributes: categoryAttributes,
      attachmentHintText: attachmentHintText,
      onValidatedFormField: onValidatedFormField,
      fileUploaded: fileUploaded,
      setBundle: setBundle,
      emitFormSubmission: emitFormSubmission
    };
  }
};

var _withScopeId$3 = function _withScopeId(n) {
  return pushScopeId("data-v-5be662e6"), n = n(), popScopeId(), n;
};

var _hoisted_1$4 = {
  key: 0,
  class: "mb-2"
};
var _hoisted_2$4 = {
  key: 1,
  class: "row mb-2"
};
var _hoisted_3$4 = {
  class: "col-md-6"
};
var _hoisted_4$3 = {
  class: "col-md-6"
};

var _hoisted_5$3 = /*#__PURE__*/_withScopeId$3(function () {
  return /*#__PURE__*/createElementVNode("div", {
    class: "fs-sm text-muted float-end"
  }, "* Diese Felder sind Pflichtfelder", -1);
});

function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_form_control_input = resolveComponent("form-control-input");

  var _component_FormControlTextarea = resolveComponent("FormControlTextarea");

  var _component_FileBundle = resolveComponent("FileBundle");

  var _component_form_control_attributes = resolveComponent("form-control-attributes");

  var _component_Form = resolveComponent("Form");

  return openBlock(), createElementBlock("div", null, [createVNode(_component_Form, {
    onSubmit: $setup.emitFormSubmission,
    id: "wizardForm"
  }, {
    default: withCtx(function () {
      return [$setup.useTitle ? (openBlock(), createElementBlock("div", _hoisted_1$4, [createVNode(_component_form_control_input, {
        label: "Titel",
        name: "title",
        type: "text",
        required: true,
        defaultvalue: $setup.userEntry.title
      }, null, 8, ["defaultvalue"])])) : createCommentVNode("", true), $setup.useLink ? (openBlock(), createElementBlock("div", _hoisted_2$4, [createElementVNode("div", _hoisted_3$4, [createVNode(_component_form_control_input, {
        label: "Link anhängen",
        name: "link",
        type: "link",
        placeholder: "https://",
        required: false,
        defaultvalue: $setup.userEntry.link
      }, null, 8, ["defaultvalue"])]), createElementVNode("div", _hoisted_4$3, [createVNode(_component_form_control_input, {
        label: "Link titel",
        name: "link_title",
        type: "text",
        required: false,
        defaultvalue: $setup.userEntry.link_title
      }, null, 8, ["defaultvalue"])])])) : createCommentVNode("", true), createVNode(_component_FormControlTextarea, {
        class: "mb-2",
        name: "text",
        label: "Beschreibung",
        required: true,
        isPublic: true,
        defaultvalue: $setup.userEntry.description,
        error: $setup.descriptionFieldHelpError,
        help: $setup.descriptionFieldHelpError,
        onValidate: $setup.fetchDebouncedDuplicates
      }, null, 8, ["defaultvalue", "error", "help", "onValidate"]), createVNode(_component_FileBundle, {
        name: 'picture',
        code: 'picture',
        files: $setup.uploadedFiles,
        bundle_token: $setup.bundleId,
        infotext: $setup.attachmentHintText,
        onFilesUploaded: $setup.fileUploaded,
        onSetBundleToken: $setup.setBundle
      }, null, 8, ["files", "bundle_token", "infotext", "onFilesUploaded", "onSetBundleToken"]), createElementVNode("div", null, [createVNode(_component_form_control_attributes, {
        elementPrefixId: "wdw-bms-wizard-form",
        onValidate: $setup.onValidatedFormField,
        requiredIfResults: $setup.formEvaluation.requiredIfResult,
        visibleIfResults: $setup.formEvaluation.visibleIfResult,
        fields: $setup.categoryAttributes || [],
        serverErrors: $setup.formEvaluation.errors,
        initialValues: $setup.attributeEditInitialValues,
        showInputAsCols: true
      }, null, 8, ["onValidate", "requiredIfResults", "visibleIfResults", "fields", "serverErrors", "initialValues"])])];
    }),
    _: 1
  }, 8, ["onSubmit"]), _hoisted_5$3]);
}

script$4.render = render$4;
script$4.__scopeId = "data-v-5be662e6";

var _hoisted_1$3 = {
  class: "widget mb-4"
};
var _hoisted_2$3 = {
  class: "widget-title"
};
var _hoisted_3$3 = {
  class: "widget-text"
};
function render$3(_ctx, _cache) {
  return openBlock(), createElementBlock("div", _hoisted_1$3, [createElementVNode("h4", _hoisted_2$3, [renderSlot(_ctx.$slots, "title")]), createElementVNode("div", _hoisted_3$3, [renderSlot(_ctx.$slots, "default")])]);
}

var script$3 = {};
script$3.render = render$3;
script$3.__scopeId = "data-v-7b319db2";
var StepSummaryGrid = script$3;

library.add(faVolumeHigh, faArrowsRotate);
var script$2 = {
  name: "Captcha",
  props: {
    title: {
      type: String,
      required: false,
      default: 'Sicherheitsabfrage'
    },
    captcha: {
      type: Object,
      required: true
    }
  },
  emits: ["captchaEntered"],
  setup: function setup(props, context) {
    // +----------------+
    // |   Variables    |
    // +----------------+
    var captchaUserInput = ref('');
    var valid = ref(true);

    var _toRefs = toRefs(props),
        captcha = _toRefs.captcha; // +----------------+
    // |    Methods     |
    // +----------------+


    function playAudioCaptcha() {
      var audio = new Audio(captcha.value.audio);
      audio.play();
    }

    function refetchCaptcha() {
      wizardStore.reFetchCaptcha();
      captchaUserInput.value = '';
    }

    function submitCaptcha() {
      if (props.captcha) {
        var _props$captcha;

        captchaRepository.validateCaptcha((_props$captcha = props.captcha) === null || _props$captcha === void 0 ? void 0 : _props$captcha.id, captchaUserInput.value).then(function (res) {
          context.emit("captchaEntered", {
            input: captchaUserInput.value,
            valid: res.valid
          });
          valid.value = res.valid;
        });
      }
    }

    context.expose({
      captchaUserInput: captchaUserInput
    }); // +----------------+
    // |    Watchers    |
    // +----------------+

    watch(captchaUserInput, function () {
      submitCaptcha();
    });
    return {
      captchaUserInput: captchaUserInput,
      valid: valid,
      playAudioCaptcha: playAudioCaptcha,
      refetchCaptcha: refetchCaptcha
    };
  }
};

var _withScopeId$2 = function _withScopeId(n) {
  return pushScopeId("data-v-40b34619"), n = n(), popScopeId(), n;
};

var _hoisted_1$2 = {
  key: 0,
  class: "form-group has-error"
};
var _hoisted_2$2 = {
  class: "my-2"
};
var _hoisted_3$2 = {
  for: "wdw-captcha"
};

var _hoisted_4$2 = /*#__PURE__*/_withScopeId$2(function () {
  return /*#__PURE__*/createElementVNode("br", null, null, -1);
});

var _hoisted_5$2 = /*#__PURE__*/_withScopeId$2(function () {
  return /*#__PURE__*/createElementVNode("span", null, "Bitte geben Sie die Zeichenfolge aus dem Bild an.", -1);
});

var _hoisted_6$2 = /*#__PURE__*/_withScopeId$2(function () {
  return /*#__PURE__*/createElementVNode("br", null, null, -1);
});

var _hoisted_7$2 = ["src"];
var _hoisted_8$2 = {
  key: 0
};
var _hoisted_9$2 = {
  ref: "player",
  id: "bms-wizard-audio-captcha"
};
var _hoisted_10$2 = ["src"];

var _hoisted_11$2 = /*#__PURE__*/createTextVNode(" Your browser does not support the audio element. ");

var _hoisted_12$2 = ["data-vv-as", "aria-errormessage"];
var _hoisted_13$1 = {
  key: 0,
  id: "bms-wizard-captcha-error",
  "aria-live": "polite",
  class: "text-danger"
};
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  return $props.captcha !== undefined ? (openBlock(), createElementBlock("div", _hoisted_1$2, [createElementVNode("div", null, [createElementVNode("div", _hoisted_2$2, [createElementVNode("label", _hoisted_3$2, toDisplayString($props.title), 1), _hoisted_4$2, _hoisted_5$2, _hoisted_6$2, createElementVNode("img", {
    "aria-hidden": "true",
    role: "presentation",
    tabindex: "-1",
    src: $props.captcha.image,
    class: "img-responsive img-thumbnail"
  }, null, 8, _hoisted_7$2), $props.captcha.audio !== undefined ? (openBlock(), createElementBlock("span", _hoisted_8$2, [createElementVNode("audio", _hoisted_9$2, [createElementVNode("source", {
    src: $props.captcha.audio,
    type: "audio/wav"
  }, null, 8, _hoisted_10$2), _hoisted_11$2], 512), createElementVNode("button", {
    class: "btn btn-primary captcha-button",
    type: "button",
    id: "bms-wizard-audio-captcha-play-btn",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $setup.playAudioCaptcha();
    }),
    "aria-label": "Zeichenfolge aussprechen. Zeichenfolge beinhaltet Kleinbuchstaben und Zahlen."
  }, [createVNode(_component_font_awesome_icon, {
    icon: "volume-high",
    "aria-hidden": "true",
    tabindex: "-1"
  })])])) : createCommentVNode("", true), createElementVNode("span", null, [createElementVNode("button", {
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $setup.refetchCaptcha();
    }),
    class: "btn btn-primary form_captcha_refresh captcha-button",
    type: "button",
    "aria-label": "Neue Zeichenfolge anfordern."
  }, [createVNode(_component_font_awesome_icon, {
    icon: "arrows-rotate",
    "aria-hidden": "true"
  })])])]), withDirectives(createElementVNode("input", {
    id: "bms-wizard-captcha-field",
    name: "wdw-captcha",
    autocomplete: "off",
    "data-vv-as": $props.captcha.text.title,
    required: true,
    "aria-errormessage": 'Die Antwort auf die Sicherheitsabfrage war nicht korrekt. Bitte versuchen Sie es noch einmal.',
    "aria-label": "Sicherheitsabfrage Eingabefeld. Bitte geben Sie die Zeichenfolge aus dem Bild an.",
    class: normalizeClass(["form-control mb-2", {
      'is-invalid': !$setup.valid
    }]),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $setup.captchaUserInput = $event;
    }),
    onKeypress: _cache[3] || (_cache[3] = withKeys(withModifiers(function () {}, ["prevent"]), ["enter"]))
  }, null, 42, _hoisted_12$2), [[vModelText, $setup.captchaUserInput]]), !$setup.valid ? (openBlock(), createElementBlock("span", _hoisted_13$1, " Sicherheitsabfrage Eingabefeld. Bitte geben Sie die Zeichenfolge aus dem Bild an. ")) : createCommentVNode("", true)])])) : createCommentVNode("", true);
}

script$2.render = render$2;
script$2.__scopeId = "data-v-40b34619";

var script$1 = {
  name: "WizardStepSummary",
  props: {},
  emits: ["returnToOverview"],
  components: {
    FormControlCheckbox: script$k,
    FormControlSelect: script$g,
    FormControlTextarea: script$i,
    FormControlDatetime: script$l,
    StepSummaryGrid: StepSummaryGrid,
    FormInputSwitch: script$m,
    Form: Form,
    Captcha: script$2
  },
  setup: function setup(props, context) {
    var _useFormInputDependen = useFormInputDependency(),
        insertSubmitButtonOnFormAndExecute = _useFormInputDependen.insertSubmitButtonOnFormAndExecute; // +----------------+
    // |   Variables    |
    // +----------------+


    var errorMessage = ref('');
    var captchaInputtedCorrectly = ref(false);
    var privacyAndTerms = reactive({
      privacyAccepted: wizardStore.getState().privacyAccepted,
      termsAccepted: wizardStore.getState().termsAccepted
    });
    var messageIsPublic = ref(false); // +----------------+
    // |   Computed     |
    // +----------------+

    var categoryConfig = computed(function () {
      return {
        overAndUnder: wizardStore.getState().overAndUnderCategory,
        seperator: wizardStore.getState().categorySeparator
      };
    });
    var config = computed(function () {
      return wizardStore.getState().config;
    });
    var mapImageUrl = computed(function () {
      return wizardStore.getMapImageUrl();
    });
    var userEntrys = computed(function () {
      return wizardStore.getState().userEntrys;
    });
    var category = computed(function () {
      return wizardStore.getState().category;
    });
    var captchaConfig = computed(function () {
      var _wizardStore$getState;

      return (_wizardStore$getState = wizardStore.getState().config) === null || _wizardStore$getState === void 0 ? void 0 : _wizardStore$getState.captcha;
    });
    var showEscalateOn = computed(function () {
      var _wizardStore$getState2, _wizardStore$getState3;

      return (_wizardStore$getState2 = wizardStore.getState().config) === null || _wizardStore$getState2 === void 0 ? void 0 : (_wizardStore$getState3 = _wizardStore$getState2.escalateon) === null || _wizardStore$getState3 === void 0 ? void 0 : _wizardStore$getState3.show_escalate_on;
    });
    var canManuallySelectEscalateDate = computed(function () {
      var _wizardStore$getState4, _wizardStore$getState5;

      return (_wizardStore$getState4 = wizardStore.getState().config) === null || _wizardStore$getState4 === void 0 ? void 0 : (_wizardStore$getState5 = _wizardStore$getState4.escalateon) === null || _wizardStore$getState5 === void 0 ? void 0 : _wizardStore$getState5.can_escalate_on_manual;
    });
    var defaultEscalateDate = computed(function () {
      var _wizardStore$getState6, _wizardStore$getState7;

      return (_wizardStore$getState6 = wizardStore.getState().config) === null || _wizardStore$getState6 === void 0 ? void 0 : (_wizardStore$getState7 = _wizardStore$getState6.escalateon) === null || _wizardStore$getState7 === void 0 ? void 0 : _wizardStore$getState7.escalate_date;
    });
    var helpPublicText = computed(function () {
      return 'Vertrauliche Meldungen können nur von der Verwaltung und dem Melder eingesehen werden. Eine Meldung sollte als vertraulich markiert werden, wenn sie persönliche Daten enthält oder nur für interne Zwecke gedacht ist.';
    });
    var responsiblelist = computed(function () {
      var _wizardStore$getState8;

      var list = (_wizardStore$getState8 = wizardStore.getState().config) === null || _wizardStore$getState8 === void 0 ? void 0 : _wizardStore$getState8.responsible.responsible_list;

      if (list) {
        var userlist = list.map(function (element) {
          return {
            text: element.name,
            id: element.id,
            ordering: 1
          };
        });
        userlist.unshift({
          text: "- Zuständigkeit automatisch setzen -",
          id: 0,
          ordering: 1
        });
        return userlist;
      }

      return [];
    });
    var isAdmin = computed(function () {
      return wizardStore.isUserAnAdmin();
    });
    var responsible = ref({
      id: 0,
      private: false,
      comment: ''
    });
    var privacyText = computed(function () {
      var _config$value, _config$value$privacy;

      return "Ich stimme den Datenschutzbedingungen zu. <a href=\"".concat((_config$value = config.value) === null || _config$value === void 0 ? void 0 : (_config$value$privacy = _config$value.privacy) === null || _config$value$privacy === void 0 ? void 0 : _config$value$privacy.privacyUrl, "\" target=\"_blank\">Die Datenschutzbedingungen k\xF6nnen Sie hier einsehen.</a>");
    });
    var termsText = computed(function () {
      var _config$value2, _config$value2$privac;

      return "Ich stimme den Nutzungsbedingungen zu. <a :class=\"labelClassName\" href=".concat((_config$value2 = config.value) === null || _config$value2 === void 0 ? void 0 : (_config$value2$privac = _config$value2.privacy) === null || _config$value2$privac === void 0 ? void 0 : _config$value2$privac.termsUrl, " target=\"_blank\">Die Nutzungsbedingungen k\xF6nnen Sie hier einsehen.</a>");
    });

    function onMessagePrivateSwitched(value) {
      messageIsPublic.value = value;
    }

    function onPrivacyCheckboxChecked(data) {
      privacyAndTerms.privacyAccepted = data.validated;
      wizardStore.setPrivacyAccepted(data.validated);
    }

    function onTermsCheckboxChecked(data) {
      privacyAndTerms.termsAccepted = data.validated;
      wizardStore.setTermsAccepted(data.validated);
    }

    function onCaptchaEntered(data) {
      if (isAdmin.value) {
        captchaInputtedCorrectly.value = true;
      } else {
        captchaInputtedCorrectly.value = data.valid;
      }
    }

    function formatAttributeGroup(attributeGroup) {
      if (attributeGroup === undefined || attributeGroup === null || attributeGroup === '') return 'Sonstiges';
      return attributeGroup;
    }

    var combinedGroupedFields = computed(function () {
      var ret = {
        Meldungsdetails: [{
          value: userEntrys.value.description,
          label: 'Beschreibung'
        }]
      };
      var userFormEntrys = userEntrys.value.attribute_values;
      if (userFormEntrys) Object.keys(userFormEntrys).forEach(function (key) {
        var _category$value;

        var attribute = (_category$value = category.value) === null || _category$value === void 0 ? void 0 : _category$value.attributes.find(function (attribute) {
          return "attribute-" + attribute.id == key;
        });

        if (attribute) {
          var group = formatAttributeGroup(attribute.group);
          var value = attribute.type !== 'valuelist' ? userFormEntrys[key] : // If the form is a ValueList we have a id or an Array of id. But we want to show the text
          attribute.values.filter(function (attributeOptions) {
            var userSelection = Array.isArray(userFormEntrys[key]) ? userFormEntrys[key] : [userFormEntrys[key]];
            return userSelection === null || userSelection === void 0 ? void 0 : userSelection.includes(String(attributeOptions.id));
          }).map(function (e) {
            return ' ' + e.text;
          }).toString();
          ret[group] = (ret[group] || []).concat({
            value: value,
            label: attribute.name
          });
        }
      });
      return ret;
    }); // +----------------+
    // |   Functions    |
    // +----------------+

    function responsibleSelected(value) {
      responsible.value.id = value.value;
    }

    function createAndUploadMessage(values) {
      var _store$category, _userEntrys$value$add, _userEntrys$value$exp, _category$value2;

      var data = {};
      var store = wizardStore.getState();

      if ((_store$category = store.category) !== null && _store$category !== void 0 && _store$category.id) {
        data.typeid = userEntrys.value.typeid;
      }

      if (userEntrys.value.lat && userEntrys.value.lon) {
        data.lat = userEntrys.value.lat;
        data.lon = userEntrys.value.lon;
      }

      if ((_userEntrys$value$add = userEntrys.value.addressSearch) !== null && _userEntrys$value$add !== void 0 && _userEntrys$value$add.queryAddress) {
        var _userEntrys$value$add2;

        data.search = (_userEntrys$value$add2 = userEntrys.value.addressSearch) === null || _userEntrys$value$add2 === void 0 ? void 0 : _userEntrys$value$add2.queryAddress;
      }

      if (userEntrys.value.link) {
        data.attach_link = userEntrys.value.link;
      }

      if (userEntrys.value.link_title) {
        data.attach_link_title = userEntrys.value.link_title;
      }

      if (userEntrys.value.title) {
        data.title = userEntrys.value.title;
      }

      if (userEntrys.value.description) {
        data.description = userEntrys.value.description;
      } //Attributes


      if (userEntrys.value.attribute_values && Object.keys(userEntrys.value.attribute_values).length > 0) {
        data.attribute_values = {};
        var attributeValues = userEntrys.value.attribute_values;

        for (var _key in attributeValues) {
          var attribute = attributeValues[_key];

          if (Array.isArray(attribute)) {
            data.attribute_values[_key] = attribute;
          } else {
            data.attribute_values[_key] = [attribute];
          }
        }
      } // Attachments


      if ((_userEntrys$value$exp = userEntrys.value.expected_files) !== null && _userEntrys$value$exp !== void 0 && _userEntrys$value$exp.length) {
        data.bundle_token = userEntrys.value.bundle_token;
        data.expected_filenames = userEntrys.value.expected_files.map(function (ele) {
          return ele.filename;
        });
      } // Responsible user


      if (values.responsibility) {
        data.responsibleid = Array.isArray(values.responsibility) ? values.responsibility[0] : values.responsibility;
      } // message visibility (only for admin)


      if (((_category$value2 = category.value) === null || _category$value2 === void 0 ? void 0 : _category$value2.message_visibility) != 'never' && isAdmin.value) {
        data.private = messageIsPublic.value ? 0 : 1;
      } // Comment


      values.comment ? data.comment = values.comment : ''; // console.log(values);
      // escalate on (only the date is required)

      if (values.escalateon) {
        data.escalateon = values.escalateon.toISOString().split("T")[0];
      } // remove empty attributes


      function cleanAttributes(data) {
        var cleanedAttributes = {};
        Object.entries(data.attribute_values).filter(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              key = _ref2[0],
              value = _ref2[1];

          return key && value.length > 0 && value[0] !== '';
        }).forEach(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              key = _ref4[0],
              value = _ref4[1];

          var newKey = key.replace('attribute-', '');
          cleanedAttributes[newKey] = value;
        });
        return cleanedAttributes;
      } // console.log(data);


      var cleanedAttributeKeys = data.attribute_values ? cleanAttributes(data) : data;
      data.attribute_values = cleanedAttributeKeys; // Post

      console.log("data", data);
      wizardStore.uploadMessage(data).then(function (response) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        }); // console.log('summary submit', response);

        context.emit('returnToOverview', response.id);
      }).catch(function (err) {
        errorMessage.value = 'Die Meldung konnte leider nicht übermittelt werden. Bitte prüfen Sie Ihre Eingaben nochmal.';
        console.error('Unable to submit', err); // console.log(err)
      });
    }

    function submitSummaryForm() {
      insertSubmitButtonOnFormAndExecute("wizardForm");
    }

    function checkFormCompleted() {
      // terms and privacy and captcha if not admin
      return isAdmin.value ? true : privacyAndTerms.privacyAccepted && privacyAndTerms.termsAccepted && (!captchaConfig.value || captchaInputtedCorrectly.value);
    }

    function emitFormSubmission(values) {
      var _config$value3, _config$value4;

      if ( // Admin can just send
      isAdmin.value || // No admin and no captcha required
      !isAdmin.value && !((_config$value3 = config.value) !== null && _config$value3 !== void 0 && _config$value3.captcha) || // Captcha is inputted correctly and user agrees to terms and condition
      values.agreePrivacy && values.agreeTerms && (_config$value4 = config.value) !== null && _config$value4 !== void 0 && _config$value4.captcha && captchaInputtedCorrectly.value) {
        createAndUploadMessage(values);
      }
    }

    onMounted(function () {
      captchaInputtedCorrectly.value = isAdmin.value || false;

      if (isAdmin.value) {
        var _document$getElementB;

        (_document$getElementB = document.getElementById("wdw-form-attr-textarea-comment")) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.focus();
      }
    });
    context.expose({
      submitForm: submitSummaryForm,
      formCompleted: checkFormCompleted
    });
    return {
      combinedGroupedFields: combinedGroupedFields,
      privacyAndTerms: privacyAndTerms,
      userEntrys: userEntrys,
      privacyText: privacyText,
      termsText: termsText,
      helpPublicText: helpPublicText,
      category: category,
      categoryConfig: categoryConfig,
      captchaConfig: captchaConfig,
      mapImageUrl: mapImageUrl,
      responsiblelist: responsiblelist,
      errorMessage: errorMessage,
      isAdmin: isAdmin,
      captchaInputtedCorrectly: captchaInputtedCorrectly,
      showEscalateOn: showEscalateOn,
      canManuallySelectEscalateDate: canManuallySelectEscalateDate,
      defaultEscalateDate: defaultEscalateDate,
      onMessagePrivateSwitched: onMessagePrivateSwitched,
      onCaptchaEntered: onCaptchaEntered,
      onPrivacyCheckboxChecked: onPrivacyCheckboxChecked,
      onTermsCheckboxChecked: onTermsCheckboxChecked,
      emitFormSubmission: emitFormSubmission,
      responsibleSelected: responsibleSelected
    };
  }
};

var _withScopeId$1 = function _withScopeId(n) {
  return pushScopeId("data-v-57b99749"), n = n(), popScopeId(), n;
};

var _hoisted_1$1 = /*#__PURE__*/createTextVNode("Position");

var _hoisted_2$1 = {
  key: 0,
  class: "fst-italic"
};
var _hoisted_3$1 = ["src"];

var _hoisted_4$1 = /*#__PURE__*/createTextVNode("Kategorie");

var _hoisted_5$1 = /*#__PURE__*/_withScopeId$1(function () {
  return /*#__PURE__*/createElementVNode("div", {
    class: "fw-bold mb-1"
  }, "Name", -1);
});

var _hoisted_6$1 = {
  class: "fw-bold mb-1"
};
var _hoisted_7$1 = {
  key: 0
};
var _hoisted_8$1 = {
  key: 1,
  class: "fst-italic"
};

var _hoisted_9$1 = /*#__PURE__*/createTextVNode("Foto/Anhang");

var _hoisted_10$1 = {
  class: "mb-3"
};
var _hoisted_11$1 = {
  key: 0
};
var _hoisted_12$1 = {
  class: "d-flex flex-wrap justify-content-left"
};
var _hoisted_13 = {
  key: 0,
  style: {
    "height": "200px",
    "width": "200px"
  }
};
var _hoisted_14 = ["src"];
var _hoisted_15 = {
  key: 1,
  class: "d-flex flex-column justify-content-around align-items-center",
  style: {
    "height": "200px",
    "width": "200px"
  }
};
var _hoisted_16 = {
  key: 1,
  class: "fst-italic"
};

var _hoisted_17 = /*#__PURE__*/createTextVNode("Datenschutzbedingungen");

var _hoisted_18 = /*#__PURE__*/createTextVNode("Nutzungsbedingungen");

var _hoisted_19 = /*#__PURE__*/createTextVNode("Sicherheitsabfrage");

var _hoisted_20 = /*#__PURE__*/createTextVNode("Fristsetzung");

var _hoisted_21 = /*#__PURE__*/createTextVNode("Zuständigkeit");

var _hoisted_22 = {
  key: 0
};
var _hoisted_23 = {
  key: 0,
  class: "alert alert-danger position-relative",
  "aria-live": "polite"
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_StepSummaryGrid = resolveComponent("StepSummaryGrid");

  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  var _component_form_control_checkbox = resolveComponent("form-control-checkbox");

  var _component_Captcha = resolveComponent("Captcha");

  var _component_FormControlDatetime = resolveComponent("FormControlDatetime");

  var _component_FormControlSelect = resolveComponent("FormControlSelect");

  var _component_FormControlTextarea = resolveComponent("FormControlTextarea");

  var _component_FormInputSwitch = resolveComponent("FormInputSwitch");

  var _component_Form = resolveComponent("Form");

  return openBlock(), createElementBlock(Fragment, null, [createVNode(_component_StepSummaryGrid, null, {
    title: withCtx(function () {
      return [_hoisted_1$1];
    }),
    default: withCtx(function () {
      return [!$setup.mapImageUrl ? (openBlock(), createElementBlock("div", _hoisted_2$1, "Die Meldung hat keine Position.")) : (openBlock(), createElementBlock("img", {
        key: 1,
        src: $setup.mapImageUrl,
        alt: "Vorschau Position",
        class: "img-responsive"
      }, null, 8, _hoisted_3$1))];
    }),
    _: 1
  }), createVNode(_component_StepSummaryGrid, null, {
    title: withCtx(function () {
      return [_hoisted_4$1];
    }),
    default: withCtx(function () {
      var _$setup$category;

      return [_hoisted_5$1, createElementVNode("span", null, toDisplayString((_$setup$category = $setup.category) === null || _$setup$category === void 0 ? void 0 : _$setup$category.name), 1)];
    }),
    _: 1
  }), (openBlock(true), createElementBlock(Fragment, null, renderList($setup.combinedGroupedFields, function (labelAndValues, group) {
    return openBlock(), createBlock(_component_StepSummaryGrid, {
      key: group
    }, {
      title: withCtx(function () {
        return [createTextVNode(toDisplayString(group), 1)];
      }),
      default: withCtx(function () {
        return [(openBlock(true), createElementBlock(Fragment, null, renderList(labelAndValues, function (labelAndValue) {
          return openBlock(), createElementBlock("div", {
            key: labelAndValue.label,
            class: "mb-3"
          }, [createElementVNode("div", _hoisted_6$1, toDisplayString(labelAndValue.label), 1), !!labelAndValue.value && labelAndValue.value !== '' && labelAndValue.value.length !== 0 ? (openBlock(), createElementBlock("div", _hoisted_7$1, toDisplayString(labelAndValue.value), 1)) : (openBlock(), createElementBlock("div", _hoisted_8$1, "Nicht angegeben"))]);
        }), 128))];
      }),
      _: 2
    }, 1024);
  }), 128)), createVNode(_component_StepSummaryGrid, null, {
    title: withCtx(function () {
      return [_hoisted_9$1];
    }),
    default: withCtx(function () {
      return [createElementVNode("div", _hoisted_10$1, [$setup.userEntrys && $setup.userEntrys.expected_files && $setup.userEntrys.expected_files.length !== 0 ? (openBlock(), createElementBlock("div", _hoisted_11$1, [createElementVNode("div", _hoisted_12$1, [(openBlock(true), createElementBlock(Fragment, null, renderList($setup.userEntrys.expected_files, function (file) {
        return openBlock(), createElementBlock("div", {
          key: file.id,
          class: "m-1"
        }, [file.hasImage ? (openBlock(), createElementBlock("div", _hoisted_13, [createElementVNode("img", {
          src: file.url,
          alt: "Photo",
          class: "img-thumbnail",
          style: {
            "height": "100%",
            "object-fit": "cover"
          }
        }, null, 8, _hoisted_14)])) : (openBlock(), createElementBlock("div", _hoisted_15, [createElementVNode("div", null, toDisplayString(file.filename), 1), createVNode(_component_font_awesome_icon, {
          icon: ['fas', 'file'],
          style: {
            "height": "150px",
            "width": "150px"
          }
        })]))]);
      }), 128))])])) : (openBlock(), createElementBlock("div", _hoisted_16, "Nicht angegeben"))])];
    }),
    _: 1
  }), createVNode(_component_Form, {
    onSubmit: $setup.emitFormSubmission,
    onInvalidSubmit: _cache[0] || (_cache[0] = function () {
      return $setup.captchaInputtedCorrectly;
    }),
    id: "wizardForm"
  }, {
    default: withCtx(function () {
      return [!$setup.isAdmin ? (openBlock(), createElementBlock(Fragment, {
        key: 0
      }, [createVNode(_component_StepSummaryGrid, null, {
        title: withCtx(function () {
          return [_hoisted_17];
        }),
        default: withCtx(function () {
          return [createVNode(_component_form_control_checkbox, {
            label: $setup.privacyText,
            defaultvalue: $setup.privacyAndTerms.privacyAccepted,
            name: "agreePrivacy",
            error: "Bitte stimmen Sie den Datenschutzbedingungen zu. Ohne Ihre Zustimmung kann die Meldung nicht abgesendet werden.",
            required: true,
            onValidate: $setup.onPrivacyCheckboxChecked
          }, null, 8, ["label", "defaultvalue", "onValidate"])];
        }),
        _: 1
      }), createVNode(_component_StepSummaryGrid, null, {
        title: withCtx(function () {
          return [_hoisted_18];
        }),
        default: withCtx(function () {
          return [createVNode(_component_form_control_checkbox, {
            label: $setup.termsText,
            defaultvalue: $setup.privacyAndTerms.termsAccepted,
            name: "agreeTerms",
            error: "Bitte stimmen Sie den Nutzungsbedingungen zu. Ohne Ihre Zustimmung kann die Meldung nicht abgesendet werden.",
            required: true,
            onValidate: $setup.onTermsCheckboxChecked
          }, null, 8, ["label", "defaultvalue", "onValidate"])];
        }),
        _: 1
      })], 64)) : createCommentVNode("", true), $setup.captchaConfig !== undefined && !$setup.isAdmin ? (openBlock(), createBlock(_component_StepSummaryGrid, {
        key: 1
      }, {
        title: withCtx(function () {
          return [_hoisted_19];
        }),
        default: withCtx(function () {
          return [createVNode(_component_Captcha, {
            ref: "captcha",
            captcha: $setup.captchaConfig,
            onCaptchaEntered: $setup.onCaptchaEntered
          }, null, 8, ["captcha", "onCaptchaEntered"])];
        }),
        _: 1
      })) : createCommentVNode("", true), $setup.showEscalateOn && $setup.canManuallySelectEscalateDate ? (openBlock(), createBlock(_component_StepSummaryGrid, {
        key: 2
      }, {
        title: withCtx(function () {
          return [_hoisted_20];
        }),
        default: withCtx(function () {
          return [createElementVNode("div", null, [createVNode(_component_FormControlDatetime, {
            name: "escalateon",
            label: "Frist setzen (leer für Dauerticket)",
            required: false,
            placeholder: "Datum wählen",
            defaultvalue: $setup.defaultEscalateDate,
            showButtonBar: true,
            "date-format": "yy-mm-dd"
          }, null, 8, ["defaultvalue"])])];
        }),
        _: 1
      })) : createCommentVNode("", true), $setup.isAdmin ? (openBlock(), createBlock(_component_StepSummaryGrid, {
        key: 3
      }, {
        title: withCtx(function () {
          return [_hoisted_21];
        }),
        default: withCtx(function () {
          var _$setup$category2;

          return [createElementVNode("div", null, [createVNode(_component_FormControlSelect, {
            class: "mb-2",
            label: "Zuständiger Bearbeiter",
            name: "responsibility",
            defaultvalue: [0],
            required: false,
            options: $setup.responsiblelist,
            typeable: true,
            onSelected: $setup.responsibleSelected
          }, null, 8, ["options", "onSelected"]), createVNode(_component_FormControlTextarea, {
            class: "mb-2",
            name: "comment",
            label: "Öffentlicher Kommentar für den Bürger",
            isPublic: true
          }), ((_$setup$category2 = $setup.category) === null || _$setup$category2 === void 0 ? void 0 : _$setup$category2.message_visibility) != 'never' ? (openBlock(), createElementBlock("div", _hoisted_22, [createVNode(_component_FormInputSwitch, {
            inputSwitchId: "btn-switch-message-private",
            labelposition: "right",
            defaultvalue: false,
            options: [{
              value: 0,
              description: 'Meldung ist versteckt'
            }, {
              value: 1,
              description: 'Meldung ist öffentlich'
            }],
            onEmitSwitch: $setup.onMessagePrivateSwitched
          }, null, 8, ["onEmitSwitch"])])) : createCommentVNode("", true)])];
        }),
        _: 1
      })) : createCommentVNode("", true)];
    }),
    _: 1
  }, 8, ["onSubmit"]), $setup.errorMessage ? (openBlock(), createElementBlock("div", _hoisted_23, toDisplayString($setup.errorMessage), 1)) : createCommentVNode("", true)], 64);
}

script$1.render = render$1;
script$1.__scopeId = "data-v-57b99749";

library.add(faArrowLeft, faArrowRight);
var script = {
  name: "BmsWizard",
  props: {
    domainid: {
      type: Number,
      required: true
    },
    user: {
      type: Object,
      required: false,
      default: undefined
    },
    userAuthToken: {
      type: String,
      required: false,
      default: undefined
    },
    showBackButton: {
      type: Boolean,
      required: false,
      default: false
    },
    backButtonText: {
      type: String,
      required: false,
      default: "zurück zur Übersicht"
    },
    redirectOnMessageCreated: {
      // redirectOnMessageCreated (STRING, OPTIONAL) -> URL for redirect after creating message
      type: String,
      required: false,
      default: ''
    },
    redirectOnMessageCreatedWithMessageid: {
      // redirectOnMessageCreatedWithMessageid (STRING, OPTIONAL) -> URL for redirect after creating message if messageid is known
      type: String,
      required: false,
      default: ''
    },
    redirectOnCancel: {
      // redirectOnCancel (STRING, OPTIONAL) -> URL for redirect after cancelling process
      type: String,
      required: false,
      default: ''
    },
    apiBaseUrl: {
      // Baseurl for API calls
      type: String,
      required: false,
      default: "/"
    },
    selectedtypeid: {
      // Pre-selected typeid
      type: Number,
      required: false,
      default: 0
    },
    initialLatitude: {
      type: Number,
      required: false,
      default: 0
    },
    initialLongitude: {
      type: Number,
      required: false,
      default: 0
    },
    selectedRubric: {
      // Pre-selected rubric
      type: String,
      required: false,
      default: ""
    },
    filtertypeids: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    }
  },
  emits: ['onMessageCreated', 'onBack'],
  components: {
    WizardStepPosition: script$9,
    WizardStepCategory: script$6,
    WizardStepFields: script$4,
    WizardStepSummary: script$1,
    WizardDuplicates: script$c,
    WizardProgress: script$e,
    Loading: script$f
  },
  setup: function setup(props, context) {
    var readyForNextStep = ref(false);
    var currentComponentRef = ref();
    var components = {
      position: script$9,
      category: script$6,
      attributes: script$4,
      summary: script$1
    };

    var _useWizardAccessibili = useWizardAccessibility(),
        focusStartOfStep = _useWizardAccessibili.focusStartOfStep,
        focusNextButton = _useWizardAccessibili.focusNextButton,
        observeSelect2SearchField = _useWizardAccessibili.observeSelect2SearchField,
        destroySelect2Observer = _useWizardAccessibili.destroySelect2Observer; // +----------------+
    // |    Computed    |
    // +----------------+


    var currentstep = computed(function () {
      return wizardStore.getState().currentStep;
    });
    var submitting = computed(function () {
      return wizardStore.getState().submitting;
    });
    var loading = computed(function () {
      return wizardStore.getState().loading;
    });
    var config = computed(function () {
      return wizardStore.getState().config;
    });
    var sortedArray = computed(function () {
      return wizardStore.getState().currentStepdata;
    });
    var currentComponent = computed(function () {
      var _sortedArray$value;

      return components[(_sortedArray$value = sortedArray.value) === null || _sortedArray$value === void 0 ? void 0 : _sortedArray$value.code];
    });
    var currentComponentHasForm = computed(function () {
      var _currentComponentRef$;

      return !!((_currentComponentRef$ = currentComponentRef.value) !== null && _currentComponentRef$ !== void 0 && _currentComponentRef$.submitForm);
    });
    var currentComponentHasCompletedForm = computed(function () {
      var _currentComponentRef$2;

      return !!((_currentComponentRef$2 = currentComponentRef.value) !== null && _currentComponentRef$2 !== void 0 && _currentComponentRef$2.formCompleted());
    });
    var lastStep = computed(function () {
      var _wizardStore$getState;

      return currentstep.value === ((_wizardStore$getState = wizardStore.getState().config) === null || _wizardStore$getState === void 0 ? void 0 : _wizardStore$getState.steps.length);
    });
    /**
     *  For steps with form (summary and fields), the component needs to expose `submitForm` and `formCompleted` method
     *  1. submitForm() submits the form with all the entered values. 
     *      To move to the next step, you have to emit("selection", data) in this method
     *  2. formCompleted() returns true or false. If true, the "next" button will be enabled. Disabled otherwise. 
     *      This is where you check if the form is completed or not
     * 
     *  See the example in WizardStepFields.vue
    */

    var nextButtonDisabled = computed(function () {
      return (// User needs to do something on this step without form
        !currentComponentHasForm.value && !readyForNextStep.value // Form exists and user has to fill in the form completely first 
        || currentComponentHasForm.value && !currentComponentHasCompletedForm.value // it is submitting
        || submitting.value // it is loading 
        || loading.value
      );
    });
    var prevButtonDisabled = computed(function () {
      return currentstep.value <= 1 || submitting.value || loading.value;
    }); // +----------------+
    // |   Functions    |
    // +----------------+

    function beforeUnloadHandler() {
      return 'stop page redirect';
    }

    function removeAttributeIdFromLocalStorage() {
      var _wizardStore$getState2;

      (_wizardStore$getState2 = wizardStore.getState().category) === null || _wizardStore$getState2 === void 0 ? void 0 : _wizardStore$getState2.attributeids.forEach(function (id) {
        localStorage.removeItem(id.toString());
      });
    }

    function toggleCreateMessage(messageid) {
      // Disable page leave warning
      window.onbeforeunload = function () {
        return null;
      };

      if (messageid) {
        // Messageid is known (usually admin created messages)
        if (props.redirectOnMessageCreatedWithMessageid != '') {
          var redirUrl = props.redirectOnMessageCreatedWithMessageid.replace('{messageid}', messageid.toString());
          window.location.href = redirUrl;
        } else {
          context.emit('onMessageCreated', messageid);
        }
      } else {
        // messageid is not known (usually user created)
        if (props.redirectOnMessageCreated != '') {
          window.location.href = props.redirectOnMessageCreated;
        } else {
          context.emit('onMessageCreated', undefined);
        }
      }

      removeAttributeIdFromLocalStorage();
      wizardStore.resetMessageWizard();
    }

    function onBack() {
      var confirmLeave = window.confirm('Wollen Sie wirklich die Meldungs-Erstellung abbrechen?');

      if (!confirmLeave) {
        return;
      }

      removeAttributeIdFromLocalStorage();
      wizardStore.resetMessageWizard();

      if (props.redirectOnCancel && props.redirectOnCancel !== '') {
        window.location.href = props.redirectOnCancel;
      } else {
        context.emit('onBack');
      }
    }

    function nextStep() {
      if (!currentComponentHasForm.value) {
        wizardStore.nextStep();
        readyForNextStep.value = false;
      } else {
        var _currentComponentRef$3;

        // submit form instead of nextStep if page has a form. If successfully submitted, 'selection' is emitted
        (_currentComponentRef$3 = currentComponentRef.value) === null || _currentComponentRef$3 === void 0 ? void 0 : _currentComponentRef$3.submitForm();
      }

      if (!lastStep.value) {
        nextTick(function () {
          return focusStartOfStep();
        });
      }
    }

    function previousStep() {
      wizardStore.previousStep();
      nextTick(function () {
        return focusStartOfStep();
      });
    }

    function selectionMade() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      readyForNextStep.value = value; // If category is selected from search, automatically go to next step
      // if we have pre-selected category, also skip the WizardStepCategory step

      if (currentComponentHasForm.value || source == "category_selected_from_search" || currentComponent.value == script$6 && props.selectedtypeid > 0) {
        wizardStore.nextStep();
        readyForNextStep.value = false;
      } else {
        // Focus to next button
        nextTick(function () {
          return focusNextButton();
        });
      }
    } // Pass logged-in user info to store


    watch(function () {
      return props.user;
    }, function (nv) {
      if (nv) {
        wizardStore.setLoggedInUser(nv);
      }
    });
    watch(function () {
      return props.userAuthToken;
    }, function (nv) {
      if (nv) {
        wizardStore.setUserAuthToken(nv);
      }
    }); // +----------------+
    // |   Lifecycle    |
    // +----------------+

    onBeforeMount(function () {
      domainStore.setDomainId(props.domainid);
      wizardStore.setApiBaseUrl(props.apiBaseUrl);

      if (props.user) {
        wizardStore.setLoggedInUser(props.user);
      }

      if (props.userAuthToken) {
        wizardStore.setUserAuthToken(props.userAuthToken);
      }
    });
    onMounted(function () {
      window.onbeforeunload = beforeUnloadHandler;
      wizardStore.setInitialParams({
        selectedRubric: props.selectedRubric,
        selectedTypeId: props.selectedtypeid,
        filterTypeIds: props.filtertypeids,
        initialLat: props.initialLatitude,
        initialLon: props.initialLongitude
      });
      fetchDomainConfig().finally(function () {
        wizardStore.getWizardConfig().then(function () {
          nextTick(function () {
            return focusStartOfStep();
          });
        });
      });
      observeSelect2SearchField();
    });
    onUnmounted(function () {
      localStorage.removeItem('position');
      removeAttributeIdFromLocalStorage();
      destroySelect2Observer();
    });
    onBeforeUnmount(function () {
      window.onbeforeunload = null; // Remove the event listener when component is unmounted
    });
    return {
      config: config,
      currentstep: currentstep,
      sortedArray: sortedArray,
      currentComponentRef: currentComponentRef,
      currentComponent: currentComponent,
      currentComponentHasForm: currentComponentHasForm,
      currentComponentHasCompletedForm: currentComponentHasCompletedForm,
      lastStep: lastStep,
      prevButtonDisabled: prevButtonDisabled,
      nextButtonDisabled: nextButtonDisabled,
      loading: loading,
      readyForNextStep: readyForNextStep,
      selectionMade: selectionMade,
      nextStep: nextStep,
      previousStep: previousStep,
      onBack: onBack,
      toggleCreateMessage: toggleCreateMessage
    };
  }
};

var _withScopeId = function _withScopeId(n) {
  return pushScopeId("data-v-52d7c9a8"), n = n(), popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  id: "wizard-bms-widget",
  class: "row p-3 mb-2"
};
var _hoisted_2 = {
  class: "mb-3 wizard-panel"
};
var _hoisted_3 = {
  class: "col-xl-8",
  style: {
    "padding-left": "0px"
  }
};
var _hoisted_4 = {
  class: "wizard-panel"
};
var _hoisted_5 = {
  id: "wizard-step-title",
  class: "step-title"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/createElementVNode("hr", null, null, -1);
});

var _hoisted_7 = {
  key: 0,
  id: "wdw-bms-wizard-hint-text",
  tabindex: "0",
  class: "alert alert-info"
};
var _hoisted_8 = {
  class: "mt-3 d-flex justify-content-end"
};
var _hoisted_9 = ["disabled"];

var _hoisted_10 = /*#__PURE__*/createTextVNode(" Zurück ");

var _hoisted_11 = ["aria-label", "disabled"];
var _hoisted_12 = {
  key: 1,
  class: "wizard-panel d-flex justify-content-center"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _$setup$sortedArray, _$setup$sortedArray2;

  var _component_WizardProgress = resolveComponent("WizardProgress");

  var _component_font_awesome_icon = resolveComponent("font-awesome-icon");

  var _component_Loading = resolveComponent("Loading");

  var _component_WizardDuplicates = resolveComponent("WizardDuplicates");

  var _directive_dompurify_html = resolveDirective("dompurify-html");

  return openBlock(), createElementBlock("div", null, [$setup.config ? (openBlock(), createElementBlock("div", _hoisted_1, [createElementVNode("div", _hoisted_2, [createVNode(_component_WizardProgress)]), createElementVNode("div", _hoisted_3, [createElementVNode("div", _hoisted_4, [createElementVNode("p", _hoisted_5, "Schritt " + toDisplayString($setup.currentstep) + ": " + toDisplayString((_$setup$sortedArray = $setup.sortedArray) === null || _$setup$sortedArray === void 0 ? void 0 : _$setup$sortedArray.label), 1), _hoisted_6, (_$setup$sortedArray2 = $setup.sortedArray) !== null && _$setup$sortedArray2 !== void 0 && _$setup$sortedArray2.hint_text ? withDirectives((openBlock(), createElementBlock("div", _hoisted_7, null, 512)), [[_directive_dompurify_html, $setup.sortedArray.hint_text]]) : createCommentVNode("", true), (openBlock(), createBlock(resolveDynamicComponent($setup.currentComponent), {
    ref: "currentComponentRef",
    onSelection: $setup.selectionMade,
    onNextStep: _cache[0] || (_cache[0] = function ($event) {
      return $setup.nextStep();
    }),
    onReturnToOverview: $setup.toggleCreateMessage
  }, null, 8, ["onSelection", "onReturnToOverview"]))]), createElementVNode("div", _hoisted_8, [createElementVNode("button", {
    "aria-label": "Zurück",
    class: "btn btn-primary navigation-buttons me-2 align-items-center d-flex gap-2",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $setup.previousStep();
    }),
    disabled: $setup.prevButtonDisabled
  }, [createVNode(_component_font_awesome_icon, {
    icon: "arrow-left"
  }), _hoisted_10], 8, _hoisted_9), createElementVNode("button", {
    id: "bms-wizard-btn-next",
    "aria-label": !$setup.lastStep ? 'Weiter' : 'Meldung abschicken',
    class: "btn btn-primary align-items-center d-flex gap-2",
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return $setup.nextStep();
    }),
    disabled: $setup.nextButtonDisabled
  }, [createTextVNode(toDisplayString(!$setup.lastStep ? 'Weiter' : 'Meldung abschicken') + " ", 1), !$setup.loading ? (openBlock(), createBlock(_component_font_awesome_icon, {
    key: 0,
    icon: "arrow-right"
  })) : (openBlock(), createBlock(_component_Loading, {
    key: 1
  }))], 8, _hoisted_11)])]), createVNode(_component_WizardDuplicates, {
    class: "wizard-panel col-xl-4 mt-5 mt-xl-0"
  })])) : (openBlock(), createElementBlock("div", _hoisted_12, [createVNode(_component_Loading, {
    spinnerStyle: "width: 100px; height: 100px;"
  })])), $props.showBackButton ? (openBlock(), createElementBlock("button", {
    key: 2,
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return $setup.onBack();
    }),
    class: "btn btn-primary"
  }, toDisplayString($props.backButtonText), 1)) : createCommentVNode("", true)]);
}

script.render = render;
script.__scopeId = "data-v-52d7c9a8";

var Plugin = {
  install: function install(vue) {
    registerComponent(vue, script);
  }
}; // use(Plugin);

export { script as BmsWizard, Plugin as default };
